import _regeneratorRuntime from "/Users/kations/Projekte/Spicy/spicy-next/node_modules/@babel/runtime/regenerator";
import "core-js/modules/es6.date.to-iso-string";
import "core-js/modules/es6.date.to-json";
import "core-js/modules/es6.regexp.replace";
import "core-js/modules/es6.array.find";
import "core-js/modules/es6.array.reduce";
import "core-js/modules/es6.array.find-index";
import "core-js/modules/es6.function.bind";
import "core-js/modules/es6.date.now";
import "core-js/modules/es6.map";
import "core-js/modules/es6.array.filter";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";
import "core-js/modules/es6.object.set-prototype-of";
import "core-js/modules/es6.object.create";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.promise";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/es6.number.constructor";
import "core-js/modules/es6.object.freeze";
import "core-js/modules/es6.array.index-of";
import "core-js/modules/es6.array.sort";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.regexp.split";
import "core-js/modules/es6.array.map";
import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.date.to-string";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.regexp.match";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.array.is-array";
import * as reactNative from 'react-native';
import { Dimensions, Platform, Image, TouchableOpacity, View, ScrollView, SafeAreaView, FlatList, createElement, DatePickerAndroid, TimePickerAndroid, DatePickerIOS, Text, Picker, PanResponder } from 'react-native';
import React__default, { useContext, useState, Fragment, useEffect, Component, Children, useRef, createElement as createElement$1 } from 'react';
import scStyled, { ThemeContext, withTheme, ThemeProvider } from 'styled-components/native';
export { withTheme } from 'styled-components/native';
import PropTypes__default, { node, func, number, string, object, bool, oneOfType, element } from 'prop-types';
import { useSpring, animated, useTransition, config } from 'react-spring/native';
import Svg, { Path, G } from 'swgs';
import { useTransition as useTransition$1, animated as animated$1 } from 'react-spring';
var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function createCommonjsModule(fn, module) {
  return module = {
    exports: {}
  }, fn(module, module.exports), module.exports;
}

var colorName = {
  "aliceblue": [240, 248, 255],
  "antiquewhite": [250, 235, 215],
  "aqua": [0, 255, 255],
  "aquamarine": [127, 255, 212],
  "azure": [240, 255, 255],
  "beige": [245, 245, 220],
  "bisque": [255, 228, 196],
  "black": [0, 0, 0],
  "blanchedalmond": [255, 235, 205],
  "blue": [0, 0, 255],
  "blueviolet": [138, 43, 226],
  "brown": [165, 42, 42],
  "burlywood": [222, 184, 135],
  "cadetblue": [95, 158, 160],
  "chartreuse": [127, 255, 0],
  "chocolate": [210, 105, 30],
  "coral": [255, 127, 80],
  "cornflowerblue": [100, 149, 237],
  "cornsilk": [255, 248, 220],
  "crimson": [220, 20, 60],
  "cyan": [0, 255, 255],
  "darkblue": [0, 0, 139],
  "darkcyan": [0, 139, 139],
  "darkgoldenrod": [184, 134, 11],
  "darkgray": [169, 169, 169],
  "darkgreen": [0, 100, 0],
  "darkgrey": [169, 169, 169],
  "darkkhaki": [189, 183, 107],
  "darkmagenta": [139, 0, 139],
  "darkolivegreen": [85, 107, 47],
  "darkorange": [255, 140, 0],
  "darkorchid": [153, 50, 204],
  "darkred": [139, 0, 0],
  "darksalmon": [233, 150, 122],
  "darkseagreen": [143, 188, 143],
  "darkslateblue": [72, 61, 139],
  "darkslategray": [47, 79, 79],
  "darkslategrey": [47, 79, 79],
  "darkturquoise": [0, 206, 209],
  "darkviolet": [148, 0, 211],
  "deeppink": [255, 20, 147],
  "deepskyblue": [0, 191, 255],
  "dimgray": [105, 105, 105],
  "dimgrey": [105, 105, 105],
  "dodgerblue": [30, 144, 255],
  "firebrick": [178, 34, 34],
  "floralwhite": [255, 250, 240],
  "forestgreen": [34, 139, 34],
  "fuchsia": [255, 0, 255],
  "gainsboro": [220, 220, 220],
  "ghostwhite": [248, 248, 255],
  "gold": [255, 215, 0],
  "goldenrod": [218, 165, 32],
  "gray": [128, 128, 128],
  "green": [0, 128, 0],
  "greenyellow": [173, 255, 47],
  "grey": [128, 128, 128],
  "honeydew": [240, 255, 240],
  "hotpink": [255, 105, 180],
  "indianred": [205, 92, 92],
  "indigo": [75, 0, 130],
  "ivory": [255, 255, 240],
  "khaki": [240, 230, 140],
  "lavender": [230, 230, 250],
  "lavenderblush": [255, 240, 245],
  "lawngreen": [124, 252, 0],
  "lemonchiffon": [255, 250, 205],
  "lightblue": [173, 216, 230],
  "lightcoral": [240, 128, 128],
  "lightcyan": [224, 255, 255],
  "lightgoldenrodyellow": [250, 250, 210],
  "lightgray": [211, 211, 211],
  "lightgreen": [144, 238, 144],
  "lightgrey": [211, 211, 211],
  "lightpink": [255, 182, 193],
  "lightsalmon": [255, 160, 122],
  "lightseagreen": [32, 178, 170],
  "lightskyblue": [135, 206, 250],
  "lightslategray": [119, 136, 153],
  "lightslategrey": [119, 136, 153],
  "lightsteelblue": [176, 196, 222],
  "lightyellow": [255, 255, 224],
  "lime": [0, 255, 0],
  "limegreen": [50, 205, 50],
  "linen": [250, 240, 230],
  "magenta": [255, 0, 255],
  "maroon": [128, 0, 0],
  "mediumaquamarine": [102, 205, 170],
  "mediumblue": [0, 0, 205],
  "mediumorchid": [186, 85, 211],
  "mediumpurple": [147, 112, 219],
  "mediumseagreen": [60, 179, 113],
  "mediumslateblue": [123, 104, 238],
  "mediumspringgreen": [0, 250, 154],
  "mediumturquoise": [72, 209, 204],
  "mediumvioletred": [199, 21, 133],
  "midnightblue": [25, 25, 112],
  "mintcream": [245, 255, 250],
  "mistyrose": [255, 228, 225],
  "moccasin": [255, 228, 181],
  "navajowhite": [255, 222, 173],
  "navy": [0, 0, 128],
  "oldlace": [253, 245, 230],
  "olive": [128, 128, 0],
  "olivedrab": [107, 142, 35],
  "orange": [255, 165, 0],
  "orangered": [255, 69, 0],
  "orchid": [218, 112, 214],
  "palegoldenrod": [238, 232, 170],
  "palegreen": [152, 251, 152],
  "paleturquoise": [175, 238, 238],
  "palevioletred": [219, 112, 147],
  "papayawhip": [255, 239, 213],
  "peachpuff": [255, 218, 185],
  "peru": [205, 133, 63],
  "pink": [255, 192, 203],
  "plum": [221, 160, 221],
  "powderblue": [176, 224, 230],
  "purple": [128, 0, 128],
  "rebeccapurple": [102, 51, 153],
  "red": [255, 0, 0],
  "rosybrown": [188, 143, 143],
  "royalblue": [65, 105, 225],
  "saddlebrown": [139, 69, 19],
  "salmon": [250, 128, 114],
  "sandybrown": [244, 164, 96],
  "seagreen": [46, 139, 87],
  "seashell": [255, 245, 238],
  "sienna": [160, 82, 45],
  "silver": [192, 192, 192],
  "skyblue": [135, 206, 235],
  "slateblue": [106, 90, 205],
  "slategray": [112, 128, 144],
  "slategrey": [112, 128, 144],
  "snow": [255, 250, 250],
  "springgreen": [0, 255, 127],
  "steelblue": [70, 130, 180],
  "tan": [210, 180, 140],
  "teal": [0, 128, 128],
  "thistle": [216, 191, 216],
  "tomato": [255, 99, 71],
  "turquoise": [64, 224, 208],
  "violet": [238, 130, 238],
  "wheat": [245, 222, 179],
  "white": [255, 255, 255],
  "whitesmoke": [245, 245, 245],
  "yellow": [255, 255, 0],
  "yellowgreen": [154, 205, 50]
};

var isArrayish = function isArrayish(obj) {
  if (!obj || typeof obj === 'string') {
    return false;
  }

  return obj instanceof Array || Array.isArray(obj) || obj.length >= 0 && (obj.splice instanceof Function || Object.getOwnPropertyDescriptor(obj, obj.length - 1) && obj.constructor.name !== 'String');
};

var simpleSwizzle = createCommonjsModule(function (module) {
  var concat = Array.prototype.concat;
  var slice = Array.prototype.slice;

  var swizzle = module.exports = function swizzle(args) {
    var results = [];

    for (var i = 0, len = args.length; i < len; i++) {
      var arg = args[i];

      if (isArrayish(arg)) {
        // http://jsperf.com/javascript-array-concat-vs-push/98
        results = concat.call(results, slice.call(arg));
      } else {
        results.push(arg);
      }
    }

    return results;
  };

  swizzle.wrap = function (fn) {
    return function () {
      return fn(swizzle(arguments));
    };
  };
});
var colorString = createCommonjsModule(function (module) {
  /* MIT license */
  var reverseNames = {}; // create a list of reverse color names

  for (var name in colorName) {
    if (colorName.hasOwnProperty(name)) {
      reverseNames[colorName[name]] = name;
    }
  }

  var cs = module.exports = {
    to: {},
    get: {}
  };

  cs.get = function (string$$1) {
    var prefix = string$$1.substring(0, 3).toLowerCase();
    var val;
    var model;

    switch (prefix) {
      case 'hsl':
        val = cs.get.hsl(string$$1);
        model = 'hsl';
        break;

      case 'hwb':
        val = cs.get.hwb(string$$1);
        model = 'hwb';
        break;

      default:
        val = cs.get.rgb(string$$1);
        model = 'rgb';
        break;
    }

    if (!val) {
      return null;
    }

    return {
      model: model,
      value: val
    };
  };

  cs.get.rgb = function (string$$1) {
    if (!string$$1) {
      return null;
    }

    var abbr = /^#([a-f0-9]{3,4})$/i;
    var hex = /^#([a-f0-9]{6})([a-f0-9]{2})?$/i;
    var rgba = /^rgba?\(\s*([+-]?\d+)\s*,\s*([+-]?\d+)\s*,\s*([+-]?\d+)\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)$/;
    var per = /^rgba?\(\s*([+-]?[\d\.]+)\%\s*,\s*([+-]?[\d\.]+)\%\s*,\s*([+-]?[\d\.]+)\%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)$/;
    var keyword = /(\D+)/;
    var rgb = [0, 0, 0, 1];
    var match;
    var i;
    var hexAlpha;

    if (match = string$$1.match(hex)) {
      hexAlpha = match[2];
      match = match[1];

      for (i = 0; i < 3; i++) {
        // https://jsperf.com/slice-vs-substr-vs-substring-methods-long-string/19
        var i2 = i * 2;
        rgb[i] = parseInt(match.slice(i2, i2 + 2), 16);
      }

      if (hexAlpha) {
        rgb[3] = Math.round(parseInt(hexAlpha, 16) / 255 * 100) / 100;
      }
    } else if (match = string$$1.match(abbr)) {
      match = match[1];
      hexAlpha = match[3];

      for (i = 0; i < 3; i++) {
        rgb[i] = parseInt(match[i] + match[i], 16);
      }

      if (hexAlpha) {
        rgb[3] = Math.round(parseInt(hexAlpha + hexAlpha, 16) / 255 * 100) / 100;
      }
    } else if (match = string$$1.match(rgba)) {
      for (i = 0; i < 3; i++) {
        rgb[i] = parseInt(match[i + 1], 0);
      }

      if (match[4]) {
        rgb[3] = parseFloat(match[4]);
      }
    } else if (match = string$$1.match(per)) {
      for (i = 0; i < 3; i++) {
        rgb[i] = Math.round(parseFloat(match[i + 1]) * 2.55);
      }

      if (match[4]) {
        rgb[3] = parseFloat(match[4]);
      }
    } else if (match = string$$1.match(keyword)) {
      if (match[1] === 'transparent') {
        return [0, 0, 0, 0];
      }

      rgb = colorName[match[1]];

      if (!rgb) {
        return null;
      }

      rgb[3] = 1;
      return rgb;
    } else {
      return null;
    }

    for (i = 0; i < 3; i++) {
      rgb[i] = clamp(rgb[i], 0, 255);
    }

    rgb[3] = clamp(rgb[3], 0, 1);
    return rgb;
  };

  cs.get.hsl = function (string$$1) {
    if (!string$$1) {
      return null;
    }

    var hsl = /^hsla?\(\s*([+-]?(?:\d*\.)?\d+)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)$/;
    var match = string$$1.match(hsl);

    if (match) {
      var alpha = parseFloat(match[4]);
      var h = (parseFloat(match[1]) + 360) % 360;
      var s = clamp(parseFloat(match[2]), 0, 100);
      var l = clamp(parseFloat(match[3]), 0, 100);
      var a = clamp(isNaN(alpha) ? 1 : alpha, 0, 1);
      return [h, s, l, a];
    }

    return null;
  };

  cs.get.hwb = function (string$$1) {
    if (!string$$1) {
      return null;
    }

    var hwb = /^hwb\(\s*([+-]?\d*[\.]?\d+)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)$/;
    var match = string$$1.match(hwb);

    if (match) {
      var alpha = parseFloat(match[4]);
      var h = (parseFloat(match[1]) % 360 + 360) % 360;
      var w = clamp(parseFloat(match[2]), 0, 100);
      var b = clamp(parseFloat(match[3]), 0, 100);
      var a = clamp(isNaN(alpha) ? 1 : alpha, 0, 1);
      return [h, w, b, a];
    }

    return null;
  };

  cs.to.hex = function () {
    var rgba = simpleSwizzle(arguments);
    return '#' + hexDouble(rgba[0]) + hexDouble(rgba[1]) + hexDouble(rgba[2]) + (rgba[3] < 1 ? hexDouble(Math.round(rgba[3] * 255)) : '');
  };

  cs.to.rgb = function () {
    var rgba = simpleSwizzle(arguments);
    return rgba.length < 4 || rgba[3] === 1 ? 'rgb(' + Math.round(rgba[0]) + ', ' + Math.round(rgba[1]) + ', ' + Math.round(rgba[2]) + ')' : 'rgba(' + Math.round(rgba[0]) + ', ' + Math.round(rgba[1]) + ', ' + Math.round(rgba[2]) + ', ' + rgba[3] + ')';
  };

  cs.to.rgb.percent = function () {
    var rgba = simpleSwizzle(arguments);
    var r = Math.round(rgba[0] / 255 * 100);
    var g = Math.round(rgba[1] / 255 * 100);
    var b = Math.round(rgba[2] / 255 * 100);
    return rgba.length < 4 || rgba[3] === 1 ? 'rgb(' + r + '%, ' + g + '%, ' + b + '%)' : 'rgba(' + r + '%, ' + g + '%, ' + b + '%, ' + rgba[3] + ')';
  };

  cs.to.hsl = function () {
    var hsla = simpleSwizzle(arguments);
    return hsla.length < 4 || hsla[3] === 1 ? 'hsl(' + hsla[0] + ', ' + hsla[1] + '%, ' + hsla[2] + '%)' : 'hsla(' + hsla[0] + ', ' + hsla[1] + '%, ' + hsla[2] + '%, ' + hsla[3] + ')';
  }; // hwb is a bit different than rgb(a) & hsl(a) since there is no alpha specific syntax
  // (hwb have alpha optional & 1 is default value)


  cs.to.hwb = function () {
    var hwba = simpleSwizzle(arguments);
    var a = '';

    if (hwba.length >= 4 && hwba[3] !== 1) {
      a = ', ' + hwba[3];
    }

    return 'hwb(' + hwba[0] + ', ' + hwba[1] + '%, ' + hwba[2] + '%' + a + ')';
  };

  cs.to.keyword = function (rgb) {
    return reverseNames[rgb.slice(0, 3)];
  }; // helpers


  function clamp(num, min, max) {
    return Math.min(Math.max(min, num), max);
  }

  function hexDouble(num) {
    var str = num.toString(16).toUpperCase();
    return str.length < 2 ? '0' + str : str;
  }
});
var colorString_1 = colorString.to;
var colorString_2 = colorString.get;
var colorName$1 = {
  "aliceblue": [240, 248, 255],
  "antiquewhite": [250, 235, 215],
  "aqua": [0, 255, 255],
  "aquamarine": [127, 255, 212],
  "azure": [240, 255, 255],
  "beige": [245, 245, 220],
  "bisque": [255, 228, 196],
  "black": [0, 0, 0],
  "blanchedalmond": [255, 235, 205],
  "blue": [0, 0, 255],
  "blueviolet": [138, 43, 226],
  "brown": [165, 42, 42],
  "burlywood": [222, 184, 135],
  "cadetblue": [95, 158, 160],
  "chartreuse": [127, 255, 0],
  "chocolate": [210, 105, 30],
  "coral": [255, 127, 80],
  "cornflowerblue": [100, 149, 237],
  "cornsilk": [255, 248, 220],
  "crimson": [220, 20, 60],
  "cyan": [0, 255, 255],
  "darkblue": [0, 0, 139],
  "darkcyan": [0, 139, 139],
  "darkgoldenrod": [184, 134, 11],
  "darkgray": [169, 169, 169],
  "darkgreen": [0, 100, 0],
  "darkgrey": [169, 169, 169],
  "darkkhaki": [189, 183, 107],
  "darkmagenta": [139, 0, 139],
  "darkolivegreen": [85, 107, 47],
  "darkorange": [255, 140, 0],
  "darkorchid": [153, 50, 204],
  "darkred": [139, 0, 0],
  "darksalmon": [233, 150, 122],
  "darkseagreen": [143, 188, 143],
  "darkslateblue": [72, 61, 139],
  "darkslategray": [47, 79, 79],
  "darkslategrey": [47, 79, 79],
  "darkturquoise": [0, 206, 209],
  "darkviolet": [148, 0, 211],
  "deeppink": [255, 20, 147],
  "deepskyblue": [0, 191, 255],
  "dimgray": [105, 105, 105],
  "dimgrey": [105, 105, 105],
  "dodgerblue": [30, 144, 255],
  "firebrick": [178, 34, 34],
  "floralwhite": [255, 250, 240],
  "forestgreen": [34, 139, 34],
  "fuchsia": [255, 0, 255],
  "gainsboro": [220, 220, 220],
  "ghostwhite": [248, 248, 255],
  "gold": [255, 215, 0],
  "goldenrod": [218, 165, 32],
  "gray": [128, 128, 128],
  "green": [0, 128, 0],
  "greenyellow": [173, 255, 47],
  "grey": [128, 128, 128],
  "honeydew": [240, 255, 240],
  "hotpink": [255, 105, 180],
  "indianred": [205, 92, 92],
  "indigo": [75, 0, 130],
  "ivory": [255, 255, 240],
  "khaki": [240, 230, 140],
  "lavender": [230, 230, 250],
  "lavenderblush": [255, 240, 245],
  "lawngreen": [124, 252, 0],
  "lemonchiffon": [255, 250, 205],
  "lightblue": [173, 216, 230],
  "lightcoral": [240, 128, 128],
  "lightcyan": [224, 255, 255],
  "lightgoldenrodyellow": [250, 250, 210],
  "lightgray": [211, 211, 211],
  "lightgreen": [144, 238, 144],
  "lightgrey": [211, 211, 211],
  "lightpink": [255, 182, 193],
  "lightsalmon": [255, 160, 122],
  "lightseagreen": [32, 178, 170],
  "lightskyblue": [135, 206, 250],
  "lightslategray": [119, 136, 153],
  "lightslategrey": [119, 136, 153],
  "lightsteelblue": [176, 196, 222],
  "lightyellow": [255, 255, 224],
  "lime": [0, 255, 0],
  "limegreen": [50, 205, 50],
  "linen": [250, 240, 230],
  "magenta": [255, 0, 255],
  "maroon": [128, 0, 0],
  "mediumaquamarine": [102, 205, 170],
  "mediumblue": [0, 0, 205],
  "mediumorchid": [186, 85, 211],
  "mediumpurple": [147, 112, 219],
  "mediumseagreen": [60, 179, 113],
  "mediumslateblue": [123, 104, 238],
  "mediumspringgreen": [0, 250, 154],
  "mediumturquoise": [72, 209, 204],
  "mediumvioletred": [199, 21, 133],
  "midnightblue": [25, 25, 112],
  "mintcream": [245, 255, 250],
  "mistyrose": [255, 228, 225],
  "moccasin": [255, 228, 181],
  "navajowhite": [255, 222, 173],
  "navy": [0, 0, 128],
  "oldlace": [253, 245, 230],
  "olive": [128, 128, 0],
  "olivedrab": [107, 142, 35],
  "orange": [255, 165, 0],
  "orangered": [255, 69, 0],
  "orchid": [218, 112, 214],
  "palegoldenrod": [238, 232, 170],
  "palegreen": [152, 251, 152],
  "paleturquoise": [175, 238, 238],
  "palevioletred": [219, 112, 147],
  "papayawhip": [255, 239, 213],
  "peachpuff": [255, 218, 185],
  "peru": [205, 133, 63],
  "pink": [255, 192, 203],
  "plum": [221, 160, 221],
  "powderblue": [176, 224, 230],
  "purple": [128, 0, 128],
  "rebeccapurple": [102, 51, 153],
  "red": [255, 0, 0],
  "rosybrown": [188, 143, 143],
  "royalblue": [65, 105, 225],
  "saddlebrown": [139, 69, 19],
  "salmon": [250, 128, 114],
  "sandybrown": [244, 164, 96],
  "seagreen": [46, 139, 87],
  "seashell": [255, 245, 238],
  "sienna": [160, 82, 45],
  "silver": [192, 192, 192],
  "skyblue": [135, 206, 235],
  "slateblue": [106, 90, 205],
  "slategray": [112, 128, 144],
  "slategrey": [112, 128, 144],
  "snow": [255, 250, 250],
  "springgreen": [0, 255, 127],
  "steelblue": [70, 130, 180],
  "tan": [210, 180, 140],
  "teal": [0, 128, 128],
  "thistle": [216, 191, 216],
  "tomato": [255, 99, 71],
  "turquoise": [64, 224, 208],
  "violet": [238, 130, 238],
  "wheat": [245, 222, 179],
  "white": [255, 255, 255],
  "whitesmoke": [245, 245, 245],
  "yellow": [255, 255, 0],
  "yellowgreen": [154, 205, 50]
};
var conversions = createCommonjsModule(function (module) {
  /* MIT license */
  // NOTE: conversions should only return primitive values (i.e. arrays, or
  //       values that give correct `typeof` results).
  //       do not use box values types (i.e. Number(), String(), etc.)
  var reverseKeywords = {};

  for (var key in colorName$1) {
    if (colorName$1.hasOwnProperty(key)) {
      reverseKeywords[colorName$1[key]] = key;
    }
  }

  var convert = module.exports = {
    rgb: {
      channels: 3,
      labels: 'rgb'
    },
    hsl: {
      channels: 3,
      labels: 'hsl'
    },
    hsv: {
      channels: 3,
      labels: 'hsv'
    },
    hwb: {
      channels: 3,
      labels: 'hwb'
    },
    cmyk: {
      channels: 4,
      labels: 'cmyk'
    },
    xyz: {
      channels: 3,
      labels: 'xyz'
    },
    lab: {
      channels: 3,
      labels: 'lab'
    },
    lch: {
      channels: 3,
      labels: 'lch'
    },
    hex: {
      channels: 1,
      labels: ['hex']
    },
    keyword: {
      channels: 1,
      labels: ['keyword']
    },
    ansi16: {
      channels: 1,
      labels: ['ansi16']
    },
    ansi256: {
      channels: 1,
      labels: ['ansi256']
    },
    hcg: {
      channels: 3,
      labels: ['h', 'c', 'g']
    },
    apple: {
      channels: 3,
      labels: ['r16', 'g16', 'b16']
    },
    gray: {
      channels: 1,
      labels: ['gray']
    }
  }; // hide .channels and .labels properties

  for (var model in convert) {
    if (convert.hasOwnProperty(model)) {
      if (!('channels' in convert[model])) {
        throw new Error('missing channels property: ' + model);
      }

      if (!('labels' in convert[model])) {
        throw new Error('missing channel labels property: ' + model);
      }

      if (convert[model].labels.length !== convert[model].channels) {
        throw new Error('channel and label counts mismatch: ' + model);
      }

      var channels = convert[model].channels;
      var labels = convert[model].labels;
      delete convert[model].channels;
      delete convert[model].labels;
      Object.defineProperty(convert[model], 'channels', {
        value: channels
      });
      Object.defineProperty(convert[model], 'labels', {
        value: labels
      });
    }
  }

  convert.rgb.hsl = function (rgb) {
    var r = rgb[0] / 255;
    var g = rgb[1] / 255;
    var b = rgb[2] / 255;
    var min = Math.min(r, g, b);
    var max = Math.max(r, g, b);
    var delta = max - min;
    var h;
    var s;
    var l;

    if (max === min) {
      h = 0;
    } else if (r === max) {
      h = (g - b) / delta;
    } else if (g === max) {
      h = 2 + (b - r) / delta;
    } else if (b === max) {
      h = 4 + (r - g) / delta;
    }

    h = Math.min(h * 60, 360);

    if (h < 0) {
      h += 360;
    }

    l = (min + max) / 2;

    if (max === min) {
      s = 0;
    } else if (l <= 0.5) {
      s = delta / (max + min);
    } else {
      s = delta / (2 - max - min);
    }

    return [h, s * 100, l * 100];
  };

  convert.rgb.hsv = function (rgb) {
    var rdif;
    var gdif;
    var bdif;
    var h;
    var s;
    var r = rgb[0] / 255;
    var g = rgb[1] / 255;
    var b = rgb[2] / 255;
    var v = Math.max(r, g, b);
    var diff = v - Math.min(r, g, b);

    var diffc = function diffc(c) {
      return (v - c) / 6 / diff + 1 / 2;
    };

    if (diff === 0) {
      h = s = 0;
    } else {
      s = diff / v;
      rdif = diffc(r);
      gdif = diffc(g);
      bdif = diffc(b);

      if (r === v) {
        h = bdif - gdif;
      } else if (g === v) {
        h = 1 / 3 + rdif - bdif;
      } else if (b === v) {
        h = 2 / 3 + gdif - rdif;
      }

      if (h < 0) {
        h += 1;
      } else if (h > 1) {
        h -= 1;
      }
    }

    return [h * 360, s * 100, v * 100];
  };

  convert.rgb.hwb = function (rgb) {
    var r = rgb[0];
    var g = rgb[1];
    var b = rgb[2];
    var h = convert.rgb.hsl(rgb)[0];
    var w = 1 / 255 * Math.min(r, Math.min(g, b));
    b = 1 - 1 / 255 * Math.max(r, Math.max(g, b));
    return [h, w * 100, b * 100];
  };

  convert.rgb.cmyk = function (rgb) {
    var r = rgb[0] / 255;
    var g = rgb[1] / 255;
    var b = rgb[2] / 255;
    var c;
    var m;
    var y;
    var k;
    k = Math.min(1 - r, 1 - g, 1 - b);
    c = (1 - r - k) / (1 - k) || 0;
    m = (1 - g - k) / (1 - k) || 0;
    y = (1 - b - k) / (1 - k) || 0;
    return [c * 100, m * 100, y * 100, k * 100];
  };
  /**
   * See https://en.m.wikipedia.org/wiki/Euclidean_distance#Squared_Euclidean_distance
   * */


  function comparativeDistance(x, y) {
    return Math.pow(x[0] - y[0], 2) + Math.pow(x[1] - y[1], 2) + Math.pow(x[2] - y[2], 2);
  }

  convert.rgb.keyword = function (rgb) {
    var reversed = reverseKeywords[rgb];

    if (reversed) {
      return reversed;
    }

    var currentClosestDistance = Infinity;
    var currentClosestKeyword;

    for (var keyword in colorName$1) {
      if (colorName$1.hasOwnProperty(keyword)) {
        var value = colorName$1[keyword]; // Compute comparative distance

        var distance = comparativeDistance(rgb, value); // Check if its less, if so set as closest

        if (distance < currentClosestDistance) {
          currentClosestDistance = distance;
          currentClosestKeyword = keyword;
        }
      }
    }

    return currentClosestKeyword;
  };

  convert.keyword.rgb = function (keyword) {
    return colorName$1[keyword];
  };

  convert.rgb.xyz = function (rgb) {
    var r = rgb[0] / 255;
    var g = rgb[1] / 255;
    var b = rgb[2] / 255; // assume sRGB

    r = r > 0.04045 ? Math.pow((r + 0.055) / 1.055, 2.4) : r / 12.92;
    g = g > 0.04045 ? Math.pow((g + 0.055) / 1.055, 2.4) : g / 12.92;
    b = b > 0.04045 ? Math.pow((b + 0.055) / 1.055, 2.4) : b / 12.92;
    var x = r * 0.4124 + g * 0.3576 + b * 0.1805;
    var y = r * 0.2126 + g * 0.7152 + b * 0.0722;
    var z = r * 0.0193 + g * 0.1192 + b * 0.9505;
    return [x * 100, y * 100, z * 100];
  };

  convert.rgb.lab = function (rgb) {
    var xyz = convert.rgb.xyz(rgb);
    var x = xyz[0];
    var y = xyz[1];
    var z = xyz[2];
    var l;
    var a;
    var b;
    x /= 95.047;
    y /= 100;
    z /= 108.883;
    x = x > 0.008856 ? Math.pow(x, 1 / 3) : 7.787 * x + 16 / 116;
    y = y > 0.008856 ? Math.pow(y, 1 / 3) : 7.787 * y + 16 / 116;
    z = z > 0.008856 ? Math.pow(z, 1 / 3) : 7.787 * z + 16 / 116;
    l = 116 * y - 16;
    a = 500 * (x - y);
    b = 200 * (y - z);
    return [l, a, b];
  };

  convert.hsl.rgb = function (hsl) {
    var h = hsl[0] / 360;
    var s = hsl[1] / 100;
    var l = hsl[2] / 100;
    var t1;
    var t2;
    var t3;
    var rgb;
    var val;

    if (s === 0) {
      val = l * 255;
      return [val, val, val];
    }

    if (l < 0.5) {
      t2 = l * (1 + s);
    } else {
      t2 = l + s - l * s;
    }

    t1 = 2 * l - t2;
    rgb = [0, 0, 0];

    for (var i = 0; i < 3; i++) {
      t3 = h + 1 / 3 * -(i - 1);

      if (t3 < 0) {
        t3++;
      }

      if (t3 > 1) {
        t3--;
      }

      if (6 * t3 < 1) {
        val = t1 + (t2 - t1) * 6 * t3;
      } else if (2 * t3 < 1) {
        val = t2;
      } else if (3 * t3 < 2) {
        val = t1 + (t2 - t1) * (2 / 3 - t3) * 6;
      } else {
        val = t1;
      }

      rgb[i] = val * 255;
    }

    return rgb;
  };

  convert.hsl.hsv = function (hsl) {
    var h = hsl[0];
    var s = hsl[1] / 100;
    var l = hsl[2] / 100;
    var smin = s;
    var lmin = Math.max(l, 0.01);
    var sv;
    var v;
    l *= 2;
    s *= l <= 1 ? l : 2 - l;
    smin *= lmin <= 1 ? lmin : 2 - lmin;
    v = (l + s) / 2;
    sv = l === 0 ? 2 * smin / (lmin + smin) : 2 * s / (l + s);
    return [h, sv * 100, v * 100];
  };

  convert.hsv.rgb = function (hsv) {
    var h = hsv[0] / 60;
    var s = hsv[1] / 100;
    var v = hsv[2] / 100;
    var hi = Math.floor(h) % 6;
    var f = h - Math.floor(h);
    var p = 255 * v * (1 - s);
    var q = 255 * v * (1 - s * f);
    var t = 255 * v * (1 - s * (1 - f));
    v *= 255;

    switch (hi) {
      case 0:
        return [v, t, p];

      case 1:
        return [q, v, p];

      case 2:
        return [p, v, t];

      case 3:
        return [p, q, v];

      case 4:
        return [t, p, v];

      case 5:
        return [v, p, q];
    }
  };

  convert.hsv.hsl = function (hsv) {
    var h = hsv[0];
    var s = hsv[1] / 100;
    var v = hsv[2] / 100;
    var vmin = Math.max(v, 0.01);
    var lmin;
    var sl;
    var l;
    l = (2 - s) * v;
    lmin = (2 - s) * vmin;
    sl = s * vmin;
    sl /= lmin <= 1 ? lmin : 2 - lmin;
    sl = sl || 0;
    l /= 2;
    return [h, sl * 100, l * 100];
  }; // http://dev.w3.org/csswg/css-color/#hwb-to-rgb


  convert.hwb.rgb = function (hwb) {
    var h = hwb[0] / 360;
    var wh = hwb[1] / 100;
    var bl = hwb[2] / 100;
    var ratio = wh + bl;
    var i;
    var v;
    var f;
    var n; // wh + bl cant be > 1

    if (ratio > 1) {
      wh /= ratio;
      bl /= ratio;
    }

    i = Math.floor(6 * h);
    v = 1 - bl;
    f = 6 * h - i;

    if ((i & 0x01) !== 0) {
      f = 1 - f;
    }

    n = wh + f * (v - wh); // linear interpolation

    var r;
    var g;
    var b;

    switch (i) {
      default:
      case 6:
      case 0:
        r = v;
        g = n;
        b = wh;
        break;

      case 1:
        r = n;
        g = v;
        b = wh;
        break;

      case 2:
        r = wh;
        g = v;
        b = n;
        break;

      case 3:
        r = wh;
        g = n;
        b = v;
        break;

      case 4:
        r = n;
        g = wh;
        b = v;
        break;

      case 5:
        r = v;
        g = wh;
        b = n;
        break;
    }

    return [r * 255, g * 255, b * 255];
  };

  convert.cmyk.rgb = function (cmyk) {
    var c = cmyk[0] / 100;
    var m = cmyk[1] / 100;
    var y = cmyk[2] / 100;
    var k = cmyk[3] / 100;
    var r;
    var g;
    var b;
    r = 1 - Math.min(1, c * (1 - k) + k);
    g = 1 - Math.min(1, m * (1 - k) + k);
    b = 1 - Math.min(1, y * (1 - k) + k);
    return [r * 255, g * 255, b * 255];
  };

  convert.xyz.rgb = function (xyz) {
    var x = xyz[0] / 100;
    var y = xyz[1] / 100;
    var z = xyz[2] / 100;
    var r;
    var g;
    var b;
    r = x * 3.2406 + y * -1.5372 + z * -0.4986;
    g = x * -0.9689 + y * 1.8758 + z * 0.0415;
    b = x * 0.0557 + y * -0.2040 + z * 1.0570; // assume sRGB

    r = r > 0.0031308 ? 1.055 * Math.pow(r, 1.0 / 2.4) - 0.055 : r * 12.92;
    g = g > 0.0031308 ? 1.055 * Math.pow(g, 1.0 / 2.4) - 0.055 : g * 12.92;
    b = b > 0.0031308 ? 1.055 * Math.pow(b, 1.0 / 2.4) - 0.055 : b * 12.92;
    r = Math.min(Math.max(0, r), 1);
    g = Math.min(Math.max(0, g), 1);
    b = Math.min(Math.max(0, b), 1);
    return [r * 255, g * 255, b * 255];
  };

  convert.xyz.lab = function (xyz) {
    var x = xyz[0];
    var y = xyz[1];
    var z = xyz[2];
    var l;
    var a;
    var b;
    x /= 95.047;
    y /= 100;
    z /= 108.883;
    x = x > 0.008856 ? Math.pow(x, 1 / 3) : 7.787 * x + 16 / 116;
    y = y > 0.008856 ? Math.pow(y, 1 / 3) : 7.787 * y + 16 / 116;
    z = z > 0.008856 ? Math.pow(z, 1 / 3) : 7.787 * z + 16 / 116;
    l = 116 * y - 16;
    a = 500 * (x - y);
    b = 200 * (y - z);
    return [l, a, b];
  };

  convert.lab.xyz = function (lab) {
    var l = lab[0];
    var a = lab[1];
    var b = lab[2];
    var x;
    var y;
    var z;
    y = (l + 16) / 116;
    x = a / 500 + y;
    z = y - b / 200;
    var y2 = Math.pow(y, 3);
    var x2 = Math.pow(x, 3);
    var z2 = Math.pow(z, 3);
    y = y2 > 0.008856 ? y2 : (y - 16 / 116) / 7.787;
    x = x2 > 0.008856 ? x2 : (x - 16 / 116) / 7.787;
    z = z2 > 0.008856 ? z2 : (z - 16 / 116) / 7.787;
    x *= 95.047;
    y *= 100;
    z *= 108.883;
    return [x, y, z];
  };

  convert.lab.lch = function (lab) {
    var l = lab[0];
    var a = lab[1];
    var b = lab[2];
    var hr;
    var h;
    var c;
    hr = Math.atan2(b, a);
    h = hr * 360 / 2 / Math.PI;

    if (h < 0) {
      h += 360;
    }

    c = Math.sqrt(a * a + b * b);
    return [l, c, h];
  };

  convert.lch.lab = function (lch) {
    var l = lch[0];
    var c = lch[1];
    var h = lch[2];
    var a;
    var b;
    var hr;
    hr = h / 360 * 2 * Math.PI;
    a = c * Math.cos(hr);
    b = c * Math.sin(hr);
    return [l, a, b];
  };

  convert.rgb.ansi16 = function (args) {
    var r = args[0];
    var g = args[1];
    var b = args[2];
    var value = 1 in arguments ? arguments[1] : convert.rgb.hsv(args)[2]; // hsv -> ansi16 optimization

    value = Math.round(value / 50);

    if (value === 0) {
      return 30;
    }

    var ansi = 30 + (Math.round(b / 255) << 2 | Math.round(g / 255) << 1 | Math.round(r / 255));

    if (value === 2) {
      ansi += 60;
    }

    return ansi;
  };

  convert.hsv.ansi16 = function (args) {
    // optimization here; we already know the value and don't need to get
    // it converted for us.
    return convert.rgb.ansi16(convert.hsv.rgb(args), args[2]);
  };

  convert.rgb.ansi256 = function (args) {
    var r = args[0];
    var g = args[1];
    var b = args[2]; // we use the extended greyscale palette here, with the exception of
    // black and white. normal palette only has 4 greyscale shades.

    if (r === g && g === b) {
      if (r < 8) {
        return 16;
      }

      if (r > 248) {
        return 231;
      }

      return Math.round((r - 8) / 247 * 24) + 232;
    }

    var ansi = 16 + 36 * Math.round(r / 255 * 5) + 6 * Math.round(g / 255 * 5) + Math.round(b / 255 * 5);
    return ansi;
  };

  convert.ansi16.rgb = function (args) {
    var color = args % 10; // handle greyscale

    if (color === 0 || color === 7) {
      if (args > 50) {
        color += 3.5;
      }

      color = color / 10.5 * 255;
      return [color, color, color];
    }

    var mult = (~~(args > 50) + 1) * 0.5;
    var r = (color & 1) * mult * 255;
    var g = (color >> 1 & 1) * mult * 255;
    var b = (color >> 2 & 1) * mult * 255;
    return [r, g, b];
  };

  convert.ansi256.rgb = function (args) {
    // handle greyscale
    if (args >= 232) {
      var c = (args - 232) * 10 + 8;
      return [c, c, c];
    }

    args -= 16;
    var rem;
    var r = Math.floor(args / 36) / 5 * 255;
    var g = Math.floor((rem = args % 36) / 6) / 5 * 255;
    var b = rem % 6 / 5 * 255;
    return [r, g, b];
  };

  convert.rgb.hex = function (args) {
    var integer = ((Math.round(args[0]) & 0xFF) << 16) + ((Math.round(args[1]) & 0xFF) << 8) + (Math.round(args[2]) & 0xFF);
    var string$$1 = integer.toString(16).toUpperCase();
    return '000000'.substring(string$$1.length) + string$$1;
  };

  convert.hex.rgb = function (args) {
    var match = args.toString(16).match(/[a-f0-9]{6}|[a-f0-9]{3}/i);

    if (!match) {
      return [0, 0, 0];
    }

    var colorString = match[0];

    if (match[0].length === 3) {
      colorString = colorString.split('').map(function (_char) {
        return _char + _char;
      }).join('');
    }

    var integer = parseInt(colorString, 16);
    var r = integer >> 16 & 0xFF;
    var g = integer >> 8 & 0xFF;
    var b = integer & 0xFF;
    return [r, g, b];
  };

  convert.rgb.hcg = function (rgb) {
    var r = rgb[0] / 255;
    var g = rgb[1] / 255;
    var b = rgb[2] / 255;
    var max = Math.max(Math.max(r, g), b);
    var min = Math.min(Math.min(r, g), b);
    var chroma = max - min;
    var grayscale;
    var hue;

    if (chroma < 1) {
      grayscale = min / (1 - chroma);
    } else {
      grayscale = 0;
    }

    if (chroma <= 0) {
      hue = 0;
    } else if (max === r) {
      hue = (g - b) / chroma % 6;
    } else if (max === g) {
      hue = 2 + (b - r) / chroma;
    } else {
      hue = 4 + (r - g) / chroma + 4;
    }

    hue /= 6;
    hue %= 1;
    return [hue * 360, chroma * 100, grayscale * 100];
  };

  convert.hsl.hcg = function (hsl) {
    var s = hsl[1] / 100;
    var l = hsl[2] / 100;
    var c = 1;
    var f = 0;

    if (l < 0.5) {
      c = 2.0 * s * l;
    } else {
      c = 2.0 * s * (1.0 - l);
    }

    if (c < 1.0) {
      f = (l - 0.5 * c) / (1.0 - c);
    }

    return [hsl[0], c * 100, f * 100];
  };

  convert.hsv.hcg = function (hsv) {
    var s = hsv[1] / 100;
    var v = hsv[2] / 100;
    var c = s * v;
    var f = 0;

    if (c < 1.0) {
      f = (v - c) / (1 - c);
    }

    return [hsv[0], c * 100, f * 100];
  };

  convert.hcg.rgb = function (hcg) {
    var h = hcg[0] / 360;
    var c = hcg[1] / 100;
    var g = hcg[2] / 100;

    if (c === 0.0) {
      return [g * 255, g * 255, g * 255];
    }

    var pure = [0, 0, 0];
    var hi = h % 1 * 6;
    var v = hi % 1;
    var w = 1 - v;
    var mg = 0;

    switch (Math.floor(hi)) {
      case 0:
        pure[0] = 1;
        pure[1] = v;
        pure[2] = 0;
        break;

      case 1:
        pure[0] = w;
        pure[1] = 1;
        pure[2] = 0;
        break;

      case 2:
        pure[0] = 0;
        pure[1] = 1;
        pure[2] = v;
        break;

      case 3:
        pure[0] = 0;
        pure[1] = w;
        pure[2] = 1;
        break;

      case 4:
        pure[0] = v;
        pure[1] = 0;
        pure[2] = 1;
        break;

      default:
        pure[0] = 1;
        pure[1] = 0;
        pure[2] = w;
    }

    mg = (1.0 - c) * g;
    return [(c * pure[0] + mg) * 255, (c * pure[1] + mg) * 255, (c * pure[2] + mg) * 255];
  };

  convert.hcg.hsv = function (hcg) {
    var c = hcg[1] / 100;
    var g = hcg[2] / 100;
    var v = c + g * (1.0 - c);
    var f = 0;

    if (v > 0.0) {
      f = c / v;
    }

    return [hcg[0], f * 100, v * 100];
  };

  convert.hcg.hsl = function (hcg) {
    var c = hcg[1] / 100;
    var g = hcg[2] / 100;
    var l = g * (1.0 - c) + 0.5 * c;
    var s = 0;

    if (l > 0.0 && l < 0.5) {
      s = c / (2 * l);
    } else if (l >= 0.5 && l < 1.0) {
      s = c / (2 * (1 - l));
    }

    return [hcg[0], s * 100, l * 100];
  };

  convert.hcg.hwb = function (hcg) {
    var c = hcg[1] / 100;
    var g = hcg[2] / 100;
    var v = c + g * (1.0 - c);
    return [hcg[0], (v - c) * 100, (1 - v) * 100];
  };

  convert.hwb.hcg = function (hwb) {
    var w = hwb[1] / 100;
    var b = hwb[2] / 100;
    var v = 1 - b;
    var c = v - w;
    var g = 0;

    if (c < 1) {
      g = (v - c) / (1 - c);
    }

    return [hwb[0], c * 100, g * 100];
  };

  convert.apple.rgb = function (apple) {
    return [apple[0] / 65535 * 255, apple[1] / 65535 * 255, apple[2] / 65535 * 255];
  };

  convert.rgb.apple = function (rgb) {
    return [rgb[0] / 255 * 65535, rgb[1] / 255 * 65535, rgb[2] / 255 * 65535];
  };

  convert.gray.rgb = function (args) {
    return [args[0] / 100 * 255, args[0] / 100 * 255, args[0] / 100 * 255];
  };

  convert.gray.hsl = convert.gray.hsv = function (args) {
    return [0, 0, args[0]];
  };

  convert.gray.hwb = function (gray) {
    return [0, 100, gray[0]];
  };

  convert.gray.cmyk = function (gray) {
    return [0, 0, 0, gray[0]];
  };

  convert.gray.lab = function (gray) {
    return [gray[0], 0, 0];
  };

  convert.gray.hex = function (gray) {
    var val = Math.round(gray[0] / 100 * 255) & 0xFF;
    var integer = (val << 16) + (val << 8) + val;
    var string$$1 = integer.toString(16).toUpperCase();
    return '000000'.substring(string$$1.length) + string$$1;
  };

  convert.rgb.gray = function (rgb) {
    var val = (rgb[0] + rgb[1] + rgb[2]) / 3;
    return [val / 255 * 100];
  };
});
var conversions_1 = conversions.rgb;
var conversions_2 = conversions.hsl;
var conversions_3 = conversions.hsv;
var conversions_4 = conversions.hwb;
var conversions_5 = conversions.cmyk;
var conversions_6 = conversions.xyz;
var conversions_7 = conversions.lab;
var conversions_8 = conversions.lch;
var conversions_9 = conversions.hex;
var conversions_10 = conversions.keyword;
var conversions_11 = conversions.ansi16;
var conversions_12 = conversions.ansi256;
var conversions_13 = conversions.hcg;
var conversions_14 = conversions.apple;
var conversions_15 = conversions.gray;
/*
	this function routes a model to all other models.

	all functions that are routed have a property `.conversion` attached
	to the returned synthetic function. This property is an array
	of strings, each with the steps in between the 'from' and 'to'
	color models (inclusive).

	conversions that are not possible simply are not included.
*/

function buildGraph() {
  var graph = {}; // https://jsperf.com/object-keys-vs-for-in-with-closure/3

  var models = Object.keys(conversions);

  for (var len = models.length, i = 0; i < len; i++) {
    graph[models[i]] = {
      // http://jsperf.com/1-vs-infinity
      // micro-opt, but this is simple.
      distance: -1,
      parent: null
    };
  }

  return graph;
} // https://en.wikipedia.org/wiki/Breadth-first_search


function deriveBFS(fromModel) {
  var graph = buildGraph();
  var queue = [fromModel]; // unshift -> queue -> pop

  graph[fromModel].distance = 0;

  while (queue.length) {
    var current = queue.pop();
    var adjacents = Object.keys(conversions[current]);

    for (var len = adjacents.length, i = 0; i < len; i++) {
      var adjacent = adjacents[i];
      var node$$1 = graph[adjacent];

      if (node$$1.distance === -1) {
        node$$1.distance = graph[current].distance + 1;
        node$$1.parent = current;
        queue.unshift(adjacent);
      }
    }
  }

  return graph;
}

function link(from, to) {
  return function (args) {
    return to(from(args));
  };
}

function wrapConversion(toModel, graph) {
  var path = [graph[toModel].parent, toModel];
  var fn = conversions[graph[toModel].parent][toModel];
  var cur = graph[toModel].parent;

  while (graph[cur].parent) {
    path.unshift(graph[cur].parent);
    fn = link(conversions[graph[cur].parent][cur], fn);
    cur = graph[cur].parent;
  }

  fn.conversion = path;
  return fn;
}

var route = function route(fromModel) {
  var graph = deriveBFS(fromModel);
  var conversion = {};
  var models = Object.keys(graph);

  for (var len = models.length, i = 0; i < len; i++) {
    var toModel = models[i];
    var node$$1 = graph[toModel];

    if (node$$1.parent === null) {
      // no possible conversion, or this node is the source model.
      continue;
    }

    conversion[toModel] = wrapConversion(toModel, graph);
  }

  return conversion;
};

var convert = {};
var models = Object.keys(conversions);

function wrapRaw(fn) {
  var wrappedFn = function wrappedFn(args) {
    if (args === undefined || args === null) {
      return args;
    }

    if (arguments.length > 1) {
      args = Array.prototype.slice.call(arguments);
    }

    return fn(args);
  }; // preserve .conversion property if there is one


  if ('conversion' in fn) {
    wrappedFn.conversion = fn.conversion;
  }

  return wrappedFn;
}

function wrapRounded(fn) {
  var wrappedFn = function wrappedFn(args) {
    if (args === undefined || args === null) {
      return args;
    }

    if (arguments.length > 1) {
      args = Array.prototype.slice.call(arguments);
    }

    var result = fn(args); // we're assuming the result is an array here.
    // see notice in conversions.js; don't use box types
    // in conversion functions.

    if (typeof result === 'object') {
      for (var len = result.length, i = 0; i < len; i++) {
        result[i] = Math.round(result[i]);
      }
    }

    return result;
  }; // preserve .conversion property if there is one


  if ('conversion' in fn) {
    wrappedFn.conversion = fn.conversion;
  }

  return wrappedFn;
}

models.forEach(function (fromModel) {
  convert[fromModel] = {};
  Object.defineProperty(convert[fromModel], 'channels', {
    value: conversions[fromModel].channels
  });
  Object.defineProperty(convert[fromModel], 'labels', {
    value: conversions[fromModel].labels
  });
  var routes = route(fromModel);
  var routeModels = Object.keys(routes);
  routeModels.forEach(function (toModel) {
    var fn = routes[toModel];
    convert[fromModel][toModel] = wrapRounded(fn);
    convert[fromModel][toModel].raw = wrapRaw(fn);
  });
});
var colorConvert = convert;
var _slice = [].slice;
var skippedModels = [// to be honest, I don't really feel like keyword belongs in color convert, but eh.
'keyword', // gray conflicts with some method names, and has its own method defined.
'gray', // shouldn't really be in color-convert either...
'hex'];
var hashedModelKeys = {};
Object.keys(colorConvert).forEach(function (model) {
  hashedModelKeys[_slice.call(colorConvert[model].labels).sort().join('')] = model;
});
var limiters = {};

function Color(obj, model) {
  if (!(this instanceof Color)) {
    return new Color(obj, model);
  }

  if (model && model in skippedModels) {
    model = null;
  }

  if (model && !(model in colorConvert)) {
    throw new Error('Unknown model: ' + model);
  }

  var i;
  var channels;

  if (obj == null) {
    // eslint-disable-line no-eq-null,eqeqeq
    this.model = 'rgb';
    this.color = [0, 0, 0];
    this.valpha = 1;
  } else if (obj instanceof Color) {
    this.model = obj.model;
    this.color = obj.color.slice();
    this.valpha = obj.valpha;
  } else if (typeof obj === 'string') {
    var result = colorString.get(obj);

    if (result === null) {
      throw new Error('Unable to parse color from string: ' + obj);
    }

    this.model = result.model;
    channels = colorConvert[this.model].channels;
    this.color = result.value.slice(0, channels);
    this.valpha = typeof result.value[channels] === 'number' ? result.value[channels] : 1;
  } else if (obj.length) {
    this.model = model || 'rgb';
    channels = colorConvert[this.model].channels;

    var newArr = _slice.call(obj, 0, channels);

    this.color = zeroArray(newArr, channels);
    this.valpha = typeof obj[channels] === 'number' ? obj[channels] : 1;
  } else if (typeof obj === 'number') {
    // this is always RGB - can be converted later on.
    obj &= 0xFFFFFF;
    this.model = 'rgb';
    this.color = [obj >> 16 & 0xFF, obj >> 8 & 0xFF, obj & 0xFF];
    this.valpha = 1;
  } else {
    this.valpha = 1;
    var keys = Object.keys(obj);

    if ('alpha' in obj) {
      keys.splice(keys.indexOf('alpha'), 1);
      this.valpha = typeof obj.alpha === 'number' ? obj.alpha : 0;
    }

    var hashedKeys = keys.sort().join('');

    if (!(hashedKeys in hashedModelKeys)) {
      throw new Error('Unable to parse color from object: ' + JSON.stringify(obj));
    }

    this.model = hashedModelKeys[hashedKeys];
    var labels = colorConvert[this.model].labels;
    var color = [];

    for (i = 0; i < labels.length; i++) {
      color.push(obj[labels[i]]);
    }

    this.color = zeroArray(color);
  } // perform limitations (clamping, etc.)


  if (limiters[this.model]) {
    channels = colorConvert[this.model].channels;

    for (i = 0; i < channels; i++) {
      var limit = limiters[this.model][i];

      if (limit) {
        this.color[i] = limit(this.color[i]);
      }
    }
  }

  this.valpha = Math.max(0, Math.min(1, this.valpha));

  if (Object.freeze) {
    Object.freeze(this);
  }
}

Color.prototype = {
  toString: function toString() {
    return this.string();
  },
  toJSON: function toJSON() {
    return this[this.model]();
  },
  string: function string(places) {
    var self = this.model in colorString.to ? this : this.rgb();
    self = self.round(typeof places === 'number' ? places : 1);
    var args = self.valpha === 1 ? self.color : self.color.concat(this.valpha);
    return colorString.to[self.model](args);
  },
  percentString: function percentString(places) {
    var self = this.rgb().round(typeof places === 'number' ? places : 1);
    var args = self.valpha === 1 ? self.color : self.color.concat(this.valpha);
    return colorString.to.rgb.percent(args);
  },
  array: function array() {
    return this.valpha === 1 ? this.color.slice() : this.color.concat(this.valpha);
  },
  object: function object() {
    var result = {};
    var channels = colorConvert[this.model].channels;
    var labels = colorConvert[this.model].labels;

    for (var i = 0; i < channels; i++) {
      result[labels[i]] = this.color[i];
    }

    if (this.valpha !== 1) {
      result.alpha = this.valpha;
    }

    return result;
  },
  unitArray: function unitArray() {
    var rgb = this.rgb().color;
    rgb[0] /= 255;
    rgb[1] /= 255;
    rgb[2] /= 255;

    if (this.valpha !== 1) {
      rgb.push(this.valpha);
    }

    return rgb;
  },
  unitObject: function unitObject() {
    var rgb = this.rgb().object();
    rgb.r /= 255;
    rgb.g /= 255;
    rgb.b /= 255;

    if (this.valpha !== 1) {
      rgb.alpha = this.valpha;
    }

    return rgb;
  },
  round: function round(places) {
    places = Math.max(places || 0, 0);
    return new Color(this.color.map(roundToPlace(places)).concat(this.valpha), this.model);
  },
  alpha: function alpha(val) {
    if (arguments.length) {
      return new Color(this.color.concat(Math.max(0, Math.min(1, val))), this.model);
    }

    return this.valpha;
  },
  // rgb
  red: getset('rgb', 0, maxfn(255)),
  green: getset('rgb', 1, maxfn(255)),
  blue: getset('rgb', 2, maxfn(255)),
  hue: getset(['hsl', 'hsv', 'hsl', 'hwb', 'hcg'], 0, function (val) {
    return (val % 360 + 360) % 360;
  }),
  // eslint-disable-line brace-style
  saturationl: getset('hsl', 1, maxfn(100)),
  lightness: getset('hsl', 2, maxfn(100)),
  saturationv: getset('hsv', 1, maxfn(100)),
  value: getset('hsv', 2, maxfn(100)),
  chroma: getset('hcg', 1, maxfn(100)),
  gray: getset('hcg', 2, maxfn(100)),
  white: getset('hwb', 1, maxfn(100)),
  wblack: getset('hwb', 2, maxfn(100)),
  cyan: getset('cmyk', 0, maxfn(100)),
  magenta: getset('cmyk', 1, maxfn(100)),
  yellow: getset('cmyk', 2, maxfn(100)),
  black: getset('cmyk', 3, maxfn(100)),
  x: getset('xyz', 0, maxfn(100)),
  y: getset('xyz', 1, maxfn(100)),
  z: getset('xyz', 2, maxfn(100)),
  l: getset('lab', 0, maxfn(100)),
  a: getset('lab', 1),
  b: getset('lab', 2),
  keyword: function keyword(val) {
    if (arguments.length) {
      return new Color(val);
    }

    return colorConvert[this.model].keyword(this.color);
  },
  hex: function hex(val) {
    if (arguments.length) {
      return new Color(val);
    }

    return colorString.to.hex(this.rgb().round().color);
  },
  rgbNumber: function rgbNumber() {
    var rgb = this.rgb().color;
    return (rgb[0] & 0xFF) << 16 | (rgb[1] & 0xFF) << 8 | rgb[2] & 0xFF;
  },
  luminosity: function luminosity() {
    // http://www.w3.org/TR/WCAG20/#relativeluminancedef
    var rgb = this.rgb().color;
    var lum = [];

    for (var i = 0; i < rgb.length; i++) {
      var chan = rgb[i] / 255;
      lum[i] = chan <= 0.03928 ? chan / 12.92 : Math.pow((chan + 0.055) / 1.055, 2.4);
    }

    return 0.2126 * lum[0] + 0.7152 * lum[1] + 0.0722 * lum[2];
  },
  contrast: function contrast(color2) {
    // http://www.w3.org/TR/WCAG20/#contrast-ratiodef
    var lum1 = this.luminosity();
    var lum2 = color2.luminosity();

    if (lum1 > lum2) {
      return (lum1 + 0.05) / (lum2 + 0.05);
    }

    return (lum2 + 0.05) / (lum1 + 0.05);
  },
  level: function level(color2) {
    var contrastRatio = this.contrast(color2);

    if (contrastRatio >= 7.1) {
      return 'AAA';
    }

    return contrastRatio >= 4.5 ? 'AA' : '';
  },
  isDark: function isDark() {
    // YIQ equation from http://24ways.org/2010/calculating-color-contrast
    var rgb = this.rgb().color;
    var yiq = (rgb[0] * 299 + rgb[1] * 587 + rgb[2] * 114) / 1000;
    return yiq < 128;
  },
  isLight: function isLight() {
    return !this.isDark();
  },
  negate: function negate() {
    var rgb = this.rgb();

    for (var i = 0; i < 3; i++) {
      rgb.color[i] = 255 - rgb.color[i];
    }

    return rgb;
  },
  lighten: function lighten(ratio) {
    var hsl = this.hsl();
    hsl.color[2] += hsl.color[2] * ratio;
    return hsl;
  },
  darken: function darken(ratio) {
    var hsl = this.hsl();
    hsl.color[2] -= hsl.color[2] * ratio;
    return hsl;
  },
  saturate: function saturate(ratio) {
    var hsl = this.hsl();
    hsl.color[1] += hsl.color[1] * ratio;
    return hsl;
  },
  desaturate: function desaturate(ratio) {
    var hsl = this.hsl();
    hsl.color[1] -= hsl.color[1] * ratio;
    return hsl;
  },
  whiten: function whiten(ratio) {
    var hwb = this.hwb();
    hwb.color[1] += hwb.color[1] * ratio;
    return hwb;
  },
  blacken: function blacken(ratio) {
    var hwb = this.hwb();
    hwb.color[2] += hwb.color[2] * ratio;
    return hwb;
  },
  grayscale: function grayscale() {
    // http://en.wikipedia.org/wiki/Grayscale#Converting_color_to_grayscale
    var rgb = this.rgb().color;
    var val = rgb[0] * 0.3 + rgb[1] * 0.59 + rgb[2] * 0.11;
    return Color.rgb(val, val, val);
  },
  fade: function fade(ratio) {
    return this.alpha(this.valpha - this.valpha * ratio);
  },
  opaquer: function opaquer(ratio) {
    return this.alpha(this.valpha + this.valpha * ratio);
  },
  rotate: function rotate(degrees) {
    var hsl = this.hsl();
    var hue = hsl.color[0];
    hue = (hue + degrees) % 360;
    hue = hue < 0 ? 360 + hue : hue;
    hsl.color[0] = hue;
    return hsl;
  },
  mix: function mix(mixinColor, weight) {
    // ported from sass implementation in C
    // https://github.com/sass/libsass/blob/0e6b4a2850092356aa3ece07c6b249f0221caced/functions.cpp#L209
    if (!mixinColor || !mixinColor.rgb) {
      throw new Error('Argument to "mix" was not a Color instance, but rather an instance of ' + typeof mixinColor);
    }

    var color1 = mixinColor.rgb();
    var color2 = this.rgb();
    var p = weight === undefined ? 0.5 : weight;
    var w = 2 * p - 1;
    var a = color1.alpha() - color2.alpha();
    var w1 = ((w * a === -1 ? w : (w + a) / (1 + w * a)) + 1) / 2.0;
    var w2 = 1 - w1;
    return Color.rgb(w1 * color1.red() + w2 * color2.red(), w1 * color1.green() + w2 * color2.green(), w1 * color1.blue() + w2 * color2.blue(), color1.alpha() * p + color2.alpha() * (1 - p));
  }
}; // model conversion methods and static constructors

Object.keys(colorConvert).forEach(function (model) {
  if (skippedModels.indexOf(model) !== -1) {
    return;
  }

  var channels = colorConvert[model].channels; // conversion methods

  Color.prototype[model] = function () {
    if (this.model === model) {
      return new Color(this);
    }

    if (arguments.length) {
      return new Color(arguments, model);
    }

    var newAlpha = typeof arguments[channels] === 'number' ? channels : this.valpha;
    return new Color(assertArray(colorConvert[this.model][model].raw(this.color)).concat(newAlpha), model);
  }; // 'static' construction methods


  Color[model] = function (color) {
    if (typeof color === 'number') {
      color = zeroArray(_slice.call(arguments), channels);
    }

    return new Color(color, model);
  };
});

function roundTo(num, places) {
  return Number(num.toFixed(places));
}

function roundToPlace(places) {
  return function (num) {
    return roundTo(num, places);
  };
}

function getset(model, channel, modifier) {
  model = Array.isArray(model) ? model : [model];
  model.forEach(function (m) {
    (limiters[m] || (limiters[m] = []))[channel] = modifier;
  });
  model = model[0];
  return function (val) {
    var result;

    if (arguments.length) {
      if (modifier) {
        val = modifier(val);
      }

      result = this[model]();
      result.color[channel] = val;
      return result;
    }

    result = this[model]().color[channel];

    if (modifier) {
      result = modifier(result);
    }

    return result;
  };
}

function maxfn(max) {
  return function (v) {
    return Math.max(0, Math.min(max, v));
  };
}

function assertArray(val) {
  return Array.isArray(val) ? val : [val];
}

function zeroArray(arr, length) {
  for (var i = 0; i < length; i++) {
    if (typeof arr[i] !== 'number') {
      arr[i] = 0;
    }
  }

  return arr;
}

var color = Color;

var isDark = function isDark(colorString) {
  var _color$rgb$object = color(colorString).rgb().object(),
      r = _color$rgb$object.r,
      g = _color$rgb$object.g,
      b = _color$rgb$object.b;

  var brightness = (r * 299 + g * 587 + b * 114) / 1000;
  return brightness < 180 ? true : false;
};

var canUseDOM = !!(typeof window !== "undefined" && window.document && window.document.createElement);

var isIphoneX = function isIphoneX() {
  var dimen = Dimensions.get("window");
  return Platform.OS === "ios" && !Platform.isPad && !Platform.isTVOS && (dimen.height === 812 || dimen.width === 812 || dimen.height === 896 || dimen.width === 896);
};

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};

var asyncToGenerator = function asyncToGenerator(fn) {
  return function () {
    var gen = fn.apply(this, arguments);
    return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);
          var value = info.value;
        } catch (error) {
          reject(error);
          return;
        }

        if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }

      return step("next");
    });
  };
};

var classCallCheck = function classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var defineProperty = function defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var inherits = function inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};

var objectWithoutProperties = function objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var possibleConstructorReturn = function possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

var slicedToArray = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if (Symbol.iterator in Object(arr)) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

var toConsumableArray = function toConsumableArray(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return Array.from(arr);
  }
};

var colorStyles = ["color", "backgroundColor", "borderColor", "borderBottomColor", "borderTopColor"];

var useTheme = function useTheme() {
  return useContext(ThemeContext);
};

var withThemeProps = function withThemeProps(WrappedComponent, name) {
  var WithSubscription = function (_React$Component) {
    inherits(WithSubscription, _React$Component);

    function WithSubscription() {
      classCallCheck(this, WithSubscription);
      return possibleConstructorReturn(this, (WithSubscription.__proto__ || Object.getPrototypeOf(WithSubscription)).apply(this, arguments));
    }

    createClass(WithSubscription, [{
      key: "render",
      value: function render() {
        var themeProps = Object.assign({}, this.props.theme.globals[name], this.props);
        return React__default.createElement(WrappedComponent, themeProps);
      }
    }]);
    return WithSubscription;
  }(React__default.Component);

  WithSubscription.displayName = "withThemeProps(" + getDisplayName(WrappedComponent) + ")";
  return withTheme(WithSubscription);
};

function getDisplayName(WrappedComponent) {
  return WrappedComponent.displayName || WrappedComponent.name || "Component";
}

function isFunction(functionToCheck) {
  return functionToCheck && {}.toString.call(functionToCheck) === "[object Function]";
} // @ts-ignore


function styled(component) {
  return function (arg) {
    return scStyled(component)(function (props) {
      var style = arg || {};

      if (isFunction(style)) {
        style = style(props);
      }

      if (typeof style[0] === "string") {
        console.log({
          isString: true,
          split: style[0].split(":")
        });
      }

      Object.keys(style).map(function (key) {
        if (colorStyles.indexOf(key) > -1) {
          //console.log({ found: key });
          style[key] = props.theme.colors[style[key]] || style[key];
        }

        if (key === "fontSize") {
          style[key] = props.theme.fontSize[style[key]] || style[key];
        }

        if (key === Platform.OS) {
          style = Object.assign({}, style, style[key]);
        }
      });
      delete style["web"];
      delete style["android"];
      delete style["ios"];
      return style;
    });
  };
} // export default function styled(component) {
//   //return scStyled(component);
//   return scStyled(props => {
//     console.log({ propssss: props, component });
//     return <Box as={component} {...props} />;
//   });
// }


Object.keys(scStyled).forEach(function (alias) {
  Object.defineProperty(styled, alias, {
    enumerable: true,
    configurable: false,
    get: function get$$1() {
      return styled(reactNative[alias]);
    }
  });
});

var interpolate = function interpolate(min, max, value) {
  var theVariable = value * 3; // 1 to 100

  var distance = max - min;
  var position = min + theVariable / 100 * distance;
  return position;
};

var isColor = function isColor(col) {
  try {
    color(col).lighten(0.9).toString();
    return true;
  } catch (err) {
    return false;
  }
};

var getStyle = function getStyle(_ref) {
  var theme = _ref.theme,
      type = _ref.type,
      shadow = _ref.shadow,
      shadowColor = _ref.shadowColor,
      _ref$shadowCasting = _ref.shadowCasting,
      shadowCasting = _ref$shadowCasting === undefined ? "bottom" : _ref$shadowCasting,
      lighten = _ref.lighten,
      darken = _ref.darken,
      alpha = _ref.alpha,
      absolute = _ref.absolute,
      relative = _ref.relative,
      w = _ref.w,
      h = _ref.h,
      t = _ref.t,
      r = _ref.r,
      b = _ref.b,
      l = _ref.l,
      p = _ref.p,
      px = _ref.px,
      py = _ref.py,
      pt = _ref.pt,
      pb = _ref.pb,
      pl = _ref.pl,
      pr = _ref.pr,
      m = _ref.m,
      mx = _ref.mx,
      my = _ref.my,
      mt = _ref.mt,
      mb = _ref.mb,
      ml = _ref.ml,
      mr = _ref.mr;
  var style = {};
  if (absolute) style["position"] = "absolute";
  if (relative) style["position"] = "relative";
  if (w !== undefined) style["width"] = w;
  if (h !== undefined) style["height"] = h;
  if (t !== undefined) style["top"] = t;
  if (r !== undefined) style["right"] = r;
  if (b !== undefined) style["bottom"] = b;
  if (l !== undefined) style["left"] = l;
  if (p !== undefined) style["padding"] = p;
  if (px !== undefined) style["paddingHorizontal"] = px;
  if (py !== undefined) style["paddingVertical"] = py;
  if (pt !== undefined) style["paddingTop"] = pt;
  if (pb !== undefined) style["paddingBottom"] = pb;
  if (pl !== undefined) style["paddingLeft"] = pl;
  if (pr !== undefined) style["paddingRight"] = pr;
  if (m !== undefined) style["margin"] = m;
  if (mx !== undefined) style["marginHorizontal"] = mx;
  if (my !== undefined) style["marginVertical"] = my;
  if (mt !== undefined) style["marginTop"] = mt;
  if (mb !== undefined) style["marginBottom"] = mb;
  if (ml !== undefined) style["marginLeft"] = ml;
  if (mr !== undefined) style["marginRight"] = mr;

  if (type && isColor(type) === true || type && theme.colors[type]) {
    var col = theme.colors[type] || type;

    if (lighten) {
      col = color(col).lighten(lighten).toString();
    }

    if (darken) {
      col = color(col).darken(darken).toString();
    }

    if (alpha) {
      col = color(col).alpha(alpha).toString();
    }

    style["backgroundColor"] = col;
  }

  if (shadow) {
    var ssOffset = shadowCasting === "top" ? -Math.round(shadow / 3) : Math.round(shadow / 3);
    var sCololor = shadowColor || theme.colors.shadow;
    var sRadius = interpolate(1, 20, shadow);
    style["elevation"] = shadow;
    style["boxShadow"] = "0 " + ssOffset + "px " + sRadius + "px " + sCololor;
  } //console.log({ style });


  return style;
};

var Box = styled.View(function (props) {
  return _extends({}, getStyle(props));
});
Box.propTypes = {
  type: PropTypes__default.string,
  lighten: PropTypes__default.number,
  darken: PropTypes__default.number,
  alpha: PropTypes__default.number,
  style: PropTypes__default.object,
  children: PropTypes__default.node
};
var Icon = styled(Box)(function (_ref) {
  var size = _ref.size;
  return {
    position: "relative",
    width: size,
    height: size
  };
});
var Line = animated(styled.View(function (_ref2) {
  var color = _ref2.color,
      lineWidth = _ref2.lineWidth;
  return {
    position: "absolute",
    backgroundColor: color,
    height: lineWidth
  };
}));
var first = {
  x: {
    rotate: 45,
    width: 100,
    top: 50,
    left: 0
  },
  arrowDown: {
    rotate: 45,
    width: 50,
    top: 50,
    left: 7
  },
  arrowTop: {
    rotate: -45,
    width: 50,
    top: 50,
    left: 7
  },
  plus: {
    rotate: 90,
    width: 100,
    left: 0,
    top: 50
  },
  minus: {
    width: 100,
    left: 0,
    top: 50,
    rotate: 0
  },
  burger: {
    width: 100,
    left: 0,
    top: 35,
    rotate: 0
  }
};
var sec = {
  x: {
    rotate: -45,
    width: 100,
    top: 50,
    left: 0
  },
  arrowDown: {
    rotate: -45,
    width: 50,
    top: 50,
    left: 40
  },
  arrowTop: {
    rotate: 45,
    width: 50,
    top: 50,
    left: 40
  },
  plus: {
    width: 100,
    left: 0,
    top: 50,
    rotate: 0
  },
  burger: {
    width: 100,
    left: 0,
    top: 65,
    rotate: 0
  }
};

var Comp = function Comp(_ref3) {
  var _ref3$size = _ref3.size,
      size = _ref3$size === undefined ? 44 : _ref3$size,
      _ref3$lineWidth = _ref3.lineWidth,
      lineWidth = _ref3$lineWidth === undefined ? 2 : _ref3$lineWidth,
      _ref3$name = _ref3.name,
      name = _ref3$name === undefined ? "x" : _ref3$name,
      onPress = _ref3.onPress,
      _ref3$color = _ref3.color,
      color = _ref3$color === undefined ? "primary" : _ref3$color,
      rest = objectWithoutProperties(_ref3, ["size", "lineWidth", "name", "onPress", "color"]);
  var firstStyle = useSpring({
    to: first[name]
  });
  var secStyle = useSpring({
    to: sec[name]
  });

  if (!first[name]) {
    return null;
  }

  return React__default.createElement(Icon, _extends({
    as: onPress ? TouchableOpacity : undefined,
    onPress: onPress || null,
    activeOpacity: onPress ? 0.8 : undefined,
    size: size
  }, rest), React__default.createElement(Line, {
    position: "absolute",
    color: color,
    lineWidth: lineWidth,
    style: {
      left: firstStyle.left.interpolate(function (l) {
        return l + "%";
      }),
      top: firstStyle.top.interpolate(function (l) {
        return l + "%";
      }),
      width: firstStyle.width.interpolate(function (l) {
        return l + "%";
      }),
      transform: firstStyle.rotate.interpolate(function (l) {
        return [{
          rotate: l + "deg"
        }];
      })
    }
  }), ["minus"].indexOf(name) > -1 ? null : React__default.createElement(Line, {
    position: "absolute",
    color: color,
    lineWidth: lineWidth,
    style: {
      left: secStyle.left.interpolate(function (l) {
        return l + "%";
      }),
      top: secStyle.top.interpolate(function (l) {
        return l + "%";
      }),
      width: secStyle.width.interpolate(function (l) {
        return l + "%";
      }),
      transform: secStyle.rotate.interpolate(function (l) {
        return [{
          rotate: l + "deg"
        }];
      })
    }
  }));
};

var Container = styled.View(function (_ref) {
  var from = _ref.from,
      gap = _ref.gap;
  return {
    position: Platform.OS === "web" ? "fixed" : "absolute",
    left: 0,
    bottom: from === "bottom" ? 0 : "auto",
    top: from === "top" ? 0 : "auto",
    width: "100%",
    zIndex: 500,
    paddingHorizontal: gap,
    paddingVertical: isIphoneX() ? gap / 2 + 25 : gap / 2
  };
});
var Message = animated(styled(Box)(function (_ref2) {
  var theme = _ref2.theme,
      gap = _ref2.gap,
      maxWidth = _ref2.maxWidth;
  return {
    flexBasis: "100%",
    alignItems: "center",
    justifyContent: "space-between",
    flexDirection: "row",
    marginVertical: gap / 2,
    width: "100%",
    maxWidth: maxWidth,
    alignSelf: "center",
    borderRadius: theme.globals.roundness
  };
}));
var Text$1 = styled.Text(function (_ref3) {
  var color = _ref3.color;
  return {
    maxWidth: 400,
    width: "100%",
    padding: 20,
    color: color
  };
});
var id = 0;

function Alert(_ref4) {
  var alert = _ref4.alert,
      _ref4$timeout = _ref4.timeout,
      timeout = _ref4$timeout === undefined ? 2000 : _ref4$timeout,
      _ref4$from = _ref4.from,
      from = _ref4$from === undefined ? "top" : _ref4$from,
      _ref4$gap = _ref4.gap,
      gap = _ref4$gap === undefined ? 15 : _ref4$gap,
      _ref4$maxWidth = _ref4.maxWidth,
      maxWidth = _ref4$maxWidth === undefined ? 700 : _ref4$maxWidth,
      rest = objectWithoutProperties(_ref4, ["alert", "timeout", "from", "gap", "maxWidth"]);
  var theme = useTheme();

  var _useState = useState([]),
      _useState2 = slicedToArray(_useState, 2),
      items = _useState2[0],
      setItems = _useState2[1];

  var transitions = useTransition(items, function (items) {
    return items.key;
  }, {
    from: {
      opacity: 0,
      top: from === "bottom" ? 30 : -30
    },
    enter: {
      opacity: 1,
      top: 0
    },
    leave: {
      opacity: 0,
      top: from === "bottom" ? 30 : -30
    },
    onRest: function onRest(item) {
      return setTimeout(function () {
        setItems(function (state) {
          return state.filter(function (i) {
            return i.key !== item.key;
          });
        });
      }, timeout);
    }
  });
  useEffect(function () {
    if (alert) {
      if (from === "bottom") {
        setItems(function (state) {
          return [].concat(toConsumableArray(state), [{
            key: id++,
            message: alert.message,
            type: alert.type
          }]);
        });
      } else {
        setItems(function (state) {
          return [{
            key: id++,
            message: alert.message,
            type: alert.type
          }].concat(toConsumableArray(state));
        });
      }
    }
  }, [alert, from]);
  return React__default.createElement(Container, _extends({
    from: from,
    gap: gap,
    pointerEvents: "box-none"
  }, rest), from === "top" ? React__default.createElement(SafeAreaView, {
    collapsable: false
  }) : null, transitions.map(function (_ref5) {
    var item = _ref5.item,
        props = _ref5.props,
        key = _ref5.key;
    return React__default.createElement(Message, {
      type: item.type || "surface",
      key: key,
      style: props,
      from: from,
      gap: gap,
      maxWidth: maxWidth,
      shadow: 3
    }, React__default.createElement(Text$1, {
      color: isDark(theme.colors[item.type || "surface"]) ? "#FFF" : "#000"
    }, item.message), React__default.createElement(Comp, {
      style: {
        position: "absolute",
        top: 17,
        right: 15
      },
      size: 20,
      color: isDark(theme.colors[item.type || "surface"]) ? "#FFF" : "#000",
      onPress: function onPress(e) {
        e.stopPropagation();
        setItems(function (state) {
          return state.filter(function (i) {
            return i.key !== item.key;
          });
        });
      }
    }));
  }));
}

Alert.propTypes = {
  alert: object,
  timeout: number,
  from: string,
  gap: number,
  maxWidth: number
}; //      
// An event handler can take an optional event argument
// and should not return a value
// An array of all currently registered event handlers for a type
// A map of event types and their corresponding event handlers.

/** Mitt: Tiny (~200b) functional event emitter / pubsub.
 *  @name mitt
 *  @returns {Mitt}
 */

function mitt(all) {
  all = all || Object.create(null);
  return {
    /**
     * Register an event handler for the given type.
     *
     * @param  {String} type	Type of event to listen for, or `"*"` for all events
     * @param  {Function} handler Function to call in response to given event
     * @memberOf mitt
     */
    on: function on(type, handler) {
      (all[type] || (all[type] = [])).push(handler);
    },

    /**
     * Remove an event handler for the given type.
     *
     * @param  {String} type	Type of event to unregister `handler` from, or `"*"`
     * @param  {Function} handler Handler function to remove
     * @memberOf mitt
     */
    off: function off(type, handler) {
      if (all[type]) {
        all[type].splice(all[type].indexOf(handler) >>> 0, 1);
      }
    },

    /**
     * Invoke all handlers for the given type.
     * If present, `"*"` handlers are invoked after type-matched handlers.
     *
     * @param {String} type  The event type to invoke
     * @param {Any} [evt]  Any value (object is recommended and powerful), passed to each handler
     * @memberOf mitt
     */
    emit: function emit(type, evt) {
      (all[type] || []).slice().map(function (handler) {
        handler(evt);
      });
      (all['*'] || []).slice().map(function (handler) {
        handler(type, evt);
      });
    }
  };
}

if (!PropTypes__default) console.warn("<react-native-portal> no PropTypes available");
var oContextTypes = {
  portalSub: PropTypes__default.func,
  portalUnsub: PropTypes__default.func,
  portalSet: PropTypes__default.func,
  portalGet: PropTypes__default.func
};

var PortalProvider = function (_React$Component) {
  inherits(PortalProvider, _React$Component);

  function PortalProvider() {
    var _ref;

    var _temp, _this, _ret;

    classCallCheck(this, PortalProvider);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = PortalProvider.__proto__ || Object.getPrototypeOf(PortalProvider)).call.apply(_ref, [this].concat(args))), _this), _this.portals = new Map(), _this.portalSub = function (name, callback) {
      var emitter = _this._emitter;

      if (emitter) {
        emitter.on(name, callback);
      }
    }, _this.portalUnsub = function (name, callback) {
      var emitter = _this._emitter;

      if (emitter) {
        emitter.off(name, callback);
      }
    }, _this.portalSet = function (name, value) {
      _this.portals.set(name, value);

      if (_this._emitter) {
        _this._emitter.emit(name);
      }
    }, _this.portalGet = function (name) {
      return _this.portals.get(name) || null;
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  createClass(PortalProvider, [{
    key: "getChildContext",
    value: function getChildContext() {
      return {
        portalSub: this.portalSub,
        portalUnsub: this.portalUnsub,
        portalSet: this.portalSet,
        portalGet: this.portalGet
      };
    }
  }, {
    key: "componentWillMount",
    value: function componentWillMount() {
      this._emitter = new mitt();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this._emitter = null;
    } // 변경시 통지 요청 등록
    // 변경시 통지 요청 해제
    // 변경

  }, {
    key: "render",
    // 변경
    value: function render() {
      return this.props.children;
    }
  }]);
  return PortalProvider;
}(React__default.Component);

PortalProvider.childContextTypes = oContextTypes;

var BlackPortal = function (_React$PureComponent) {
  inherits(BlackPortal, _React$PureComponent);

  function BlackPortal() {
    classCallCheck(this, BlackPortal);
    return possibleConstructorReturn(this, (BlackPortal.__proto__ || Object.getPrototypeOf(BlackPortal)).apply(this, arguments));
  }

  createClass(BlackPortal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _props = this.props,
          name = _props.name,
          children = _props.children;
      var portalSet = this.context.portalSet;
      portalSet && portalSet(name, children);
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(newProps) {
      var oldProps = this.props;
      var name = newProps.name,
          children = newProps.children;
      var portalSet = this.context.portalSet;

      if (oldProps.children != newProps.children) {
        portalSet && portalSet(name, children);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var name = this.props.name;
      var portalSet = this.context.portalSet;
      portalSet && portalSet(name, null);
    }
  }, {
    key: "render",
    value: function render() {
      var name = this.props.name;
      return null;
    }
  }]);
  return BlackPortal;
}(React__default.PureComponent);

BlackPortal.contextTypes = oContextTypes;

var WhitePortal = function (_React$PureComponent2) {
  inherits(WhitePortal, _React$PureComponent2);

  function WhitePortal() {
    var _ref2;

    var _temp2, _this3, _ret2;

    classCallCheck(this, WhitePortal);

    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return _ret2 = (_temp2 = (_this3 = possibleConstructorReturn(this, (_ref2 = WhitePortal.__proto__ || Object.getPrototypeOf(WhitePortal)).call.apply(_ref2, [this].concat(args))), _this3), _this3.forceUpdater = function () {
      return _this3.forceUpdate();
    }, _temp2), possibleConstructorReturn(_this3, _ret2);
  }

  createClass(WhitePortal, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      var name = this.props.name;
      var portalSub = this.context.portalSub;
      portalSub && portalSub(name, this.forceUpdater);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var name = this.props.name;
      var portalUnsub = this.context.portalUnsub;
      portalUnsub && portalUnsub(name, this.forceUpdater);
    }
  }, {
    key: "render",
    value: function render() {
      var _props2 = this.props,
          name = _props2.name,
          children = _props2.children,
          childrenProps = _props2.childrenProps;
      var portalGet = this.context.portalGet;
      var portalChildren = portalGet && portalGet(name) || children;
      return (childrenProps && portalChildren ? React__default.cloneElement(React__default.Children.only(portalChildren), childrenProps) : portalChildren) || null;
    }
  }]);
  return WhitePortal;
}(React__default.PureComponent);

WhitePortal.contextTypes = oContextTypes;

function isObject(item) {
  return item && (typeof item === "undefined" ? "undefined" : _typeof(item)) === "object" && !Array.isArray(item);
}

function mergeDeep(target) {
  for (var _len = arguments.length, sources = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    sources[_key - 1] = arguments[_key];
  }

  if (!sources.length) return target;
  var source = sources.shift();

  if (isObject(target) && isObject(source)) {
    for (var key in source) {
      if (isObject(source[key])) {
        if (!target[key]) Object.assign(target, defineProperty({}, key, {}));
        mergeDeep(target[key], source[key]);
      } else {
        Object.assign(target, defineProperty({}, key, source[key]));
      }
    }
  }

  return mergeDeep.apply(undefined, [target].concat(sources));
}

var primary = "#673fb4";
var DefaultTheme = {
  colors: {
    primary: primary,
    background: color(primary).alpha(0.1).toString(),
    accent: "",
    text: color(primary).darken(0.6).toString(),
    surface: "#FFF",
    placeholder: "",
    success: "#8bc34a",
    warning: "#ffbb33",
    error: "#f44336",
    shadow: "rgba(0,0,0,0.1)"
  },
  fontSize: {
    h1: 30,
    h2: 25,
    h3: 20,
    h4: 18,
    h5: 16,
    p: 16,
    caption: 10,
    label: 12
  },
  breaks: {
    mobile: 768,
    tablet: 1024,
    desktop: 99999
  },
  globals: {
    borderRadius: 3,
    roundness: 5
  }
};

var ThemeProvider$1 = function ThemeProvider$1(_ref) {
  var children = _ref.children,
      _ref$theme = _ref.theme,
      theme = _ref$theme === undefined ? {} : _ref$theme,
      _ref$alertProps = _ref.alertProps,
      alertProps = _ref$alertProps === undefined ? {} : _ref$alertProps;

  var _useState = useState(null),
      _useState2 = slicedToArray(_useState, 2),
      alert = _useState2[0],
      setAlert = _useState2[1];

  var _useState3 = useState(function () {
    return mergeDeep(_extends({}, DefaultTheme, {
      alert: function alert(obj) {
        setAlert(obj);
      }
    }), theme);
  }),
      _useState4 = slicedToArray(_useState3, 2),
      defaultTheme = _useState4[0],
      setTheme = _useState4[1];

  var dimensionHandler = function dimensionHandler(_ref2) {
    var window = _ref2.window,
        screen = _ref2.screen;
    setTheme(_extends({}, defaultTheme, {
      window: window,
      screen: screen
    }));
  };

  useEffect(function () {
    dimensionHandler({
      window: Dimensions.get("window"),
      screen: Dimensions.get("screen")
    });
    Dimensions.addEventListener("change", dimensionHandler);
    return function () {
      Dimensions.removeEventListener("change", dimensionHandler);
    };
  }, []);
  return React__default.createElement(PortalProvider, null, React__default.createElement(ThemeProvider, {
    theme: defaultTheme
  }, React__default.createElement(Fragment, null, children, React__default.createElement(Alert, _extends({
    alert: alert
  }, alertProps)), React__default.createElement(WhitePortal, {
    name: "unikit"
  }))));
};

var getStyle$1 = function getStyle(props) {
  var style = {};

  if (props.align) {
    style["alignItems"] = props.align;
  }

  if (props.content) {
    style["justifyContent"] = props.content;
  }

  if (props.wrap) {
    style["flexWrap"] = "wrap";
  }

  if (props.row) {
    style["flexDirection"] = "row";
  }

  return style;
};

var Flex = styled(Box)(function (props) {
  return _extends({}, getStyle$1(props));
});

var Visible = function (_Component) {
  inherits(Visible, _Component);

  function Visible(props) {
    classCallCheck(this, Visible);

    var _this = possibleConstructorReturn(this, (Visible.__proto__ || Object.getPrototypeOf(Visible)).call(this, props));

    _this.startWatching = function () {
      var offset = _this.props.offset;

      if (_this.interval) {
        return;
      }

      _this.interval = setInterval(function () {
        if (!_this.myview) {
          return;
        }

        _this.myview.measure(function (x, y, width, height, pageX, pageY) {
          _this.setState({
            rectTop: pageY + offset,
            rectBottom: pageY + height + offset,
            rectWidth: pageX + width
          });
        });

        _this.isInViewPort();
      }, _this.props.delay || 100);
    };

    _this.state = {
      rectTop: 0,
      rectBottom: 0,
      isVisible: false
    };
    return _this;
  }

  createClass(Visible, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (!this.props.disabled) {
        this.startWatching();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.stopWatching();
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.disabled) {
        this.stopWatching();
      } else {
        this.lastValue = null;
        this.startWatching();
      }
    }
  }, {
    key: "stopWatching",
    value: function stopWatching() {
      this.interval = clearInterval(this.interval);
    }
  }, {
    key: "isInViewPort",
    value: function isInViewPort() {
      var window = Dimensions.get("window");
      var isVisible = this.state.rectBottom != 0 && this.state.rectTop >= 0 && this.state.rectBottom <= window.height;

      if (this.lastValue !== isVisible) {
        this.lastValue = isVisible;
        this.setState({
          isVisible: isVisible
        });
        if (isVisible && this.props.stayVisible) this.stopWatching();
        if (this.props.onChange) this.props.onChange(isVisible);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      return React__default.createElement(View, _extends({
        collapsable: false,
        ref: function ref(component) {
          _this2.myview = component;
        }
      }, this.props), this.props.children instanceof Function ? this.props.children({
        isVisible: this.state.isVisible
      }) : this.props.children);
    }
  }]);
  return Visible;
}(Component);

var ImageWrap = styled(Box)({
  backgroundColor: "surface",
  maxWidth: "100%"
});
var Animate = animated(styled.View({
  position: "absolute",
  top: 0,
  bottom: 0,
  left: 0,
  right: 0
}));

function Image$1(_ref) {
  var source = _ref.source,
      thumbSource = _ref.thumbSource,
      width = _ref.width,
      height = _ref.height,
      _ref$blurRadius = _ref.blurRadius,
      blurRadius = _ref$blurRadius === undefined ? 10 : _ref$blurRadius,
      style = _ref.style,
      _ref$lazy = _ref.lazy,
      lazy = _ref$lazy === undefined ? false : _ref$lazy,
      rest = objectWithoutProperties(_ref, ["source", "thumbSource", "width", "height", "blurRadius", "style", "lazy"]);

  var _useState = useState(true),
      _useState2 = slicedToArray(_useState, 2),
      imgLoading = _useState2[0],
      setImgLoading = _useState2[1];

  var _useState3 = useState(true),
      _useState4 = slicedToArray(_useState3, 2),
      thumbLoading = _useState4[0],
      setThumbLoading = _useState4[1];

  var _useState5 = useState(width || 0),
      _useState6 = slicedToArray(_useState5, 2),
      imgWidth = _useState6[0],
      setWidth = _useState6[1];

  var _useState7 = useState(0),
      _useState8 = slicedToArray(_useState7, 2),
      aspect = _useState8[0],
      setAspect = _useState8[1];

  var _useState9 = useState(0),
      _useState10 = slicedToArray(_useState9, 2),
      aspectHeight = _useState10[0],
      setAspectHeight = _useState10[1];

  useEffect(function () {
    Image.getSize(source.uri, function (w, h) {
      setAspect(h / w);
      setAspectHeight(w / h);
    });
  }, []);
  var imgProps = useSpring({
    opacity: imgLoading ? 0 : 1,
    config: {
      duration: 250
    }
  });
  var thumbProps = useSpring({
    opacity: thumbLoading ? 0 : 1,
    config: {
      duration: 250
    }
  });
  return React__default.createElement(ImageWrap, _extends({
    onLayout: function onLayout(e) {
      setWidth(e.nativeEvent.layout.width);
    },
    style: _extends({
      width: width || height * aspectHeight || 0,
      height: height || imgWidth * aspect || 0
    }, style)
  }, rest), lazy ? React__default.createElement(Visible, {
    stayVisible: true,
    offset: 100
  }, function (_ref2) {
    var isVisible = _ref2.isVisible;
    return isVisible ? React__default.createElement(Fragment, null, React__default.createElement(Animate, {
      style: {
        opacity: thumbProps.opacity
      }
    }, React__default.createElement(Image, {
      source: thumbSource || source,
      onLoad: function onLoad() {
        return setThumbLoading(false);
      },
      style: {
        width: width || height * aspectHeight || 0,
        height: height || imgWidth * aspect || 0
      },
      blurRadius: blurRadius
    })), React__default.createElement(Animate, {
      style: {
        opacity: imgProps.opacity
      }
    }, React__default.createElement(Image, {
      source: source,
      onLoad: function onLoad() {
        return setImgLoading(false);
      },
      style: {
        width: width || height * aspectHeight || 0,
        height: height || imgWidth * aspect || 0
      }
    }))) : null;
  }) : React__default.createElement(Image, {
    source: source,
    onLoad: function onLoad() {
      return setImgLoading(false);
    },
    style: {
      width: width || height * aspectHeight || 0,
      height: height || imgWidth * aspect || 0
    }
  }));
}

var Txt = styled.Text(function (_ref) {
  var fontSize = _ref.fontSize,
      color = _ref.color,
      level = _ref.level;
  return {
    fontSize: level ? "h" + level : fontSize || "p",
    color: color || "text"
  };
});

function Text$2(_ref2) {
  var children = _ref2.children,
      level = _ref2.level,
      rest = objectWithoutProperties(_ref2, ["children", "level"]);
  return React__default.createElement(Box, _extends({
    as: Txt,
    "aria-level": level,
    accessibilityRole: Platform.OS === "web" && level ? "heading" : undefined,
    level: level
  }, rest), children);
}

var AnimatedView = animated(styled.View({}));
var Animated = animated(styled.Text({
  web: {
    display: "inline-block"
  }
}));

var AnimatedText = function AnimatedText(_ref) {
  var _ref$strings = _ref.strings,
      strings = _ref$strings === undefined ? [] : _ref$strings,
      _ref$level = _ref.level,
      level = _ref$level === undefined ? 1 : _ref$level,
      animateType = _ref.animateType;
  console.log({
    strings: strings
  });
  var transitions = useTransition(strings, function (data) {
    return data;
  }, {
    from: {
      opacity: 0,
      y: 100,
      x: 0
    },
    leave: {
      opacity: 0,
      y: 100,
      x: 0
    },
    enter: {
      opacity: 1,
      y: 0,
      x: 0
    },
    update: {
      opacity: 1,
      y: 0,
      x: 0
    },
    unique: false,
    trail: 400 / strings.length
  });

  if (Platform.OS !== "web") {
    return transitions.map(function (_ref2, index) {
      var item = _ref2.item,
          _ref2$props = _ref2.props,
          opacity = _ref2$props.opacity,
          x = _ref2$props.x,
          y = _ref2$props.y,
          key = _ref2.key;
      return React__default.createElement(AnimatedView, {
        key: key + "-" + index,
        style: {
          opacity: opacity,
          transform: [{
            translateY: y || 0
          }, {
            translateX: x || 0
          }]
        }
      }, React__default.createElement(Text$2, {
        level: level
      }, item, animateType === "word" ? " " : null));
    });
  }

  return transitions.map(function (_ref3, index) {
    var item = _ref3.item,
        _ref3$props = _ref3.props,
        opacity = _ref3$props.opacity,
        x = _ref3$props.x,
        y = _ref3$props.y,
        key = _ref3.key;
    return React__default.createElement(Animated, {
      key: key + "-" + index,
      style: {
        opacity: opacity,
        transform: [{
          translateY: y || 0
        }, {
          translateX: x || 0
        }]
      }
    }, item, animateType === "word" ? " " : null);
  });
};

function Headline(_ref4) {
  var _ref4$level = _ref4.level,
      level = _ref4$level === undefined ? 1 : _ref4$level,
      children = _ref4.children,
      style = _ref4.style,
      animate = _ref4.animate,
      _ref4$animateType = _ref4.animateType,
      animateType = _ref4$animateType === undefined ? "char" : _ref4$animateType,
      onVisible = _ref4.onVisible,
      _ref4$stayVisible = _ref4.stayVisible,
      stayVisible = _ref4$stayVisible === undefined ? true : _ref4$stayVisible,
      _ref4$delay = _ref4.delay,
      from = _ref4.from,
      to = _ref4.to,
      config$$1 = _ref4.config,
      rest = objectWithoutProperties(_ref4, ["level", "children", "style", "animate", "animateType", "onVisible", "stayVisible", "delay", "from", "to", "config"]);

  var _useState = useState(false),
      _useState2 = slicedToArray(_useState, 2),
      visible = _useState2[0],
      setVisible = _useState2[1];

  if (animate) {
    var splittedString = children.split(animateType === "word" ? " " : "");
    return React__default.createElement(Text$2, _extends({}, Platform.OS !== "web" ? {
      as: Box
    } : {}, {
      style: Platform.OS !== "web" ? _extends({}, style, {
        flexDirection: "row"
      }) : style,
      level: level
    }, rest), onVisible ? React__default.createElement(Visible, {
      disabled: visible && stayVisible,
      onChange: function onChange(isVisible) {
        setVisible(isVisible);
      },
      offset: 100
    }, function (_ref5) {
      var isVisible = _ref5.isVisible;
      return React__default.createElement(Text$2, null);
    }) : null, React__default.createElement(AnimatedText, {
      strings: onVisible && visible || !onVisible ? splittedString : [],
      animateType: animateType
    }));
  }

  return React__default.createElement(Text$2, _extends({
    level: level,
    style: style
  }, rest), children);
}

Headline.propTypes = {
  children: PropTypes__default.node,
  as: PropTypes__default.string,
  style: PropTypes__default.object,
  from: PropTypes__default.object,
  to: PropTypes__default.object
};
var isEnabled = false;

if (canUseDOM) {
  var enableHover = function enableHover() {
    if (isEnabled || Date.now() - lastTouchTimestamp < HOVER_THRESHOLD_MS) {
      return;
    }

    isEnabled = true;
  };

  var disableHover = function disableHover() {
    lastTouchTimestamp = Date.now();

    if (isEnabled) {
      isEnabled = false;
    }
  };
  /**
   * Web browsers emulate mouse events (and hover states) after touch events.
   * This code infers when the currently-in-use modality supports hover
   * (including for multi-modality devices) and considers "hover" to be enabled
   * if a mouse movement occurs more than 1 second after the last touch event.
   * This threshold is long enough to account for longer delays between the
   * browser firing touch and mouse events on low-powered devices.
   */


  var HOVER_THRESHOLD_MS = 1000;
  var lastTouchTimestamp = 0;
  document.addEventListener("touchstart", disableHover, true);
  document.addEventListener("touchmove", disableHover, true);
  document.addEventListener("mousemove", enableHover, true);
}

function isHoverEnabled() {
  return isEnabled;
}

var Hoverable = function (_Component) {
  inherits(Hoverable, _Component);

  function Hoverable(props) {
    classCallCheck(this, Hoverable);

    var _this = possibleConstructorReturn(this, (Hoverable.__proto__ || Object.getPrototypeOf(Hoverable)).call(this, props));

    _this.state = {
      isHovered: false,
      showHover: true
    };
    _this._handleMouseEnter = _this._handleMouseEnter.bind(_this);
    _this._handleMouseLeave = _this._handleMouseLeave.bind(_this);
    _this._handleGrant = _this._handleGrant.bind(_this);
    _this._handleRelease = _this._handleRelease.bind(_this);
    return _this;
  }

  createClass(Hoverable, [{
    key: "_handleMouseEnter",
    value: function _handleMouseEnter(e) {
      if (isHoverEnabled() && !this.state.isHovered) {
        var onHoverIn = this.props.onHoverIn;
        if (onHoverIn) onHoverIn();
        this.setState(function (state) {
          return _extends({}, state, {
            isHovered: true
          });
        });
      }
    }
  }, {
    key: "_handleMouseLeave",
    value: function _handleMouseLeave(e) {
      if (this.state.isHovered) {
        var onHoverOut = this.props.onHoverOut;
        if (onHoverOut) onHoverOut();
        this.setState(function (state) {
          return _extends({}, state, {
            isHovered: false
          });
        });
      }
    }
  }, {
    key: "_handleGrant",
    value: function _handleGrant() {
      this.setState(function (state) {
        return _extends({}, state, {
          showHover: false
        });
      });
    }
  }, {
    key: "_handleRelease",
    value: function _handleRelease() {
      this.setState(function (state) {
        return _extends({}, state, {
          showHover: true
        });
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _props = this.props,
          children = _props.children,
          onHoverIn = _props.onHoverIn,
          onHoverOut = _props.onHoverOut;
      var child = typeof children === "function" ? children(this.state.showHover && this.state.isHovered) : children;
      return React__default.cloneElement(React__default.Children.only(child), {
        onMouseEnter: this._handleMouseEnter,
        onMouseLeave: this._handleMouseLeave,
        // prevent hover showing while responder
        onResponderGrant: this._handleGrant,
        onResponderRelease: this._handleRelease,
        // if child is Touchable
        onPressIn: this._handleGrant,
        onPressOut: this._handleRelease
      });
    }
  }]);
  return Hoverable;
}(Component);

Hoverable.propTypes = {
  children: oneOfType([func, element]),
  onHoverIn: func,
  onHoverOut: func
};
var Touchable = styled.TouchableOpacity(function (_ref) {
  var overflow = _ref.overflow;
  return {
    position: "relative",
    overflow: overflow ? "visible" : "hidden"
  };
});
var Ripple = animated(styled.View(function (_ref2) {
  var theme = _ref2.theme,
      size = _ref2.size,
      rippleColor = _ref2.rippleColor;
  return {
    width: size,
    height: size,
    borderRadius: size / 2,
    position: "absolute",
    backgroundColor: color(theme.colors[rippleColor] || rippleColor).darken(0.1).toString(),
    zIndex: 0
  };
}));

function Button(_ref3) {
  var children = _ref3.children,
      _onPress = _ref3.onPress,
      _ref3$size = _ref3.size,
      size = _ref3$size === undefined ? 50 : _ref3$size,
      _ref3$rippleColor = _ref3.rippleColor,
      rippleColor = _ref3$rippleColor === undefined ? "#000" : _ref3$rippleColor,
      _ref3$overflow = _ref3.overflow,
      overflow = _ref3$overflow === undefined ? false : _ref3$overflow,
      rest = objectWithoutProperties(_ref3, ["children", "onPress", "size", "rippleColor", "overflow"]);

  var _useState = useState([]),
      _useState2 = slicedToArray(_useState, 2),
      items = _useState2[0],
      setItems = _useState2[1];

  var transitions = useTransition(items, function (items) {
    return items.key;
  }, {
    from: {
      opacity: 0.25,
      scale: 1
    },
    enter: {
      opacity: 0,
      scale: 1.5
    },
    leave: {
      opacity: 0,
      scale: 2
    },
    onRest: function onRest(item) {
      return setItems(function (state) {
        return state.filter(function (i) {
          return i.key !== item.key;
        });
      });
    }
  });
  return React__default.createElement(Touchable, _extends({
    onPress: function onPress(e) {
      var _e$nativeEvent = e.nativeEvent,
          locationX = _e$nativeEvent.locationX,
          locationY = _e$nativeEvent.locationY;
      if (_onPress) _onPress();
      console.log({
        locationX: locationX,
        locationY: locationY,
        evt: e.nativeEvent
      });
      setItems([].concat(toConsumableArray(items), [{
        locationX: locationX,
        locationY: locationY
      }]));
    }
  }, rest, {
    overflow: overflow,
    activeOpacity: 1,
    pointerEvents: "box-only"
  }), children, transitions.map(function (_ref4) {
    var item = _ref4.item,
        props = _ref4.props,
        key = _ref4.key;
    return React__default.createElement(Ripple, {
      key: "ripple-" + key,
      size: size,
      rippleColor: rippleColor,
      style: {
        left: item ? item.locationX - size / 2 : 0,
        top: item ? item.locationY - size / 2 : 0,
        opacity: props.opacity,
        transform: props.scale.interpolate(function (s) {
          return [{
            scale: s
          }];
        })
      },
      pointerEvents: "none"
    });
  }));
}

Button.propTypes = {
  children: node.isRequired,
  rippleColor: string,
  size: number,
  overflow: bool
};
var AnimatedView$1 = animated(View);

var polarToCartesian = function polarToCartesian(centerX, centerY, radius, angleInDegrees) {
  var angleInRadians = (angleInDegrees - 90) * Math.PI / 180.0;
  return {
    x: centerX + radius * Math.cos(angleInRadians),
    y: centerY + radius * Math.sin(angleInRadians)
  };
};

var circlePath = function circlePath(x, y, radius, startAngle, endAngle) {
  var start = polarToCartesian(x, y, radius, endAngle * 0.9999);
  var end = polarToCartesian(x, y, radius, startAngle);
  var largeArcFlag = endAngle - startAngle <= 180 ? "0" : "1";
  var d = ["M", start.x, start.y, "A", radius, radius, 0, largeArcFlag, 0, end.x, end.y];
  return d.join(" ");
};

var clampFill = function clampFill(fill) {
  return Math.min(100, Math.max(0, fill));
};

var PathComp = function (_React$PureComponent) {
  inherits(PathComp, _React$PureComponent);

  function PathComp() {
    classCallCheck(this, PathComp);
    return possibleConstructorReturn(this, (PathComp.__proto__ || Object.getPrototypeOf(PathComp)).apply(this, arguments));
  }

  createClass(PathComp, [{
    key: "render",
    value: function render() {
      var _props = this.props,
          progress = _props.progress,
          trackWidth = _props.trackWidth,
          circleWidth = _props.circleWidth,
          _props$circleColor = _props.circleColor,
          circleColor = _props$circleColor === undefined ? "primary" : _props$circleColor,
          lineCap = _props.lineCap,
          size = _props.size,
          angle = _props.angle,
          theme = _props.theme;
      return React__default.createElement(Path, {
        d: circlePath(size / 2, size / 2, size / 2 - (circleWidth >= trackWidth ? circleWidth : trackWidth) / 2, 0, angle * clampFill(progress) / 100),
        strokeWidth: circleWidth,
        strokeLinecap: lineCap,
        fill: "transparent",
        style: {
          stroke: theme.colors[circleColor] || circleColor
        }
      });
    }
  }]);
  return PathComp;
}(React__default.PureComponent);

var AnimatedPath = animated(PathComp);

function Progress(props) {
  var _props$value = props.value,
      value = _props$value === undefined ? 0 : _props$value,
      _props$size = props.size,
      size = _props$size === undefined ? 44 : _props$size,
      _props$trackWidth = props.trackWidth,
      trackWidth = _props$trackWidth === undefined ? 8 : _props$trackWidth,
      _props$trackColor = props.trackColor,
      trackColor = _props$trackColor === undefined ? "background" : _props$trackColor,
      _props$circleWidth = props.circleWidth,
      circleWidth = _props$circleWidth === undefined ? 6 : _props$circleWidth,
      _props$circleColor2 = props.circleColor,
      _props$loading = props.loading,
      loading = _props$loading === undefined ? false : _props$loading,
      _props$lineCap = props.lineCap,
      lineCap = _props$lineCap === undefined ? "round" : _props$lineCap,
      _props$angle = props.angle,
      angle = _props$angle === undefined ? 360 : _props$angle,
      style = props.style,
      _props$rotate = props.rotate,
      rotate = _props$rotate === undefined ? 0 : _props$rotate,
      rest = objectWithoutProperties(props, ["value", "size", "trackWidth", "trackColor", "circleWidth", "circleColor", "loading", "lineCap", "angle", "style", "rotate"]);
  var theme = useTheme();

  var _useState = useState(1),
      _useState2 = slicedToArray(_useState, 2),
      running = _useState2[0],
      setRunning = _useState2[1]; // 0 reset, 1 run


  useEffect(function () {
    if (running === 0) {
      setRunning(1);
    }
  }, [running === 0]);

  var _useSpring = useSpring({
    from: {
      bla: 0
    },
    to: {
      bla: value || 0
    },
    config: {
      duration: 300
    }
  }),
      bla = _useSpring.bla;

  var _useSpring2 = useSpring({
    from: {
      loadingRotate: 0
    },
    to: {
      loadingRotate: 360
    },
    reset: running === 0,
    onRest: function onRest() {
      return loading ? setRunning(0) : null;
    },
    config: {
      duration: 1000
    }
  }),
      loadingRotate = _useSpring2.loadingRotate; //   const loops = 1;
  //   const { loadingRotate } = useSpring({
  //     from: { loadingRotate: 0 },
  //     to: async next => {
  //       while (1) {
  //         await next({ loadingRotate: loops * 360 });
  //         await next({ loadingRotate: 0 });
  //       }
  //     },
  //     onRest: () => loops++
  //   });


  var backgroundPath = circlePath(size / 2, size / 2, size / 2 - (circleWidth >= trackWidth ? circleWidth : trackWidth) / 2, 0, angle);
  return React__default.createElement(AnimatedView$1, _extends({
    style: loading ? {
      width: size,
      height: size,
      transform: loadingRotate.interpolate(function (l) {
        return [{
          rotate: l + 150 + "deg"
        }];
      })
    } : {
      width: size,
      height: size,
      transform: [{
        rotate: rotate + "deg"
      }]
    },
    inline: true
  }, rest), React__default.createElement(Svg, {
    width: size,
    height: size,
    style: {
      backgroundColor: "transparent"
    }
  }, React__default.createElement(G, {
    rotate: rotate,
    originX: size / 2,
    originY: size / 2
  }, React__default.createElement(Path, _extends({
    d: backgroundPath,
    strokeWidth: trackWidth,
    strokeLinecap: lineCap,
    fill: "transparent",
    strokeDashoffset: 50,
    style: {
      stroke: theme.colors[trackColor] || trackColor
    }
  }, rest)), React__default.createElement(AnimatedPath, _extends({}, props, {
    theme: theme,
    trackWidth: trackWidth,
    circleWidth: circleWidth,
    lineCap: lineCap,
    size: size,
    angle: angle,
    progress: loading ? 30 : bla
  })))));
}

Progress.propTypes = {
  value: PropTypes__default.number,
  trackWidth: PropTypes__default.number,
  circleWidth: PropTypes__default.number,
  rotate: PropTypes__default.number,
  angle: PropTypes__default.number,
  size: PropTypes__default.number,
  trackColor: PropTypes__default.string,
  lineCap: PropTypes__default.string,
  circleColor: PropTypes__default.string,
  loading: PropTypes__default.bool,
  style: PropTypes__default.object
};

var getBackground = function getBackground(_ref) {
  var type = _ref.type,
      theme = _ref.theme,
      isHovered = _ref.isHovered,
      outlined = _ref.outlined,
      light = _ref.light;

  if (outlined) {
    return isHovered ? color(theme.colors[type] || type).alpha(0.1).toString() : "transparent";
  }

  if (light) {
    return isHovered ? color(theme.colors[type] || type).alpha(0.15).toString() : color(theme.colors[type] || type).alpha(0.1).toString();
  }

  return isHovered ? color(theme.colors[type] || type).darken(0.1).toString() : theme.colors[type] || type;
};

var Touchable$1 = styled(Box)(function (_ref2) {
  var theme = _ref2.theme,
      size = _ref2.size,
      isHovered = _ref2.isHovered,
      outlined = _ref2.outlined,
      rounded = _ref2.rounded,
      light = _ref2.light,
      type = _ref2.type;
  return {
    position: "relative",
    flexDirection: "row",
    width: "auto",
    height: size,
    paddingHorizontal: size / 2,
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: getBackground({
      type: type,
      theme: theme,
      outlined: outlined,
      isHovered: isHovered,
      light: light
    }),
    borderWidth: outlined ? 3 : 0,
    borderColor: theme.colors[type] || type,
    borderRadius: rounded ? size : theme.globals.roundness,
    web: {
      cursor: "pointer"
    }
  };
});
var Label = styled.Text(function (_ref3) {
  var type = _ref3.type,
      theme = _ref3.theme,
      textColor = _ref3.textColor,
      outlined = _ref3.outlined,
      light = _ref3.light,
      size = _ref3.size;
  return {
    fontSize: size / 3,
    color: textColor
  };
});
var LoadingWrap = styled.View({
  position: "absolute",
  left: 0,
  top: 0,
  right: 0,
  bottom: 0,
  alignItems: "center",
  justifyContent: "center"
});

function Button$1(_ref4) {
  var children = _ref4.children,
      _ref4$size = _ref4.size,
      size = _ref4$size === undefined ? 44 : _ref4$size,
      _ref4$type = _ref4.type,
      type = _ref4$type === undefined ? "primary" : _ref4$type,
      _ref4$activeOpacity = _ref4.activeOpacity,
      activeOpacity = _ref4$activeOpacity === undefined ? 0.9 : _ref4$activeOpacity,
      _ref4$outlined = _ref4.outlined,
      outlined = _ref4$outlined === undefined ? false : _ref4$outlined,
      _ref4$rounded = _ref4.rounded,
      rounded = _ref4$rounded === undefined ? false : _ref4$rounded,
      _ref4$light = _ref4.light,
      light = _ref4$light === undefined ? false : _ref4$light,
      color$$1 = _ref4.color,
      _ref4$labelProps = _ref4.labelProps,
      labelProps = _ref4$labelProps === undefined ? {} : _ref4$labelProps,
      _ref4$ripple = _ref4.ripple,
      ripple = _ref4$ripple === undefined ? false : _ref4$ripple,
      _ref4$loading = _ref4.loading,
      loading = _ref4$loading === undefined ? false : _ref4$loading,
      _ref4$disabled = _ref4.disabled,
      disabled = _ref4$disabled === undefined ? false : _ref4$disabled,
      progress = _ref4.progress,
      _ref4$renderLeft = _ref4.renderLeft,
      renderLeft = _ref4$renderLeft === undefined ? null : _ref4$renderLeft,
      _ref4$renderRight = _ref4.renderRight,
      renderRight = _ref4$renderRight === undefined ? null : _ref4$renderRight,
      rest = objectWithoutProperties(_ref4, ["children", "size", "type", "activeOpacity", "outlined", "rounded", "light", "color", "labelProps", "ripple", "loading", "disabled", "progress", "renderLeft", "renderRight"]);
  var theme = useTheme();
  var textColor = color$$1 ? color$$1 : outlined || light ? theme.colors[type] || type : isDark(theme.colors[type] || type) ? "#FFF" : "#000";
  return createElement$1(Hoverable, null, function (isHovered) {
    return createElement$1(Touchable$1, _extends({
      as: ripple ? Button : TouchableOpacity,
      isHovered: isHovered,
      activeOpacity: activeOpacity,
      size: size,
      outlined: outlined ? 1 : 0,
      rounded: rounded ? 1 : 0,
      light: light ? 1 : 0,
      type: type,
      rippleColor: ripple ? type : undefined,
      disabled: loading ? true : disabled
    }, rest), loading || progress ? createElement$1(LoadingWrap, null, createElement$1(Progress, {
      trackColor: "transparent",
      circleColor: textColor,
      size: size / 2,
      circleWidth: 2,
      value: progress,
      loading: loading
    })) : null, renderLeft, typeof children === "string" ? createElement$1(Label, _extends({
      textColor: loading === true || progress < 100 ? "transparent" : textColor,
      outlined: outlined ? 1 : 0,
      light: light ? 1 : 0,
      size: size,
      type: type
    }, labelProps), children) : children, renderRight);
  });
}

Button$1.propTypes = {
  children: node.isRequired,
  onPress: func,
  size: number,
  type: string,
  color: string,
  labelStyle: object,
  labelProps: object,
  outlined: bool,
  rounded: bool,
  light: bool,
  ripple: bool,
  loading: bool,
  progress: number
};
var safePan = {
  bottom: {
    paddingTop: 20,
    paddingBottom: isIphoneX() ? 30 : 0
  },
  center: {},
  left: {
    paddingRight: 20
  },
  right: {
    paddingLeft: 20
  },
  top: {
    paddingBottom: 20,
    paddingTop: isIphoneX() ? 30 : 0
  }
};
var flexStyle = {
  bottom: {
    justifyContent: "flex-end",
    alignItems: "center"
  },
  top: {
    justifyContent: "flex-end",
    alignItems: "center"
  },
  left: {
    justifyContent: "center",
    alignItems: "flex-start"
  },
  right: {
    justifyContent: "center",
    alignItems: "flex-end"
  },
  center: {
    justifyContent: "center",
    alignItems: "center"
  }
};
var panStyle = {
  bottom: {
    top: 10,
    left: "50%",
    width: 50,
    height: 7,
    marginLeft: -25
  },
  center: {
    top: 10,
    left: "50%",
    width: 50,
    height: 7,
    marginLeft: -25
  },
  left: {
    right: 10,
    top: "50%",
    width: 7,
    height: 50,
    marginTop: -25
  },
  right: {
    left: 10,
    top: "50%",
    width: 7,
    height: 50,
    marginTop: -25
  },
  top: {
    bottom: 10,
    left: "50%",
    width: 50,
    height: 7,
    marginLeft: -25
  }
};
var Overlay = animated$1(styled.View(function (_ref) {
  var theme = _ref.theme,
      overlayPosition = _ref.overlayPosition,
      zIndex = _ref.zIndex;
  return _extends({
    width: "100%",
    height: "100%",
    position: Platform.OS === "web" ? "fixed" : "absolute",
    left: 0,
    bottom: 0,
    zIndex: zIndex + 10
  }, flexStyle[overlayPosition]);
}));
var OverlayContent = styled(Box)(function (_ref2) {
  var theme = _ref2.theme,
      roundness = _ref2.roundness,
      width = _ref2.width,
      height = _ref2.height,
      overlayPosition = _ref2.overlayPosition;
  return _extends({
    position: "relative",
    width: width,
    height: height,
    maxHeight: "100%",
    maxWidth: "100%",
    borderRadius: roundness || theme.globals.roundness
  }, safePan[overlayPosition]);
});
var Backdrop = animated$1(styled.View(function (_ref3) {
  var zIndex = _ref3.zIndex,
      theme = _ref3.theme;
  return {
    position: Platform.OS === "web" ? "fixed" : "absolute",
    left: 0,
    bottom: 0,
    top: 0,
    right: 0,
    backgroundColor: "rgba(0,0,0,0.1)",
    zIndex: zIndex + 5
  };
}));
var Pan = styled.View(function (_ref4) {
  var overlayPosition = _ref4.overlayPosition;
  return _extends({
    position: "absolute",
    backgroundColor: "background",
    borderRadius: 4
  }, panStyle[overlayPosition]);
});

var Comp$1 = function Comp(_ref5) {
  var _ref5$width = _ref5.width,
      width = _ref5$width === undefined ? "100%" : _ref5$width,
      height = _ref5.height,
      _ref5$position = _ref5.position,
      position = _ref5$position === undefined ? "center" : _ref5$position,
      visible = _ref5.visible,
      children = _ref5.children,
      onClose = _ref5.onClose,
      content = _ref5.content,
      _ref5$backdrop = _ref5.backdrop,
      backdrop = _ref5$backdrop === undefined ? true : _ref5$backdrop,
      contentMove = _ref5.contentMove,
      contentMoveStyle = _ref5.contentMoveStyle,
      containerStyle = _ref5.containerStyle,
      _ref5$usePan = _ref5.usePan,
      usePan = _ref5$usePan === undefined ? false : _ref5$usePan,
      _ref5$shadow = _ref5.shadow,
      shadow = _ref5$shadow === undefined ? 15 : _ref5$shadow,
      overlayContentProps = _ref5.overlayContentProps,
      backdropProps = _ref5.backdropProps,
      roundness = _ref5.roundness,
      _ref5$zIndex = _ref5.zIndex,
      zIndex = _ref5$zIndex === undefined ? 5000 : _ref5$zIndex,
      _ref5$portal = _ref5.portal,
      portal = _ref5$portal === undefined ? true : _ref5$portal,
      _ref5$config = _ref5.config,
      config$$1 = _ref5$config === undefined ? {} : _ref5$config,
      rest = objectWithoutProperties(_ref5, ["width", "height", "position", "visible", "children", "onClose", "content", "backdrop", "contentMove", "contentMoveStyle", "containerStyle", "usePan", "shadow", "overlayContentProps", "backdropProps", "roundness", "zIndex", "portal", "config"]);
  var theme = useTheme();

  var _useState = useState(visible),
      _useState2 = slicedToArray(_useState, 2),
      show = _useState2[0],
      set$$1 = _useState2[1];

  useEffect(function () {
    set$$1(visible);
  }, [visible]);
  var moves = {
    bottom: theme.screen ? theme.screen.height : 0,
    center: theme.screen ? 200 : 0,
    top: theme.screen ? -theme.screen.height : 0,
    left: theme.screen ? -theme.screen.width : 0,
    right: theme.screen ? theme.screen.width : 0
  };
  var move = moves[position];
  var transitions = useTransition$1(show, null, {
    from: {
      opacity: 0,
      move: move || 500 //moves[position]

    },
    enter: {
      opacity: 1,
      move: 0
    },
    leave: {
      opacity: 0,
      move: move || 500 //moves[position]

    },
    config: config$$1
  });
  var PortalComp = portal ? BlackPortal : Fragment;
  return React__default.createElement(PortalComp, {
    name: "unikit"
  }, transitions.map(function (_ref6) {
    var item = _ref6.item,
        key = _ref6.key,
        props = _ref6.props;
    return item && React__default.createElement(Fragment, {
      key: key
    }, backdrop ? React__default.createElement(Backdrop, _extends({
      as: TouchableOpacity,
      zIndex: zIndex,
      style: {
        opacity: props.opacity
      },
      pointerEvents: show ? "auto" : "none",
      onPress: onClose,
      activeOpacity: 1
    }, backdropProps)) : null, React__default.createElement(Overlay, {
      style: {
        opacity: position === "center" ? props.opacity : 1,
        transform: props.move.interpolate(function (m) {
          return position === "top" || position === "bottom" || position === "center" ? [{
            translateY: m
          }] : [{
            translateX: m
          }];
        })
      },
      overlayPosition: position,
      pointerEvents: "box-none",
      zIndex: zIndex
    }, React__default.createElement(OverlayContent, _extends({
      type: "surface",
      width: width || theme.width,
      height: height || theme.height,
      pointerEvents: show ? "auto" : "none",
      overlayPosition: position,
      shadow: shadow,
      roundness: roundness
    }, rest), usePan ? React__default.createElement(Pan, {
      overlayPosition: position
    }) : null, children)));
  }));
};

var ThemeComp = withThemeProps(Comp$1, "Overlay");
ThemeComp.propTypes = {
  overlayContentProps: PropTypes__default.object,
  backdropProps: PropTypes__default.object,
  style: PropTypes__default.object
};
var Group = styled(Flex)(function (_ref) {
  var theme = _ref.theme;
  return {
    width: "100%",
    height: "auto",
    justifyContent: "space-between",
    alignItems: "stretch",
    borderRadius: theme.globals.roundness,
    overflow: "hidden"
  };
});

var getBorderRadius = function getBorderRadius(index, length, vertical) {
  if (index === 0) {
    if (vertical) {
      return {
        borderBottomLeftRadius: 0,
        borderBottomRightRadius: 0
      };
    }

    return {
      borderTopRightRadius: 0,
      borderBottomRightRadius: 0
    };
  } else if (index === length - 1) {
    if (vertical) {
      return {
        borderTopRightRadius: 0,
        borderTopLeftRadius: 0
      };
    }

    return {
      borderTopLeftRadius: 0,
      borderBottomLeftRadius: 0
    };
  } else {
    return {
      borderRadius: 0
    };
  }
};

function ButtonGroup(_ref2) {
  var children = _ref2.children,
      _ref2$gap = _ref2.gap,
      gap = _ref2$gap === undefined ? 1 : _ref2$gap,
      _ref2$buttonStyle = _ref2.buttonStyle,
      buttonStyle = _ref2$buttonStyle === undefined ? {} : _ref2$buttonStyle,
      _ref2$vertical = _ref2.vertical,
      vertical = _ref2$vertical === undefined ? false : _ref2$vertical,
      rest = objectWithoutProperties(_ref2, ["children", "gap", "buttonStyle", "vertical"]);
  return React__default.createElement(Group, _extends({
    row: vertical ? false : true
  }, rest), Children.map(children, function (child, i) {
    if (child) {
      return React__default.cloneElement(child, {
        style: _extends({
          flex: vertical ? undefined : 1,
          marginLeft: i === 0 ? 0 : gap,
          marginTop: gap
        }, getBorderRadius(i, React__default.Children.count(children), vertical), buttonStyle, child.props.style)
      });
    }
  }));
}

ButtonGroup.propTypes = {
  children: node.isRequired,
  gap: number,
  buttonStyle: object
};

var Comp$2 = function Comp(props) {
  var _React$createElement;

  var overrides = props.overrides,
      style = props.style,
      _props$actions = props.actions,
      actions = _props$actions === undefined ? [] : _props$actions,
      onActionPress = props.onActionPress,
      onClose = props.onClose,
      _props$cancelText = props.cancelText,
      cancelText = _props$cancelText === undefined ? "Cancel" : _props$cancelText,
      _props$cancelColor = props.cancelColor,
      cancelColor = _props$cancelColor === undefined ? "error" : _props$cancelColor,
      title = props.title,
      desc = props.desc,
      rest = objectWithoutProperties(props, ["overrides", "style", "actions", "onActionPress", "onClose", "cancelText", "cancelColor", "title", "desc"]); //console.log("==>>>>", buttonProps);

  return React__default.createElement(ThemeComp, _extends({
    type: "transparent",
    shadow: 0,
    position: "bottom",
    height: "auto",
    onClose: onClose,
    px: 20
  }, rest), title && React__default.createElement(Headline, null, title), desc && React__default.createElement(Text$2, null, desc), React__default.createElement(ButtonGroup, {
    mb: 6,
    gap: 0,
    shadow: 10,
    vertical: true
  }, actions.map(function (action, index) {
    return React__default.createElement(Button$1, {
      type: "surface",
      alpha: 0.9,
      key: "action-" + index,
      color: "primary",
      style: {
        borderColor: "rgba(0,0,0,0.05)",
        borderBottomWidth: 1
      },
      onPress: function onPress() {
        if (action.onPress) {
          action.onPress();
        }

        if (onActionPress) {
          onActionPress(action);
        }
      }
    }, action.label);
  })), React__default.createElement(Button$1, (_React$createElement = {
    type: "surface",
    color: "error",
    onPress: onClose || null
  }, defineProperty(_React$createElement, "color", cancelColor), defineProperty(_React$createElement, "shadow", 10), defineProperty(_React$createElement, "mb", 20), defineProperty(_React$createElement, "alpha", 0.9), _React$createElement), cancelText));
};

var Box$1 = animated(styled.View());

function Animate$1(props) {
  var _props$from = props.from,
      from = _props$from === undefined ? {
    opacity: 0,
    y: 100,
    x: 0
  } : _props$from,
      _props$to = props.to,
      to = _props$to === undefined ? {
    opacity: 1,
    y: 0,
    x: 0
  } : _props$to,
      children = props.children,
      _props$stayVisible = props.stayVisible,
      stayVisible = _props$stayVisible === undefined ? true : _props$stayVisible,
      onVisible = props.onVisible,
      isVisible = props.isVisible,
      delay = props.delay,
      reset = props.reset,
      reverse = props.reverse,
      config$$1 = props.config,
      style = props.style,
      as = props.as,
      rest = objectWithoutProperties(props, ["from", "to", "children", "stayVisible", "onVisible", "isVisible", "delay", "reset", "reverse", "config", "style", "as"]);

  var _useState = useState(isVisible),
      _useState2 = slicedToArray(_useState, 2),
      visible = _useState2[0],
      setVisible = _useState2[1];

  var _useSpring = useSpring({
    from: from,
    to: !visible && onVisible || isVisible === false ? from : to,
    config: config[config$$1] || config$$1 || config["default"],
    delay: delay || 0,
    reset: reset || false,
    reverse: reverse || false
  }),
      opacity = _useSpring.opacity,
      x = _useSpring.x,
      y = _useSpring.y,
      z = _useSpring.z;

  var AnimatedComp = React__default.createElement(Box$1, _extends({
    as: as,
    style: _extends({}, style, {
      opacity: opacity,
      transform: [{
        translateY: y || 0
      }, {
        translateX: x || 0
      }]
    })
  }, rest), children);

  if (onVisible) {
    return React__default.createElement(Fragment, null, React__default.createElement(Visible, {
      disabled: visible && stayVisible,
      onChange: function onChange(isVisible) {
        setVisible(isVisible);
      },
      offset: 100
    }, function (_ref) {
      var isVisible = _ref.isVisible;
      return React__default.createElement(View, null);
    }), AnimatedComp);
  }

  return AnimatedComp;
}

var Wrap = styled(Box)(function (_ref) {
  var size = _ref.size;
  return {
    justifyContent: "center",
    alignItems: "center",
    height: size,
    width: size,
    borderRadius: size / 2,
    overflow: "hidden",
    web: {
      display: "inline-flex"
    }
  };
});
var BackgroundImage = styled.ImageBackground(function (_ref2) {
  var size = _ref2.size;
  return {
    position: "absolute",
    left: 0,
    top: 0,
    height: size,
    width: size,
    zIndex: 0,
    borderRadius: size / 2
  };
});
var Label$1 = styled.Text(function (_ref3) {
  var theme = _ref3.theme,
      type = _ref3.type,
      textColor = _ref3.textColor,
      size = _ref3.size;
  return {
    color: textColor ? textColor : isDark(theme.colors[type] || type) ? "#FFF" : "#000",
    position: "relative",
    zIndex: 10,
    fontSize: size / 2.77,
    fontWeight: "bold"
  };
});

function Avatar(props) {
  var _props$type = props.type,
      type = _props$type === undefined ? "primary" : _props$type,
      children = props.children,
      _props$size = props.size,
      size = _props$size === undefined ? 44 : _props$size,
      _props$char = props["char"],
      _char2 = _props$char === undefined ? "" : _props$char,
      textColor = props.textColor,
      onPress = props.onPress,
      source = props.source,
      rest = objectWithoutProperties(props, ["type", "children", "size", "char", "textColor", "onPress", "source"]);

  var theme = useTheme();
  return React__default.createElement(Wrap, _extends({
    type: type,
    as: onPress ? Button$1 : undefined,
    onPress: onPress || null,
    activeOpacity: onPress ? 0.8 : undefined,
    size: size
  }, rest), source ? React__default.createElement(BackgroundImage, {
    size: size,
    source: source
  }) : null, children ? children : React__default.createElement(Label$1, {
    size: size,
    textColor: textColor
  }, _char2));
}

Avatar.propTypes = {
  type: PropTypes__default.string,
  "char": PropTypes__default.string,
  size: PropTypes__default.number,
  source: PropTypes__default.object,
  onPress: PropTypes__default.func,
  textColor: PropTypes__default.string,
  style: PropTypes__default.object,
  children: PropTypes__default.node
};
var Grid = styled(Box)(function (_ref) {
  var theme = _ref.theme,
      gap = _ref.gap,
      w = _ref.w;
  return {
    width: w || "100%",
    flexDirection: "row",
    flexWrap: "wrap",
    padding: gap / 2
  };
});
var GridItem = styled.View(function (_ref2) {
  var rowWidth = _ref2.rowWidth,
      gap = _ref2.gap;
  return {
    width: rowWidth + "%",
    flexBasis: rowWidth + "%",
    padding: gap / 2
  };
});

var Grid$1 = function Grid$1(_ref3) {
  var children = _ref3.children,
      _ref3$min = _ref3.min,
      min = _ref3$min === undefined ? 500 : _ref3$min,
      maxRows = _ref3.maxRows,
      _ref3$minRows = _ref3.minRows,
      minRows = _ref3$minRows === undefined ? 1 : _ref3$minRows,
      _ref3$gap = _ref3.gap,
      gap = _ref3$gap === undefined ? 5 : _ref3$gap,
      _ref3$itemStyle = _ref3.itemStyle,
      itemStyle = _ref3$itemStyle === undefined ? {} : _ref3$itemStyle,
      rest = objectWithoutProperties(_ref3, ["children", "min", "maxRows", "minRows", "gap", "itemStyle"]);
  var theme = useTheme();

  var _useState = useState(theme.width || 0),
      _useState2 = slicedToArray(_useState, 2),
      width = _useState2[0],
      setWidth = _useState2[1];

  var _useState3 = useState(theme.width || 0),
      _useState4 = slicedToArray(_useState3, 2),
      rowWidth = _useState4[0],
      setRowWidth = _useState4[1];

  useEffect(function () {
    if (width) {
      var rowCount = Math.ceil(width / min);

      if (rowCount > Children.count(children) && min <= width) {
        rowCount = Children.count(children);
      }

      if (maxRows && rowCount > maxRows) {
        rowCount = maxRows;
      }

      if (minRows && rowCount < minRows) {
        rowCount = minRows;
      }

      var _rowWidth = 100 / rowCount;

      setRowWidth(_rowWidth);
    }
  }, [width]);
  return React__default.createElement(Grid, _extends({
    onLayout: function onLayout(_ref4) {
      var layout = _ref4.nativeEvent.layout;
      setWidth(layout.width);
    },
    gap: gap
  }, rest), Children.map(children, function (child, i) {
    if (child) {
      return React__default.createElement(GridItem, {
        key: i,
        rowWidth: rowWidth,
        gap: gap,
        style: itemStyle
      }, child);
    }
  }));
};

var Page = styled(Box)({});

var index = function index(_ref) {
  var _ref$type = _ref.type,
      type = _ref$type === undefined ? "background" : _ref$type,
      children = _ref.children,
      hasSafeArea = _ref.hasSafeArea,
      scrollable = _ref.scrollable,
      renderHeader = _ref.renderHeader,
      renderFooter = _ref.renderFooter,
      scrollViewProps = _ref.scrollViewProps,
      onScroll = _ref.onScroll,
      rest = objectWithoutProperties(_ref, ["type", "children", "hasSafeArea", "scrollable", "renderHeader", "renderFooter", "scrollViewProps", "onScroll"]);

  var _useState = useState(0),
      _useState2 = slicedToArray(_useState, 2),
      top = _useState2[0],
      setTop = _useState2[1];

  var onScrollPage = function onScrollPage(e) {
    var scrollSensitivity = 4 / 3;
    var offset = e.nativeEvent.contentOffset.y / scrollSensitivity;
    if (onScroll) onScroll(e.nativeEvent.contentOffset);
    setTop(offset);
  };

  var Scroller = scrollable ? ScrollView : Fragment;

  var ScrollerProps = _extends({
    onScroll: onScrollPage,
    scrollEventThrottle: 100
  }, scrollViewProps);

  return React__default.createElement(Page, _extends({
    type: type,
    as: hasSafeArea ? SafeAreaView : undefined
  }, rest), renderHeader ? renderHeader(top) : null, React__default.createElement(Scroller, scrollable ? ScrollerProps : {}, children), renderFooter ? renderFooter(top) : null);
};

var Content = styled(Box)(function (_ref) {
  var vertical = _ref.vertical,
      gap = _ref.gap,
      itemSize = _ref.itemSize;
  return {
    width: vertical ? "100%" : itemSize,
    height: !vertical ? "100%" : itemSize,
    padding: gap / 2
  };
});

var Comp$3 = function Comp(props) {
  var _props$useScrollView = props.useScrollView,
      useScrollView = _props$useScrollView === undefined ? false : _props$useScrollView,
      onSwipe = props.onSwipe,
      onSwipeEnd = props.onSwipeEnd,
      onChangeIndex = props.onChangeIndex,
      index = props.index,
      swipeIndex = props.swipeIndex,
      style = props.style,
      itemSize = props.itemSize,
      children = props.children,
      gap = props.gap,
      scale = props.scale,
      flex = props.flex,
      dots = props.dots,
      dotsPosition = props.dotsPosition,
      dotsOffset = props.dotsOffset,
      autoplay = props.autoplay,
      duration = props.duration,
      _props$vertical = props.vertical,
      vertical = _props$vertical === undefined ? false : _props$vertical,
      _props$updateSwipe = props.updateSwipe,
      updateSwipe = _props$updateSwipe === undefined ? true : _props$updateSwipe,
      rest = objectWithoutProperties(props, ["useScrollView", "onSwipe", "onSwipeEnd", "onChangeIndex", "index", "swipeIndex", "style", "itemSize", "children", "gap", "scale", "flex", "dots", "dotsPosition", "dotsOffset", "autoplay", "duration", "vertical", "updateSwipe"]);
  var scrollRef = useRef(null);
  var theme = useTheme();

  var _useState = useState(index),
      _useState2 = slicedToArray(_useState, 2),
      selectedIndex = _useState2[0],
      setIndex = _useState2[1];

  var _useState3 = useState(itemSize || theme.width || 0),
      _useState4 = slicedToArray(_useState3, 2),
      width = _useState4[0],
      setWidth = _useState4[1];

  var scrollTo = function scrollTo() {
    if (useScrollView) {
      scrollRef.current.scrollTo({
        x: vertical ? 0 : index * width,
        y: vertical ? index * width : 0,
        animated: true
      });
    } else {
      scrollRef.current.scrollToOffset({
        offset: index * width
      });
    }
  };

  useEffect(function () {
    if (!(index % 1 != 0) && index !== selectedIndex) {
      console.log({
        index: index
      });
      setIndex(index);
      scrollTo();
    }
  }, [index]);
  useEffect(function () {
    if (!(selectedIndex % 1 != 0)) {
      if (onSwipeEnd) onSwipeEnd(selectedIndex);
    }
  }, [selectedIndex]);
  var defaultProps = {
    ref: scrollRef,
    pagingEnabled: true,
    snapToInterval: width,
    horizontal: !vertical,
    automaticallyAdjustContentInsets: false,
    scrollsToTop: false,
    bounces: true,
    scrollEventThrottle: 16,
    showsHorizontalScrollIndicator: false,
    showsVerticalScrollIndicator: false,
    directionalLockEnabled: true,
    disableScrollViewPanResponder: true,
    callbackOffsetMargin: 5,
    enableMomentum: false,
    decelerationRate: "fast",
    snapToAlignment: "left",
    alwaysBounceVertical: false,
    keyboardDismissMode: "on-drag",
    style: _extends({
      flex: 1,
      width: "100%",
      height: vertical ? width : "auto",
      position: "relative",
      padding: gap / 2,
      flexDirection: vertical ? "column" : "row"
    }, style),
    onLayout: function onLayout(_ref2) {
      var nativeEvent = _ref2.nativeEvent;
      var _nativeEvent$layout = nativeEvent.layout,
          width = _nativeEvent$layout.width,
          height = _nativeEvent$layout.height;

      if (vertical) {
        setWidth(itemSize || height);
      } else {
        setWidth(itemSize || width);
      }
    },
    onScroll: function onScroll(_ref3) {
      var nativeEvent = _ref3.nativeEvent;
      var _nativeEvent$contentO = nativeEvent.contentOffset,
          x = _nativeEvent$contentO.x,
          y = _nativeEvent$contentO.y;

      if (!vertical) {
        var swipeIndex = x / width;
      } else {
        var swipeIndex = y / width;
      }

      setIndex(swipeIndex);
      if (onSwipe && updateSwipe) onSwipe(swipeIndex);
    },
    onMomentumScrollBegin: function onMomentumScrollBegin(_ref4) {
      var nativeEvent = _ref4.nativeEvent;
      console.log("onMomentumScrollBegin");
    },
    onMomentumScrollEnd: function onMomentumScrollEnd(_ref5) {
      var nativeEvent = _ref5.nativeEvent;
      var _nativeEvent$contentO2 = nativeEvent.contentOffset,
          x = _nativeEvent$contentO2.x,
          y = _nativeEvent$contentO2.y;

      if (!vertical) {
        var indexNew = Math.round(x / width);
      } else {
        var indexNew = Math.round(y / width);
      }

      console.log("onMomentumScrollEnd");
      if (onSwipeEnd) onSwipeEnd(indexNew);
      setIndex(indexNew);
    }
  };

  if (useScrollView) {
    return React__default.createElement(ScrollView, _extends({
      contentContainerStyle: {
        width: vertical ? "100%" : "auto"
      }
    }, defaultProps, rest), React__default.Children.map(children, function (child, i) {
      if (child) {
        return React__default.createElement(Content, {
          itemSize: width,
          gap: gap,
          vertical: vertical,
          key: i
        }, child);
      }
    }));
  }

  return React__default.createElement(FlatList, _extends({
    data: children,
    renderItem: function renderItem(_ref6) {
      var item = _ref6.item,
          index = _ref6.index;

      if (item) {
        return React__default.createElement(Content, {
          itemSize: width,
          gap: gap,
          vertical: vertical
        }, item);
      }
    },
    keyExtractor: function keyExtractor(item, index) {
      return index.toString();
    },
    getItemLayout: function getItemLayout(data, index) {
      return {
        length: width,
        offset: width * index,
        index: index
      };
    },
    contentContainerStyle: {
      width: vertical ? "100%" : "auto",
      flexGrow: 1
    },
    initialScrollIndex: index
  }, defaultProps, rest));
};

Comp$3.propTypes = {
  index: PropTypes__default.number,
  swipeIndex: PropTypes__default.number,
  threshold: PropTypes__default.number,
  hysteresis: PropTypes__default.number,
  children: PropTypes__default.node.isRequired,
  onSwipe: PropTypes__default.func,
  onSwipeEnd: PropTypes__default.func,
  scale: PropTypes__default.bool
};
Comp$3.defaultProps = {
  flex: undefined,
  index: 0,
  gap: 0,
  swipeIndex: 0,
  threshold: 5,
  hysteresis: 0.6,
  dotsPosition: "bottom",
  dotsOffset: 20,
  dots: false,
  autoplay: false,
  duration: 3000
};
var Tabs = styled(Box)(function (_ref) {
  var roundness = _ref.roundness,
      gap = _ref.gap,
      tabsSize = _ref.tabsSize,
      vertical = _ref.vertical;
  return {
    width: vertical ? tabsSize + gap * 2 : "100%",
    height: vertical ? "100%" : tabsSize + gap * 2,
    borderRadius: roundness > 0 ? roundness + gap : roundness,
    overflow: "hidden",
    padding: gap
  };
});
var Track = styled.View(function (_ref2) {
  var tabsSize = _ref2.tabsSize,
      vertical = _ref2.vertical;
  return {
    position: "relative",
    height: vertical ? "100%" : tabsSize,
    width: vertical ? tabsSize : "100%",
    flexDirection: vertical ? "column" : "row",
    justifyContent: "space-between",
    backgroundColor: "transparent",
    zIndex: 0
  };
});
var Tab = styled.TouchableOpacity(function (_ref3) {
  var active = _ref3.active,
      vertical = _ref3.vertical;
  return {
    position: "relative",
    height: "100%",
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
    zIndex: 100
  };
});
var TabLabel = styled.Text(function (_ref4) {
  var active = _ref4.active,
      activeColor = _ref4.activeColor,
      color = _ref4.color;
  return {
    fontSize: "label",
    color: active ? activeColor : color
  };
});
var Indicator = animated(styled(Box)(function (_ref5) {
  var roundness = _ref5.roundness,
      vertical = _ref5.vertical;
  return {
    position: "absolute",
    left: 0,
    bottom: vertical ? "auto" : 0,
    top: vertical ? 0 : "auto",
    borderRadius: roundness,
    zIndex: 10
  };
}));

var isString = function isString(option) {
  return typeof option === "string" ? true : false;
};

var Comp$4 = function Comp(props) {
  var value = props.value,
      onChange = props.onChange,
      options = props.options,
      children = props.children,
      _props$indicatorSize = props.indicatorSize,
      indicatorSize = _props$indicatorSize === undefined ? "100%" : _props$indicatorSize,
      _props$indicatorColor = props.indicatorColor,
      indicatorColor = _props$indicatorColor === undefined ? "primary" : _props$indicatorColor,
      _props$gap = props.gap,
      gap = _props$gap === undefined ? 0 : _props$gap,
      _props$roundness = props.roundness,
      roundness = _props$roundness === undefined ? 0 : _props$roundness,
      swipeIndex = props.swipeIndex,
      hideLabels = props.hideLabels,
      _props$tabsSize = props.tabsSize,
      tabsSize = _props$tabsSize === undefined ? 50 : _props$tabsSize,
      _props$backgroundColo = props.backgroundColor,
      backgroundColor = _props$backgroundColo === undefined ? "surface" : _props$backgroundColo,
      _props$activeColor = props.activeColor,
      activeColor = _props$activeColor === undefined ? "#FFF" : _props$activeColor,
      _props$color = props.color,
      color = _props$color === undefined ? "primary" : _props$color,
      _props$swiperProps = props.swiperProps,
      swiperProps = _props$swiperProps === undefined ? {} : _props$swiperProps,
      _props$indicatorProps = props.indicatorProps,
      indicatorProps = _props$indicatorProps === undefined ? {} : _props$indicatorProps,
      _props$tabProps = props.tabProps,
      tabProps = _props$tabProps === undefined ? {} : _props$tabProps,
      _props$tabLabelProps = props.tabLabelProps,
      tabLabelProps = _props$tabLabelProps === undefined ? {} : _props$tabLabelProps,
      _props$trackProps = props.trackProps,
      trackProps = _props$trackProps === undefined ? {} : _props$trackProps,
      _props$vertical = props.vertical,
      vertical = _props$vertical === undefined ? false : _props$vertical,
      _props$ripple = props.ripple,
      ripple = _props$ripple === undefined ? false : _props$ripple,
      rest = objectWithoutProperties(props, ["value", "onChange", "options", "children", "indicatorSize", "indicatorColor", "gap", "roundness", "swipeIndex", "hideLabels", "tabsSize", "backgroundColor", "activeColor", "color", "swiperProps", "indicatorProps", "tabProps", "tabLabelProps", "trackProps", "vertical", "ripple"]);
  var tabValue = value || options[0].value || options[0];
  var findIndex = options.findIndex(function (option) {
    return option === tabValue || option.value === tabValue;
  });

  var _useState = useState(findIndex),
      _useState2 = slicedToArray(_useState, 2),
      selectedIndex = _useState2[0],
      setIndex = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = slicedToArray(_useState3, 2),
      swipe = _useState4[0],
      setSwipe = _useState4[1];

  var _useState5 = useState(0),
      _useState6 = slicedToArray(_useState5, 2),
      width = _useState6[0],
      setWidth = _useState6[1];

  useEffect(function () {
    setIndex(findIndex);
  }, [findIndex]);
  useEffect(function () {
    if (!swipe) {
      setIndex(selectedIndex);
    }
  }, [selectedIndex]);

  var _useSpring = useSpring({
    x: Math.round(selectedIndex * (width / options.length)),
    config: {
      mass: 1,
      tension: 300,
      friction: 30,
      duration: 300
    },
    onRest: function onRest() {
      return setSwipe(false);
    }
  }),
      x = _useSpring.x;

  var TabsComp = React__default.createElement(Tabs, _extends({
    type: backgroundColor,
    roundness: roundness,
    gap: gap,
    tabsSize: tabsSize,
    vertical: vertical
  }, rest), React__default.createElement(Track, _extends({
    tabsSize: tabsSize,
    vertical: vertical,
    onLayout: function onLayout(_ref6) {
      var nativeEvent = _ref6.nativeEvent;
      var _nativeEvent$layout = nativeEvent.layout,
          width = _nativeEvent$layout.width,
          height = _nativeEvent$layout.height;
      setWidth(vertical ? height : width);
    }
  }, trackProps), options.map(function (option, index) {
    var active = Math.round(selectedIndex) === index;
    return React__default.createElement(Tab, _extends({
      as: ripple ? Button : undefined,
      rippleColor: ripple ? indicatorColor : undefined,
      size: ripple ? tabsSize * 2 : undefined,
      active: active,
      vertical: vertical,
      activeOpacity: active ? 1 : 0.8,
      overflow: true,
      onPress: function onPress() {
        setSwipe(true);
        setIndex(index); // setTimeout(() => {
        //   setSwipe(false);
        // }, 3000);

        if (onChange) {
          onChange(isString(option) ? option : option.value);
        }
      },
      key: "item-" + index
    }, tabProps), !hideLabels && React__default.createElement(TabLabel, _extends({
      active: active,
      activeColor: activeColor,
      color: color
    }, tabLabelProps), isString(option) ? option : option.label));
  }), React__default.createElement(Indicator, _extends({
    type: indicatorColor,
    vertical: vertical,
    roundness: roundness
  }, indicatorProps, {
    style: _extends({}, indicatorProps.style, {
      transform: vertical ? [{
        translateY: x
      }] : [{
        translateX: x
      }],
      width: vertical ? indicatorSize : 100 / options.length + "%",
      height: !vertical ? indicatorSize : 100 / options.length + "%"
    })
  }))));

  if (children) {
    return React__default.createElement(Fragment, null, TabsComp, React__default.createElement(Comp$3, _extends({
      updateSwipe: !swipe,
      index: selectedIndex,
      onSwipe: function onSwipe(swipeIndex, index) {
        setIndex(swipeIndex);
      },
      onSwipeEnd: function onSwipeEnd(index) {
        console.log("onSwipeEnd", index);
        setIndex(index);
      }
    }, swiperProps), children));
  } else {
    return TabsComp;
  }
};

var ChartWrap = styled(Box)({
  width: "100%",
  flexDirection: "row",
  overflow: "hidden"
});
var Chart = styled.ScrollView(function (_ref) {
  var showValue = _ref.showValue;
  return {
    position: "relative",
    flex: 1,
    height: "auto",
    width: "100%",
    paddingTop: showValue ? 20 : 0
  };
});
var Bar = animated(styled(Box)({
  alignItems: "center",
  position: "relative"
}));
var XAxis = styled.View({
  width: "100%",
  flexDirection: "row",
  paddingVertical: 10
});
var YAxis = styled.View(function (_ref2) {
  var height = _ref2.height,
      gridWidth = _ref2.gridWidth,
      gridColor = _ref2.gridColor,
      showValue = _ref2.showValue;
  return {
    width: "auto",
    paddingHorizontal: 10,
    height: showValue ? height + 20 : height + 10,
    justifyContent: "space-between",
    alignItems: "flex-end",
    borderRightWidth: gridWidth,
    borderColor: gridColor,
    marginTop: showValue ? 10 : 0
  };
});
var Label$2 = styled.View({
  alignItems: "center",
  justifyContent: "center",
  height: 20
});
var Spacer = styled.View(function (_ref3) {
  var gap = _ref3.gap;
  return {
    width: gap * 2
  };
});
var LabelText = styled.Text({
  fontSize: 10
});
var BarValue = styled.View(function (_ref4) {
  var theme = _ref4.theme;
  return {
    position: "absolute",
    left: "-100%",
    width: "300%",
    top: -20,
    alignItems: "center",
    justifyContent: "center"
  };
});
var BarValueWrap = styled.View(function (_ref5) {
  var theme = _ref5.theme;
  return {
    width: "100%",
    overflow: "visible"
  };
});
var BarValueText = styled.Text({
  width: "100%",
  fontSize: "label",
  textAlign: "center"
});

var BarsRenderer = function BarsRenderer(_ref6) {
  var data = _ref6.data,
      bars = _ref6.bars,
      selected = _ref6.selected,
      barColor = _ref6.barColor,
      selectedBarColor = _ref6.selectedBarColor,
      gap = _ref6.gap,
      min = _ref6.min,
      factor = _ref6.factor,
      showValue = _ref6.showValue,
      formatValue = _ref6.formatValue,
      barProps = _ref6.barProps,
      barValueStyle = _ref6.barValueStyle,
      onPress = _ref6.onPress,
      minBarWidth = _ref6.minBarWidth;
  var transitions = useTransition(bars, function (data) {
    return data.index;
  }, {
    from: {
      height: 0,
      opacity: 0
    },
    leave: {
      height: 0,
      opacity: 0
    },
    enter: function enter(item) {
      return {
        height: item.height,
        opacity: 1
      };
    },
    update: function update(item) {
      return {
        height: item.height
      };
    },
    unique: true,
    trail: 4000 / data.length
  });
  return transitions.map(function (_ref7, index) {
    var item = _ref7.item,
        height = _ref7.props.height,
        key = _ref7.key;
    return React__default.createElement(Bar, _extends({
      type: item.color ? item.color : selected && selected === item.index ? selectedBarColor : barColor,
      as: onPress ? TouchableOpacity : undefined,
      onPress: onPress ? function () {
        return onPress(item);
      } : undefined,
      activeOpacity: 0.8,
      key: key
    }, barProps, {
      style: _extends({
        display: "flex",
        flexGrow: 1,
        minWidth: minBarWidth,
        marginHorizontal: gap / 2,
        height: height.interpolate(function (h) {
          return Math.abs(h);
        }),
        marginBottom: height.interpolate(function (h) {
          return h < 0 ? min * factor + h : min * factor;
        })
      }, barProps.style)
    }), showValue ? React__default.createElement(BarValue, {
      style: _extends({}, barValueStyle)
    }, React__default.createElement(BarValueWrap, null, React__default.createElement(BarValueText, {
      numberOfLines: 1
    }, formatValue ? formatValue(item.value) : item.value))) : null);
  });
};

var Comp$5 = function Comp(props) {
  var barProps = props.barProps,
      style = props.style,
      _props$data = props.data,
      data = _props$data === undefined ? [] : _props$data,
      onPress = props.onPress,
      _props$height = props.height,
      height = _props$height === undefined ? 300 : _props$height,
      width = props.width,
      maxValue = props.maxValue,
      _props$minBarWidth = props.minBarWidth,
      minBarWidth = _props$minBarWidth === undefined ? 15 : _props$minBarWidth,
      _props$gap = props.gap,
      gap = _props$gap === undefined ? 10 : _props$gap,
      _props$barColor = props.barColor,
      barColor = _props$barColor === undefined ? "primary" : _props$barColor,
      selected = props.selected,
      _props$selectedBarCol = props.selectedBarColor,
      selectedBarColor = _props$selectedBarCol === undefined ? "primary" : _props$selectedBarCol,
      _props$grid = props.grid,
      grid = _props$grid === undefined ? true : _props$grid,
      _props$xAxis = props.xAxis,
      xAxis = _props$xAxis === undefined ? false : _props$xAxis,
      _props$yAxis = props.yAxis,
      yAxis = _props$yAxis === undefined ? false : _props$yAxis,
      _props$barValueStyle = props.barValueStyle,
      barValueStyle = _props$barValueStyle === undefined ? {} : _props$barValueStyle,
      formatValue = props.formatValue,
      formatLabel = props.formatLabel,
      _props$showValue = props.showValue,
      showValue = _props$showValue === undefined ? false : _props$showValue,
      _props$labelColor = props.labelColor,
      labelColor = _props$labelColor === undefined ? "text" : _props$labelColor,
      _props$labelSize = props.labelSize,
      labelSize = _props$labelSize === undefined ? "label" : _props$labelSize,
      _props$gridWidth = props.gridWidth,
      gridWidth = _props$gridWidth === undefined ? 2 : _props$gridWidth,
      _props$gridColor = props.gridColor,
      gridColor = _props$gridColor === undefined ? "primary" : _props$gridColor,
      _props$scrollable = props.scrollable,
      scrollable = _props$scrollable === undefined ? false : _props$scrollable,
      _props$tickCount = props.tickCount,
      tickCount = _props$tickCount === undefined ? 5 : _props$tickCount,
      rest = objectWithoutProperties(props, ["barProps", "style", "data", "onPress", "height", "width", "maxValue", "minBarWidth", "gap", "barColor", "selected", "selectedBarColor", "grid", "xAxis", "yAxis", "barValueStyle", "formatValue", "formatLabel", "showValue", "labelColor", "labelSize", "gridWidth", "gridColor", "scrollable", "tickCount"]);
  if (data.length === 0) return null;
  var Screen = Dimensions.get("window");

  if (typeof data[0] === "number") {
    var max = maxValue ? maxValue : Math.max.apply(null, data);
    var min = Math.min.apply(null, data);
  } else {
    var max = maxValue ? maxValue : Math.max.apply(null, data.map(function (a) {
      return a.value;
    }));
    var min = Math.min.apply(null, data.map(function (a) {
      return a.value;
    }));
  }

  if (min > 0) {
    min = 0;
  } else {
    min = Math.abs(min);
  }

  var factor = height / (max + min === 0 ? 1 : max + min);

  var getHeight = function getHeight(number$$1) {
    var height = number$$1 * factor;
    return height;
  };

  function calculateTicks() {
    var realMin = 0; //minNegativ ? -min : min;

    var step = max / tickCount; // Filter ticks to get closer to the desired count.
    // if (err <= 0.15) step *= 10;
    // else if (err <= 0.35) step *= 5;
    // else if (err <= 0.75) step *= 2;
    // Round start and stop values to step interval.

    var tstart = Math.ceil(realMin),
        tstop = Math.floor(max / step) * step + step * 0.5,
        ticks = [];
    if (step < 1) step = 1; // now generate ticks

    for (var i = tstart; i < tstop; i += step) {
      ticks.push(Math.round(i));
    }

    return ticks.reverse();
  }

  if (typeof data[0] === "number") {
    var transitionData = data.map(function (item, index) {
      return {
        value: item,
        label: "bar-" + index
      };
    });
  } else {
    var transitionData = data;
  }

  var count = 0;

  var groupBy = function groupBy(array, key) {
    return array.reduce(function (acc, item) {
      var newItem = Object.assign({}, item, {
        index: count,
        height: getHeight(item.value)
      });

      if (acc.find(function (a) {
        return a.label === item.label;
      })) {
        acc.find(function (a) {
          return a.label === item.label;
        }).bars.push(newItem);
      } else {
        acc.push({
          label: item[key],
          bars: [newItem]
        });
      }

      count++;
      return acc;
    }, []);
  };

  var groupedData = groupBy(transitionData, "label");
  return React__default.createElement(ChartWrap, {
    style: style
  }, yAxis ? React__default.createElement(YAxis, {
    height: height - min * factor - 1,
    gridWidth: gridWidth,
    gridColor: gridColor,
    showValue: showValue
  }, calculateTicks().map(function (y, index) {
    return React__default.createElement(Label$2, {
      key: "y-" + index
    }, React__default.createElement(LabelText, {
      style: {
        color: labelColor,
        fontSize: labelSize
      },
      numberOfLines: 1
    }, formatLabel ? formatLabel(y) : y));
  })) : null, React__default.createElement(Chart, _extends({
    as: !scrollable ? View : undefined,
    horizontal: true,
    showsHorizontalScrollIndicator: false,
    showsVerticalScrollIndicator: false,
    contentContainerStyle: {
      flexDirection: "column",
      minWidth: "100%"
    },
    showValue: showValue
  }, rest), React__default.createElement(Box, {
    style: {
      position: "relative",
      minWidth: "100%",
      height: height,
      flexDirection: "row",
      alignItems: "flex-end",
      paddingHorizontal: gap / 2
    }
  }, grid ? React__default.createElement(Box, {
    position: "absolute",
    left: 0,
    bottom: min * factor - 1,
    width: "100%",
    height: gridWidth,
    backgroundColor: gridColor
  }) : null, groupedData.map(function (group, index) {
    return React__default.createElement(Fragment, {
      key: index
    }, group.bars.length > 1 ? React__default.createElement(Spacer, {
      gap: gap
    }) : null, React__default.createElement(BarsRenderer, {
      data: data,
      bars: group.bars,
      selected: selected,
      selectedBarColor: selectedBarColor,
      gap: gap,
      min: min,
      factor: factor,
      showValue: showValue,
      formatValue: formatValue,
      barProps: barProps,
      barValueStyle: barValueStyle,
      barColor: barColor,
      minBarWidth: minBarWidth,
      onPress: onPress
    }), group.bars.length > 1 ? React__default.createElement(Spacer, {
      gap: gap
    }) : null);
  })), xAxis ? React__default.createElement(XAxis, null, groupedData.map(function (group, index) {
    return React__default.createElement(Label$2, {
      key: "label-" + index,
      style: {
        flex: group.bars.length,
        marginHorizontal: gap
      }
    }, React__default.createElement(LabelText, {
      style: {
        color: labelColor,
        fontSize: labelSize
      },
      numberOfLines: 1
    }, group.label));
  })) : null));
};

Comp$5.propTypes = {
  value: PropTypes__default.bool,
  style: PropTypes__default.object,
  borderSize: PropTypes__default.number,
  onChange: PropTypes__default.func
};
Comp$5.defaultProps = {
  labelProps: {
    style: {
      color: "text"
    }
  },
  barLabelStyle: {},
  barProps: {
    style: {}
  }
};
var Drop = styled(Box)({
  position: "relative"
});
var Down = styled(Box)(function (_ref) {
  var theme = _ref.theme;
  return {
    position: "absolute",
    left: 0,
    top: "100%",
    minWidth: "100%",
    padding: 10,
    borderRadius: theme.globals.roundnesss,
    backgroundColor: "surface"
  };
});

function Dropdown(_ref2) {
  var children = _ref2.children,
      _ref2$downProps = _ref2.downProps,
      downProps = _ref2$downProps === undefined ? {} : _ref2$downProps,
      _ref2$content = _ref2.content,
      content = _ref2$content === undefined ? null : _ref2$content,
      rest = objectWithoutProperties(_ref2, ["children", "downProps", "content"]);

  var _useState = useState(false),
      _useState2 = slicedToArray(_useState, 2),
      open = _useState2[0],
      setOpen = _useState2[1];

  return React__default.createElement(Drop, null, Children.only(React__default.cloneElement(children, _extends({
    as: TouchableOpacity,
    onPress: function onPress() {
      setOpen(!open);
    }
  }, rest))), React__default.createElement(Animate$1, _extends({
    as: Down,
    from: {
      opacity: 0,
      y: 20,
      x: 0
    },
    isVisible: open,
    shadow: 20
  }, downProps), content));
}

var Switch = animated(styled(Box)(function (_ref) {
  var size = _ref.size,
      radius = _ref.radius,
      gap = _ref.gap;
  return {
    position: "relative",
    display: Platform.OS === "web" ? "inline-block" : "flex",
    overflow: "hidden",
    width: size * 2 - gap,
    height: size,
    padding: gap,
    borderRadius: radius || size,
    margin: 0
  };
}));
var Track$1 = styled.View({
  position: "relative",
  width: "100%",
  height: "100%"
});
var Circle = animated(styled(Box)(function (_ref2) {
  var size = _ref2.size,
      radius = _ref2.radius,
      gap = _ref2.gap;
  return {
    position: "absolute",
    top: 0,
    width: size - gap * 2,
    height: size - gap * 2,
    borderRadius: radius ? radius - gap / 2 : size,
    backgroundColor: "#fff"
  };
}));

var Comp$6 = function Comp(_ref3) {
  var value = _ref3.value,
      onChange = _ref3.onChange,
      _ref3$size = _ref3.size,
      size = _ref3$size === undefined ? 40 : _ref3$size,
      radius = _ref3.radius,
      _ref3$gap = _ref3.gap,
      gap = _ref3$gap === undefined ? 5 : _ref3$gap,
      style = _ref3.style,
      _ref3$trackColor = _ref3.trackColor,
      trackColor = _ref3$trackColor === undefined ? "background" : _ref3$trackColor,
      _ref3$activeTrackColo = _ref3.activeTrackColor,
      activeTrackColor = _ref3$activeTrackColo === undefined ? "primary" : _ref3$activeTrackColo,
      rest = objectWithoutProperties(_ref3, ["value", "onChange", "size", "radius", "gap", "style", "trackColor", "activeTrackColor"]);
  var theme = useTheme();

  var _useState = useState(value || false),
      _useState2 = slicedToArray(_useState, 2),
      active = _useState2[0],
      setActive = _useState2[1];

  var _useSpring = useSpring({
    to: {
      left: active ? size - gap : 0,
      backgroundColor: active ? theme.colors[activeTrackColor] || activeTrackColor : theme.colors[trackColor] || trackColor
    },
    config: {
      duration: 300
    }
  }),
      left = _useSpring.left,
      backgroundColor = _useSpring.backgroundColor;

  useEffect(function () {
    setActive(value);
  }, [value]); // TODO: add hover effect
  // onMouseEnter={() => console.log("hover")}
  // onMouseLeave={() => }

  return React__default.createElement(Switch, _extends({
    as: TouchableOpacity,
    style: _extends({}, style, {
      backgroundColor: backgroundColor
    }),
    activeOpacity: 0.8,
    size: size,
    radius: radius,
    gap: gap,
    onPress: function onPress() {
      var newValue = !active;
      setActive(newValue);
      setTimeout(function () {
        if (onChange) {
          onChange(newValue);
        }
      }, 299);
    }
  }, rest), React__default.createElement(Track$1, null, React__default.createElement(Circle, {
    style: {
      transform: [{
        translateX: left
      }]
    },
    size: size,
    radius: radius,
    gap: gap,
    shadow: 5
  })));
};

Comp$6.propTypes = {
  value: PropTypes__default.bool,
  style: PropTypes__default.object,
  circleSize: PropTypes__default.number,
  borderSize: PropTypes__default.number,
  onChange: PropTypes__default.func
};
var TextInput = styled.TextInput(function (_ref) {
  var _babelHelpers$extends;

  var theme = _ref.theme,
      textColor = _ref.textColor;
  return _extends((_babelHelpers$extends = {
    fontSize: "p",
    backgroundColor: "transparent",
    width: "100%",
    paddingVertical: 10,
    borderRadius: 0
  }, defineProperty(_babelHelpers$extends, "fontSize", 15), defineProperty(_babelHelpers$extends, "margin", 0), defineProperty(_babelHelpers$extends, "borderWidth", 0), defineProperty(_babelHelpers$extends, "color", textColor), defineProperty(_babelHelpers$extends, "fontFamily", theme.globals.fontFamily), _babelHelpers$extends), Platform.select({
    web: {
      outlineWidth: 0,
      outlineColor: "unset",
      borderColor: "transparent"
    }
  }));
});

var Comp$7 = function Comp(props) {
  var as = props.as,
      value = props.value,
      onChange = props.onChange,
      style = props.style,
      setFocus = props.setFocus,
      _onFocus = props.onFocus,
      _onBlur = props.onBlur,
      placeholderColor = props.placeholderColor,
      rest = objectWithoutProperties(props, ["as", "value", "onChange", "style", "setFocus", "onFocus", "onBlur", "placeholderColor"]);
  var theme = useTheme();
  var placeholderTextColor = theme.colors[placeholderColor] || placeholderColor;
  return React__default.createElement(TextInput, _extends({
    value: value !== undefined && value !== null ? value.toString() : "",
    as: as || undefined,
    onChangeText: function onChangeText(text) {
      return onChange ? onChange(text) : null;
    },
    placeholderTextColor: color(placeholderTextColor).alpha(0.35),
    underlineColorAndroid: "transparent",
    onFocus: function onFocus() {
      if (setFocus) {
        setFocus(true);
      }

      if (_onFocus) {
        _onFocus();
      }
    },
    onBlur: function onBlur() {
      if (setFocus) {
        setFocus(false);
      }

      if (_onBlur) {
        _onBlur();
      }
    },
    style: style
  }, rest));
};

Comp$7.defaultProps = {
  placeholderColor: "text"
};
var dayjs_min = createCommonjsModule(function (module, exports) {
  !function (t, n) {
    module.exports = n();
  }(commonjsGlobal, function () {
    var t = "millisecond",
        n = "second",
        e = "minute",
        r = "hour",
        i = "day",
        s = "week",
        u = "month",
        a = "quarter",
        o = "year",
        h = /^(\d{4})-?(\d{1,2})-?(\d{0,2})[^0-9]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?.?(\d{1,3})?$/,
        f = /\[([^\]]+)]|Y{2,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g,
        c = function c(t, n, e) {
      var r = String(t);
      return !r || r.length >= n ? t : "" + Array(n + 1 - r.length).join(e) + t;
    },
        d = {
      s: c,
      z: function z(t) {
        var n = -t.utcOffset(),
            e = Math.abs(n),
            r = Math.floor(e / 60),
            i = e % 60;
        return (n <= 0 ? "+" : "-") + c(r, 2, "0") + ":" + c(i, 2, "0");
      },
      m: function m(t, n) {
        var e = 12 * (n.year() - t.year()) + (n.month() - t.month()),
            r = t.clone().add(e, u),
            i = n - r < 0,
            s = t.clone().add(e + (i ? -1 : 1), u);
        return Number(-(e + (n - r) / (i ? r - s : s - r)) || 0);
      },
      a: function a(t) {
        return t < 0 ? Math.ceil(t) || 0 : Math.floor(t);
      },
      p: function p(h) {
        return {
          M: u,
          y: o,
          w: s,
          d: i,
          h: r,
          m: e,
          s: n,
          ms: t,
          Q: a
        }[h] || String(h || "").toLowerCase().replace(/s$/, "");
      },
      u: function u(t) {
        return void 0 === t;
      }
    },
        $ = {
      name: "en",
      weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),
      months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_")
    },
        l = "en",
        m = {};

    m[l] = $;

    var y = function y(t) {
      return t instanceof v;
    },
        M = function M(t, n, e) {
      var r;
      if (!t) return l;
      if ("string" == typeof t) m[t] && (r = t), n && (m[t] = n, r = t);else {
        var i = t.name;
        m[i] = t, r = i;
      }
      return e || (l = r), r;
    },
        g = function g(t, n, e) {
      if (y(t)) return t.clone();
      var r = n ? "string" == typeof n ? {
        format: n,
        pl: e
      } : n : {};
      return r.date = t, new v(r);
    },
        D = d;

    D.l = M, D.i = y, D.w = function (t, n) {
      return g(t, {
        locale: n.$L,
        utc: n.$u
      });
    };

    var v = function () {
      function c(t) {
        this.$L = this.$L || M(t.locale, null, !0), this.parse(t);
      }

      var d = c.prototype;
      return d.parse = function (t) {
        this.$d = function (t) {
          var n = t.date,
              e = t.utc;
          if (null === n) return new Date(NaN);
          if (D.u(n)) return new Date();
          if (n instanceof Date) return new Date(n);

          if ("string" == typeof n && !/Z$/i.test(n)) {
            var r = n.match(h);
            if (r) return e ? new Date(Date.UTC(r[1], r[2] - 1, r[3] || 1, r[4] || 0, r[5] || 0, r[6] || 0, r[7] || 0)) : new Date(r[1], r[2] - 1, r[3] || 1, r[4] || 0, r[5] || 0, r[6] || 0, r[7] || 0);
          }

          return new Date(n);
        }(t), this.init();
      }, d.init = function () {
        var t = this.$d;
        this.$y = t.getFullYear(), this.$M = t.getMonth(), this.$D = t.getDate(), this.$W = t.getDay(), this.$H = t.getHours(), this.$m = t.getMinutes(), this.$s = t.getSeconds(), this.$ms = t.getMilliseconds();
      }, d.$utils = function () {
        return D;
      }, d.isValid = function () {
        return !("Invalid Date" === this.$d.toString());
      }, d.isSame = function (t, n) {
        var e = g(t);
        return this.startOf(n) <= e && e <= this.endOf(n);
      }, d.isAfter = function (t, n) {
        return g(t) < this.startOf(n);
      }, d.isBefore = function (t, n) {
        return this.endOf(n) < g(t);
      }, d.$g = function (t, n, e) {
        return D.u(t) ? this[n] : this.set(e, t);
      }, d.year = function (t) {
        return this.$g(t, "$y", o);
      }, d.month = function (t) {
        return this.$g(t, "$M", u);
      }, d.day = function (t) {
        return this.$g(t, "$W", i);
      }, d.date = function (t) {
        return this.$g(t, "$D", "date");
      }, d.hour = function (t) {
        return this.$g(t, "$H", r);
      }, d.minute = function (t) {
        return this.$g(t, "$m", e);
      }, d.second = function (t) {
        return this.$g(t, "$s", n);
      }, d.millisecond = function (n) {
        return this.$g(n, "$ms", t);
      }, d.unix = function () {
        return Math.floor(this.valueOf() / 1e3);
      }, d.valueOf = function () {
        return this.$d.getTime();
      }, d.startOf = function (t, a) {
        var h = this,
            f = !!D.u(a) || a,
            c = D.p(t),
            d = function d(t, n) {
          var e = D.w(h.$u ? Date.UTC(h.$y, n, t) : new Date(h.$y, n, t), h);
          return f ? e : e.endOf(i);
        },
            $ = function $(t, n) {
          return D.w(h.toDate()[t].apply(h.toDate(), (f ? [0, 0, 0, 0] : [23, 59, 59, 999]).slice(n)), h);
        },
            l = this.$W,
            m = this.$M,
            y = this.$D,
            M = "set" + (this.$u ? "UTC" : "");

        switch (c) {
          case o:
            return f ? d(1, 0) : d(31, 11);

          case u:
            return f ? d(1, m) : d(0, m + 1);

          case s:
            var g = this.$locale().weekStart || 0,
                v = (l < g ? l + 7 : l) - g;
            return d(f ? y - v : y + (6 - v), m);

          case i:
          case "date":
            return $(M + "Hours", 0);

          case r:
            return $(M + "Minutes", 1);

          case e:
            return $(M + "Seconds", 2);

          case n:
            return $(M + "Milliseconds", 3);

          default:
            return this.clone();
        }
      }, d.endOf = function (t) {
        return this.startOf(t, !1);
      }, d.$set = function (s, a) {
        var h,
            f = D.p(s),
            c = "set" + (this.$u ? "UTC" : ""),
            d = (h = {}, h[i] = c + "Date", h.date = c + "Date", h[u] = c + "Month", h[o] = c + "FullYear", h[r] = c + "Hours", h[e] = c + "Minutes", h[n] = c + "Seconds", h[t] = c + "Milliseconds", h)[f],
            $ = f === i ? this.$D + (a - this.$W) : a;

        if (f === u || f === o) {
          var l = this.clone().set("date", 1);
          l.$d[d]($), l.init(), this.$d = l.set("date", Math.min(this.$D, l.daysInMonth())).toDate();
        } else d && this.$d[d]($);

        return this.init(), this;
      }, d.set = function (t, n) {
        return this.clone().$set(t, n);
      }, d.get = function (t) {
        return this[D.p(t)]();
      }, d.add = function (t, a) {
        var h,
            f = this;
        t = Number(t);

        var c = D.p(a),
            d = function d(n) {
          var e = g(f);
          return D.w(e.date(e.date() + Math.round(n * t)), f);
        };

        if (c === u) return this.set(u, this.$M + t);
        if (c === o) return this.set(o, this.$y + t);
        if (c === i) return d(1);
        if (c === s) return d(7);
        var $ = (h = {}, h[e] = 6e4, h[r] = 36e5, h[n] = 1e3, h)[c] || 1,
            l = this.valueOf() + t * $;
        return D.w(l, this);
      }, d.subtract = function (t, n) {
        return this.add(-1 * t, n);
      }, d.format = function (t) {
        var n = this;
        if (!this.isValid()) return "Invalid Date";

        var e = t || "YYYY-MM-DDTHH:mm:ssZ",
            r = D.z(this),
            i = this.$locale(),
            s = this.$H,
            u = this.$m,
            a = this.$M,
            o = i.weekdays,
            h = i.months,
            c = function c(t, r, i, s) {
          return t && (t[r] || t(n, e)) || i[r].substr(0, s);
        },
            d = function d(t) {
          return D.s(s % 12 || 12, t, "0");
        },
            $ = i.meridiem || function (t, n, e) {
          var r = t < 12 ? "AM" : "PM";
          return e ? r.toLowerCase() : r;
        },
            l = {
          YY: String(this.$y).slice(-2),
          YYYY: this.$y,
          M: a + 1,
          MM: D.s(a + 1, 2, "0"),
          MMM: c(i.monthsShort, a, h, 3),
          MMMM: h[a] || h(this, e),
          D: this.$D,
          DD: D.s(this.$D, 2, "0"),
          d: String(this.$W),
          dd: c(i.weekdaysMin, this.$W, o, 2),
          ddd: c(i.weekdaysShort, this.$W, o, 3),
          dddd: o[this.$W],
          H: String(s),
          HH: D.s(s, 2, "0"),
          h: d(1),
          hh: d(2),
          a: $(s, u, !0),
          A: $(s, u, !1),
          m: String(u),
          mm: D.s(u, 2, "0"),
          s: String(this.$s),
          ss: D.s(this.$s, 2, "0"),
          SSS: D.s(this.$ms, 3, "0"),
          Z: r
        };

        return e.replace(f, function (t, n) {
          return n || l[t] || r.replace(":", "");
        });
      }, d.utcOffset = function () {
        return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
      }, d.diff = function (t, h, f) {
        var c,
            d = D.p(h),
            $ = g(t),
            l = 6e4 * ($.utcOffset() - this.utcOffset()),
            m = this - $,
            y = D.m(this, $);
        return y = (c = {}, c[o] = y / 12, c[u] = y, c[a] = y / 3, c[s] = (m - l) / 6048e5, c[i] = (m - l) / 864e5, c[r] = m / 36e5, c[e] = m / 6e4, c[n] = m / 1e3, c)[d] || m, f ? y : D.a(y);
      }, d.daysInMonth = function () {
        return this.endOf(u).$D;
      }, d.$locale = function () {
        return m[this.$L];
      }, d.locale = function (t, n) {
        if (!t) return this.$L;
        var e = this.clone();
        return e.$L = M(t, n, !0), e;
      }, d.clone = function () {
        return D.w(this.toDate(), this);
      }, d.toDate = function () {
        return new Date(this.$d);
      }, d.toJSON = function () {
        return this.isValid() ? this.toISOString() : null;
      }, d.toISOString = function () {
        return this.$d.toISOString();
      }, d.toString = function () {
        return this.$d.toUTCString();
      }, c;
    }();

    return g.prototype = v.prototype, g.extend = function (t, n) {
      return t(n, v, g), g;
    }, g.locale = M, g.isDayjs = y, g.unix = function (t) {
      return g(1e3 * t);
    }, g.en = m[l], g.Ls = m, g;
  });
});
var Box$2 = styled.View({
  width: "100%",
  position: "relative"
});
var Headline$1 = styled.Text({
  fontSize: "h3",
  color: "text"
}); // const SelectIcon = styled(Icon)({
//   position: "absolute",
//   top: 10,
//   right: 5
// });

var Comp$8 = function Comp$$1(props) {
  var value = props.value,
      onChange = props.onChange,
      options = props.options,
      style = props.style,
      _props$placeholder = props.placeholder,
      placeholder = _props$placeholder === undefined ? "Please select..." : _props$placeholder,
      _props$overlayProps = props.overlayProps,
      overlayProps = _props$overlayProps === undefined ? {} : _props$overlayProps,
      _props$inputProps = props.inputProps,
      inputProps = _props$inputProps === undefined ? {} : _props$inputProps,
      _props$pickerProps = props.pickerProps,
      pickerProps = _props$pickerProps === undefined ? {} : _props$pickerProps;
  var theme = useTheme();

  var _useState = useState(false),
      _useState2 = slicedToArray(_useState, 2),
      show = _useState2[0],
      setShow = _useState2[1];

  var renderCheckbox = function renderCheckbox(option, index) {
    var label = typeof option === "string" ? option : option.label;
    var optionValue = typeof option === "string" ? option : option.value;
    return React__default.createElement(Picker.Item, {
      key: "pick-" + index,
      label: label,
      value: optionValue
    });
  };

  var getValue = function getValue() {
    if (value && options) {
      if (typeof options[0] === "string") {
        return value;
      } else {
        var option = options.find(function (e) {
          return e.value === value;
        });
        return option ? option.label : undefined;
      }
    }

    return value;
  };

  var renderPicker = function renderPicker() {
    return React__default.createElement(Picker, _extends({
      selectedValue: value,
      onValueChange: function onValueChange(itemValue, itemIndex) {
        return onChange ? onChange(itemValue) : null;
      },
      itemStyle: {
        textAlign: "center",
        color: theme.colors.text
      }
    }, pickerProps, {
      style: [_extends({
        width: "100%",
        paddingVertical: 10,
        margin: 0,
        borderRadius: 0,
        backgroundColor: "transparent",
        fontSize: theme.fontSize.p
      }, Platform.select({
        web: {
          outlineWidth: 0,
          outlineColor: "unset",
          borderColor: "transparent",
          appearance: "none"
        }
      })), pickerProps.style]
    }), React__default.createElement(Picker.Item, {
      label: placeholder,
      value: null
    }), options.map(function (option, index) {
      return renderCheckbox(option, index);
    }));
  };

  return React__default.createElement(Box$2, {
    width: "100%",
    position: "relative",
    style: style
  }, Platform.OS !== "ios" ? renderPicker() : null, Platform.OS === "ios" ? React__default.createElement(TouchableOpacity, {
    onPress: function onPress() {
      setShow(!show);
    },
    style: {
      width: "100%"
    }
  }, React__default.createElement(Comp$7, _extends({
    type: "text",
    editable: false,
    value: getValue(),
    placeholder: placeholder,
    pointerEvents: Platform.OS === "web" ? "all" : "none"
  }, inputProps))) : null, React__default.createElement(Comp, {
    name: "arrowDown",
    size: 23,
    color: "primary",
    style: {
      position: "absolute",
      top: 10,
      right: 5
    }
  }), Platform.OS === "ios" ? React__default.createElement(ThemeComp, _extends({
    position: "center",
    height: "auto",
    visible: show,
    onClose: function onClose() {
      return setShow(false);
    },
    p: 20,
    style: {
      maxWidth: 500,
      width: "90%"
    }
  }, overlayProps), React__default.createElement(Box$2, {
    width: "100%"
  }, placeholder && React__default.createElement(Headline$1, null, placeholder), renderPicker(), React__default.createElement(Button$1, {
    m: 0,
    onPress: function onPress() {
      return setShow(false);
    }
  }, "Fertig"))) : null);
};

var _styled;

var DateInput = function DateInput(props) {
  return createElement("input", props);
};

var Touchable$2 = styled.TouchableOpacity({
  width: "100%"
});
var StyledDateInput = styled(DateInput)((_styled = {
  fontSize: "p",
  backgroundColor: "transparent",
  width: "100%",
  paddingVertical: 10,
  borderRadius: 0
}, defineProperty(_styled, "fontSize", 15), defineProperty(_styled, "margin", 0), defineProperty(_styled, "borderWidth", 0), defineProperty(_styled, "color", "text"), defineProperty(_styled, "web", {
  outlineWidth: 0,
  outlineColor: "unset",
  borderColor: "transparent"
}), _styled));
var types = {
  date: {
    format: "YYYY-MM-DD"
  },
  datetime: {
    format: "YYYY-MM-DDTHH:mm"
  },
  time: {
    format: "HH:mm"
  }
};
var isMobile = {
  Android: function Android() {
    return navigator.userAgent.match(/Android/i);
  },
  BlackBerry: function BlackBerry() {
    return navigator.userAgent.match(/BlackBerry/i);
  },
  iOS: function iOS() {
    return navigator.userAgent.match(/iPhone|iPad|iPod/i);
  },
  Opera: function Opera() {
    return navigator.userAgent.match(/Opera Mini/i);
  },
  Windows: function Windows() {
    return navigator.userAgent.match(/IEMobile/i);
  },
  any: function any() {
    if (Platform.OS !== "web") {
      return false;
    } else {
      return isMobile.Android() || isMobile.BlackBerry() || isMobile.iOS() || isMobile.Opera() || isMobile.Windows();
    }
  }
};
var CalendarView = styled.View({
  width: "100%",
  flexDirection: "row",
  flexWrap: "wrap",
  justifyContent: "center",
  alignItems: "center",
  paddingVertical: 10
});
var TimePicker = styled.View({
  width: "100%",
  flexDirection: "row",
  alignItems: "center",
  marginBottom: 10
});
var CalendarItem = styled.TouchableOpacity(function (_ref) {
  var theme = _ref.theme,
      active = _ref.active,
      disabled = _ref.disabled;
  return {
    width: 100 / 7 + "%",
    height: 50,
    alignItems: "center",
    justifyContent: "center",
    borderWidth: 2,
    borderColor: "surface",
    backgroundColor: active ? "primary" : "background",
    borderRadius: theme.globals.roundness,
    opacity: disabled ? 0.5 : 1
  };
});
var CalendarLabel = styled.Text(function (_ref2) {
  var active = _ref2.active;
  return {
    fontSize: "p",
    color: active ? "#FFF" : "text"
  };
});
var CalendarMonth = styled.Text(function (_ref3) {
  var active = _ref3.active;
  return {
    fontSize: "p",
    color: active ? "#FFF" : "text"
  };
});

var Calendar = function Calendar(_ref4) {
  var min = _ref4.min,
      max = _ref4.max,
      _onChange = _ref4.onChange,
      currentDate = _ref4.currentDate,
      type = _ref4.type;

  var _useState = useState(currentDate),
      _useState2 = slicedToArray(_useState, 2),
      month = _useState2[0],
      setMonth = _useState2[1];

  var _useState3 = useState("date"),
      _useState4 = slicedToArray(_useState3, 2),
      mode = _useState4[0],
      setMode = _useState4[1];

  var firstDay = dayjs_min(month).startOf("month");
  var lastDay = dayjs_min(month).endOf("month");
  var offsetStart = firstDay.get("day");
  var offsetEnd = 6 - lastDay.get("day");
  return React__default.createElement(Fragment, null, React__default.createElement(CalendarView, {
    style: {
      justifyContent: "space-between"
    }
  }, React__default.createElement(Button$1, {
    color: "surface",
    buttonTextProps: {
      style: {
        color: "primary"
      }
    },
    onPress: function onPress() {
      return setMonth(dayjs_min(month).subtract(1, "month").toDate());
    }
  }, "Prev"), React__default.createElement(CalendarMonth, null, dayjs_min(month).format("MMM YYYY")), React__default.createElement(Button$1, {
    color: "surface",
    buttonTextProps: {
      style: {
        color: "primary"
      }
    },
    onPress: function onPress() {
      return setMonth(dayjs_min(month).add(1, "month").toDate());
    }
  }, "Next")), React__default.createElement(CalendarView, null, ["Son.", "Mo.", "Di.", "Mi.", "Do.", "Fr.", "Sam."].map(function (key) {
    return React__default.createElement(CalendarItem, {
      key: key,
      style: {
        height: 20,
        backgroundColor: "transparent"
      }
    }, React__default.createElement(CalendarLabel, {
      style: {
        fontSize: "caption"
      }
    }, key));
  })), React__default.createElement(CalendarView, null, offsetStart > 0 ? Array.from(Array(offsetStart).keys()).map(function (day) {
    return React__default.createElement(CalendarItem, {
      key: day,
      activeOpacity: 1
    }, React__default.createElement(CalendarLabel, null));
  }) : null, Array.from(Array(parseInt(lastDay.format("DD"))).keys()).map(function (day) {
    var active = firstDay.add(day, "day").isSame(dayjs_min(currentDate), "day");
    var disabled = min ? firstDay.add(day, "day").isBefore(dayjs_min(min), "day") : false;
    return React__default.createElement(CalendarItem, {
      key: day,
      activeOpacity: 0.8,
      active: active,
      onPress: function onPress() {
        _onChange(firstDay.add(day, "day").toDate());
      },
      disabled: disabled
    }, React__default.createElement(CalendarLabel, {
      active: active
    }, day + 1));
  }), offsetEnd > 0 ? Array.from(Array(offsetEnd).keys()).map(function (day) {
    return React__default.createElement(CalendarItem, {
      key: day,
      activeOpacity: 1
    }, React__default.createElement(CalendarLabel, null));
  }) : null), type === "datetime" ? React__default.createElement(TimePicker, null, React__default.createElement(CalendarMonth, {
    style: {
      marginRight: 10,
      minWidth: 100
    }
  }, "Uhrzeit:"), React__default.createElement(Comp$8, {
    value: parseInt(dayjs_min(currentDate).format("HH")),
    onChange: function onChange(value) {
      return _onChange(dayjs_min(currentDate).set("hour", value).toDate());
    },
    options: Array.from(Array(24).keys()).map(function (number$$1) {
      return {
        label: "" + (number$$1 < 10 ? "0" + number$$1 : number$$1),
        value: number$$1
      };
    }),
    style: {
      flex: 1,
      width: "auto",
      alignSelf: "stretch",
      backgroundColor: "background",
      borderRadius: 3,
      paddingHorizontal: 10,
      marginRight: 5
    },
    inputProps: {
      style: {
        textAlign: "center"
      }
    }
  }), React__default.createElement(Comp$8, {
    value: parseInt(dayjs_min(currentDate).format("mm")),
    onChange: function onChange(value) {
      return _onChange(dayjs_min(currentDate).set("minute", value).toDate());
    },
    options: Array.from(Array(60).keys()).map(function (number$$1) {
      return {
        label: "" + (number$$1 < 10 ? "0" + number$$1 : number$$1),
        value: number$$1
      };
    }),
    style: {
      flex: 1,
      width: "auto",
      alignSelf: "stretch",
      backgroundColor: "background",
      borderRadius: 3,
      paddingHorizontal: 10,
      marginLeft: 5
    }
  })) : null, React__default.createElement(TimePicker, null, React__default.createElement(CalendarMonth, {
    style: {
      marginRight: 10,
      minWidth: 100
    }
  }, "Jahr:"), React__default.createElement(Comp$8, {
    value: parseInt(dayjs_min(currentDate).format("YYYY")),
    onChange: function onChange(value) {
      return _onChange(dayjs_min(currentDate).set("year", value).toDate());
    },
    options: Array.from(Array(100).keys()).map(function (number$$1) {
      return {
        label: "" + (parseInt(dayjs_min(currentDate).format("YYYY")) - number$$1),
        value: parseInt(dayjs_min(currentDate).format("YYYY")) - number$$1
      };
    }),
    style: {
      flex: 1,
      width: "auto",
      alignSelf: "stretch",
      backgroundColor: "background",
      borderRadius: 3,
      paddingHorizontal: 10,
      marginRight: 5
    },
    inputProps: {
      style: {
        textAlign: "center"
      }
    }
  })));
};

var Comp$9 = function Comp(props) {
  var openDatePicker = function () {
    var _ref5 = asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee() {
      var _ref6, action, year, month, day, code, message;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return DatePickerAndroid.open({
                // Use `new Date()` for current date.
                // May 25 2020. Month 0 is January.
                date: date,
                minDate: min,
                maxDate: max
              });

            case 3:
              _ref6 = _context.sent;
              action = _ref6.action;
              year = _ref6.year;
              month = _ref6.month;
              day = _ref6.day;

              if (action !== DatePickerAndroid.dismissedAction) {
                // Selected year, month (0-11), day
                console.log({
                  action: action,
                  year: year,
                  month: month,
                  day: day
                });

                _onChange2(dayjs_min(year + "-" + (month + 1) + "-" + day).toDate());

                if (type === "datetime") {
                  openTimePicker();
                }
              }

              _context.next = 16;
              break;

            case 11:
              _context.prev = 11;
              _context.t0 = _context["catch"](0);
              code = _context.t0.code;
              message = _context.t0.message;
              console.warn("Cannot open date picker", message);

            case 16:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this, [[0, 11]]);
    }));

    return function openDatePicker() {
      return _ref5.apply(this, arguments);
    };
  }();

  var openTimePicker = function () {
    var _ref8 = asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee2() {
      var _ref9, action, hour, minute, code, message;

      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 3;
              return TimePickerAndroid.open({
                hour: 14,
                minute: 0,
                is24Hour: false // Will display '2 PM'

              });

            case 3:
              _ref9 = _context2.sent;
              action = _ref9.action;
              hour = _ref9.hour;
              minute = _ref9.minute;

              if (action !== TimePickerAndroid.dismissedAction) {
                dayjs_min().set("date", 1);

                _onChange2(dayjs_min(date).set("hour", hour).set("minute", minute).toDate()); // Selected hour (0-23), minute (0-59)

              }

              _context2.next = 15;
              break;

            case 10:
              _context2.prev = 10;
              _context2.t0 = _context2["catch"](0);
              code = _context2.t0.code;
              message = _context2.t0.message;
              console.warn("Cannot open time picker", message);

            case 15:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, this, [[0, 10]]);
    }));

    return function openTimePicker() {
      return _ref8.apply(this, arguments);
    };
  }();

  var value = props.value,
      style = props.style,
      type = props.type,
      _onChange2 = props.onChange,
      _props$textInputProps = props.textInputProps,
      textInputProps = _props$textInputProps === undefined ? {} : _props$textInputProps,
      _props$overlayProps = props.overlayProps,
      overlayProps = _props$overlayProps === undefined ? {} : _props$overlayProps,
      _props$doneText = props.doneText,
      doneText = _props$doneText === undefined ? "Done" : _props$doneText,
      min = props.min,
      max = props.max,
      rest = objectWithoutProperties(props, ["value", "style", "type", "onChange", "textInputProps", "overlayProps", "doneText", "min", "max"]);

  var _useState5 = useState(false),
      _useState6 = slicedToArray(_useState5, 2),
      show = _useState6[0],
      setShow = _useState6[1];

  var format = types[type].format;
  var date = value ? dayjs_min(value).toDate() : new Date();
  return React__default.createElement(Fragment, null, Platform.OS === "web" && isMobile.any() ? React__default.createElement(StyledDateInput, _extends({
    value: date ? dayjs_min(date).format(format) : undefined,
    type: type,
    onChange: function onChange(event) {
      _onChange2(event.target.value);
    },
    min: min ? dayjs_min(min).format(format) : undefined,
    max: max ? dayjs_min(max).format(format) : undefined,
    style: style
  }, textInputProps)) : React__default.createElement(Touchable$2, _extends({
    onPress: function onPress() {
      if (Platform.OS === "android") {
        if (type === "date" || type === "datetime") {
          openDatePicker();
        } else {
          openTimePicker();
        }
      } else {
        setShow(true);
      }
    },
    style: _extends({
      width: "100%"
    }, style)
  }, rest), React__default.createElement(Comp$7, _extends({
    value: date ? dayjs_min(date).format(format) : undefined,
    editable: isMobile.any() ? true : false,
    pointerEvents: "none"
  }, textInputProps))), React__default.createElement(ThemeComp, _extends({
    position: "center",
    height: "auto",
    visible: show,
    onClose: function onClose() {
      return setShow(false);
    },
    p: 20,
    style: {
      maxWidth: 500,
      width: "90%"
    }
  }, overlayProps), React__default.createElement(Box, {
    width: "100%"
  }, Platform.OS === "ios" ? React__default.createElement(DatePickerIOS, {
    date: date ? date : new Date(),
    mode: type,
    minimumDate: min,
    maximumDate: max,
    onDateChange: function onDateChange(date) {
      if (_onChange2) {
        _onChange2(date);
      }
    }
  }) : React__default.createElement(Calendar, {
    currentDate: date,
    onChange: function onChange(value) {
      _onChange2(value);
    },
    type: type,
    min: min,
    max: max
  }), React__default.createElement(Button$1, {
    onPress: function onPress() {
      return setShow(false);
    },
    style: {
      marginBottom: 10
    }
  }, doneText))));
};

Comp$9.propTypes = {
  style: PropTypes__default.object,
  onChange: PropTypes__default.func,
  textInputProps: PropTypes__default.object
};
var constant = {
  RESISTANCE_COEF: 0.6,
  // This value is closed to what browsers are using internally to
  // trigger a native scroll.
  UNCERTAINTY_THRESHOLD: 3 // px

};
var swipeDirections = {
  SWIPE_UP: "SWIPE_UP",
  SWIPE_DOWN: "SWIPE_DOWN",
  SWIPE_LEFT: "SWIPE_LEFT",
  SWIPE_RIGHT: "SWIPE_RIGHT"
};
var swipeConfig = {
  velocityThreshold: 0.3,
  directionalOffsetThreshold: 80,
  gestureIsClickThreshold: 5
};

function isValidSwipe(velocity, velocityThreshold, directionalOffset, directionalOffsetThreshold) {
  return Math.abs(velocity) > velocityThreshold && Math.abs(directionalOffset) < directionalOffsetThreshold;
}

var Pan$1 = function (_Component) {
  inherits(Pan, _Component);

  function Pan(props, context) {
    classCallCheck(this, Pan);

    var _this = possibleConstructorReturn(this, (Pan.__proto__ || Object.getPrototypeOf(Pan)).call(this, props, context));

    _this.onMove = function (evt, gestureState) {
      var swipeDirection = _this._getSwipeDirection(gestureState);

      _this.props.onSwipe && _this.props.onSwipe(swipeDirection, gestureState);
    };

    _this.onEnd = function (evt, gestureState) {
      var swipeDirection = _this._getSwipeDirection(gestureState);

      if (_this.props.onSwipeEnd) {
        _this.props.onSwipeEnd(swipeDirection, gestureState);
      }
    };

    _this.onStart = function (event, gestureState) {
      console.log("onStart");

      if (_this.props.onStart) {
        _this.props.onStart(event, gestureState);
      }
    };

    _this._handlePanResponderEnd = function (evt, gestureState) {
      var swipeDirection = _this._getSwipeDirection(gestureState);

      if (_this.props.onSwipeEnd) {
        _this.props.onSwipeEnd(swipeDirection, gestureState);
      }

      _this._triggerSwipeHandlers(swipeDirection, gestureState);
    };

    _this.swipeConfig = Object.assign(swipeConfig, props.config);
    return _this;
  }

  createClass(Pan, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(props) {
      this.swipeConfig = Object.assign(swipeConfig, props.config);
    }
  }, {
    key: "componentWillMount",
    value: function componentWillMount() {
      var responderEnd = this._handlePanResponderEnd.bind(this);

      var shouldSetResponder = this._handleShouldSetPanResponder.bind(this);

      this._panResponder = PanResponder.create({
        //stop JS beautify collapse
        onStartShouldSetPanResponder: function onStartShouldSetPanResponder() {
          return true;
        },
        onMoveShouldSetPanResponder: function onMoveShouldSetPanResponder(event, gestureState) {
          var dx = Math.abs(gestureState.dx);
          var dy = Math.abs(gestureState.dy);
          return dx > dy && dx > constant.UNCERTAINTY_THRESHOLD;
        },
        onPanResponderMove: this.onMove,
        onPanResponderRelease: this.onEnd,
        onPanResponderTerminate: this.onEnd,
        onPanResponderGrant: this.onStart
      });
    }
  }, {
    key: "_handleShouldSetPanResponder",
    value: function _handleShouldSetPanResponder(evt, gestureState) {
      return evt.nativeEvent.touches.length === 1 && !this._gestureIsClick(gestureState);
    }
  }, {
    key: "_gestureIsClick",
    value: function _gestureIsClick(gestureState) {
      return Math.abs(gestureState.dx) < swipeConfig.gestureIsClickThreshold && Math.abs(gestureState.dy) < swipeConfig.gestureIsClickThreshold;
    }
  }, {
    key: "_getSwipeDirection",
    value: function _getSwipeDirection(gestureState) {
      var SWIPE_LEFT = swipeDirections.SWIPE_LEFT,
          SWIPE_RIGHT = swipeDirections.SWIPE_RIGHT,
          SWIPE_UP = swipeDirections.SWIPE_UP,
          SWIPE_DOWN = swipeDirections.SWIPE_DOWN;
      var dx = gestureState.dx,
          dy = gestureState.dy;

      if (this._isValidHorizontalSwipe(gestureState)) {
        return dx > 0 ? SWIPE_RIGHT : SWIPE_LEFT;
      } else if (this._isValidVerticalSwipe(gestureState)) {
        return dy > 0 ? SWIPE_DOWN : SWIPE_UP;
      }

      return null;
    }
  }, {
    key: "_isValidHorizontalSwipe",
    value: function _isValidHorizontalSwipe(gestureState) {
      var vx = gestureState.vx,
          dy = gestureState.dy;
      var _swipeConfig = this.swipeConfig,
          velocityThreshold = _swipeConfig.velocityThreshold,
          directionalOffsetThreshold = _swipeConfig.directionalOffsetThreshold;
      return isValidSwipe(vx, velocityThreshold, dy, directionalOffsetThreshold);
    }
  }, {
    key: "_isValidVerticalSwipe",
    value: function _isValidVerticalSwipe(gestureState) {
      var vy = gestureState.vy,
          dx = gestureState.dx;
      var _swipeConfig2 = this.swipeConfig,
          velocityThreshold = _swipeConfig2.velocityThreshold,
          directionalOffsetThreshold = _swipeConfig2.directionalOffsetThreshold;
      return isValidSwipe(vy, velocityThreshold, dx, directionalOffsetThreshold);
    }
  }, {
    key: "render",
    value: function render() {
      var RenderComp = this.props.as ? this.props.as : View;
      return React__default.createElement(RenderComp, _extends({}, this.props, this._panResponder.panHandlers));
    }
  }]);
  return Pan;
}(Component);

var invlerp$1 = function invlerp(a, b, v) {
  return (v - a) / (b - a);
};

var lerp$1 = function lerp(start, end, t) {
  return start * (1 - t) + end * t;
};

var Slider = styled(Box)(function (_ref) {
  var showValue = _ref.showValue,
      showTicks = _ref.showTicks,
      vertical = _ref.vertical,
      sliderHeight = _ref.sliderHeight,
      handleSize = _ref.handleSize;
  return {
    padding: handleSize / 2,
    paddingTop: vertical ? 15 : showValue ? 45 : handleSize / 2,
    paddingBottom: vertical ? 15 : showTicks ? 40 : handleSize / 2,
    paddingRight: vertical ? showValue ? 45 : 30 : handleSize / 2,
    width: vertical ? "auto" : "100%",
    height: vertical ? sliderHeight : "auto%",
    flexDirection: vertical ? "row" : "column"
  };
});
var Track$2 = styled(Box)(function (_ref2) {
  var vertical = _ref2.vertical,
      trackHeight = _ref2.trackHeight;
  return {
    position: "relative",
    width: vertical ? trackHeight : "100%",
    height: vertical ? "100%" : trackHeight,
    borderRadius: 10
  };
});
var Progress$1 = animated(styled(Box)({
  position: "absolute",
  top: 0,
  left: 0,
  height: 10,
  borderRadius: 10
}));
var HandleBox = animated(styled.View(function (_ref3) {
  var vertical = _ref3.vertical,
      trackHeight = _ref3.trackHeight,
      handleSize = _ref3.handleSize;
  return {
    position: "absolute",
    top: vertical ? -handleSize : trackHeight / 2 + -(handleSize * 2) / 2,
    left: vertical ? trackHeight / 2 + -(handleSize * 2) / 2 : -handleSize,
    width: handleSize * 2,
    height: handleSize * 2,
    backgroundColor: "transparent",
    alignItems: "center",
    justifyContent: "center"
  };
}));
var Handle = styled(Box)(function (_ref4) {
  var vertical = _ref4.vertical,
      trackHeight = _ref4.trackHeight,
      handleSize = _ref4.handleSize,
      handleColor = _ref4.handleColor;
  return _extends({
    width: handleSize,
    height: handleSize,
    borderRadius: handleSize / 2,
    borderColor: "rgba(0,0,0,0.1)",
    backgroundColor: handleColor
  }, Platform.OS === "web" ? {
    cursor: "pointer"
  } : {});
});
var Ticks = styled.View(function (_ref5) {
  var vertical = _ref5.vertical,
      trackHeight = _ref5.trackHeight,
      handleSize = _ref5.handleSize,
      size = _ref5.size;
  return {
    width: vertical ? 20 : size + handleSize,
    height: vertical ? size + handleSize : 20,
    flexDirection: vertical ? "column" : "row",
    justifyContent: "space-between",
    position: "absolute",
    bottom: vertical ? -handleSize / 2 : -trackHeight - 20,
    right: vertical ? -trackHeight - 20 : -handleSize / 2,
    zIndex: 0,
    web: {
      userSelect: "none"
    }
  };
});
var Tick = styled.View(function (_ref6) {
  var vertical = _ref6.vertical,
      handleSize = _ref6.handleSize;
  return {
    alignItems: "center",
    justifyContent: "center",
    overflow: "visible",
    width: vertical ? "auto" : handleSize,
    height: vertical ? handleSize : "auto"
  };
});
var Value = animated(styled(Box)(function (_ref7) {
  var vertical = _ref7.vertical;
  return {
    position: "absolute",
    bottom: vertical ? "auto" : 23,
    top: vertical ? -10 : "auto",
    left: vertical ? 25 : -20,
    width: 40,
    height: 20,
    paddingVertical: 4,
    borderRadius: 25,
    borderColor: "rgba(0,0,0,0.1)",
    borderWidth: 1,
    alignItems: "center",
    justifyContent: "center",
    zIndex: 500
  };
}));

var Comp$a = function Comp(_ref8) {
  var _ref8$value = _ref8.value,
      value = _ref8$value === undefined ? 0 : _ref8$value,
      onChange = _ref8.onChange,
      _onSwipe = _ref8.onSwipe,
      _ref8$progressColor = _ref8.progressColor,
      progressColor = _ref8$progressColor === undefined ? "primary" : _ref8$progressColor,
      _ref8$trackColor = _ref8.trackColor,
      trackColor = _ref8$trackColor === undefined ? "background" : _ref8$trackColor,
      _ref8$trackHeight = _ref8.trackHeight,
      trackHeight = _ref8$trackHeight === undefined ? 10 : _ref8$trackHeight,
      _ref8$handleSize = _ref8.handleSize,
      handleSize = _ref8$handleSize === undefined ? 30 : _ref8$handleSize,
      _ref8$handleColor = _ref8.handleColor,
      handleColor = _ref8$handleColor === undefined ? "#FFF" : _ref8$handleColor,
      _ref8$min = _ref8.min,
      min = _ref8$min === undefined ? 0 : _ref8$min,
      _ref8$max = _ref8.max,
      max = _ref8$max === undefined ? 100 : _ref8$max,
      _ref8$steps = _ref8.steps,
      steps = _ref8$steps === undefined ? 1 : _ref8$steps,
      _ref8$ticks = _ref8.ticks,
      ticks = _ref8$ticks === undefined ? 10 : _ref8$ticks,
      _ref8$showValue = _ref8.showValue,
      showValue = _ref8$showValue === undefined ? false : _ref8$showValue,
      valueSuffix = _ref8.valueSuffix,
      _ref8$showTicks = _ref8.showTicks,
      showTicks = _ref8$showTicks === undefined ? true : _ref8$showTicks,
      _ref8$vertical = _ref8.vertical,
      vertical = _ref8$vertical === undefined ? false : _ref8$vertical,
      sliderHeight = _ref8.sliderHeight,
      _ref8$handleProps = _ref8.handleProps,
      handleProps = _ref8$handleProps === undefined ? {} : _ref8$handleProps,
      rest = objectWithoutProperties(_ref8, ["value", "onChange", "onSwipe", "progressColor", "trackColor", "trackHeight", "handleSize", "handleColor", "min", "max", "steps", "ticks", "showValue", "valueSuffix", "showTicks", "vertical", "sliderHeight", "handleProps"]);

  var _useState = useState(0),
      _useState2 = slicedToArray(_useState, 2),
      position = _useState2[0],
      setPosition = _useState2[1];

  var _useState3 = useState(0),
      _useState4 = slicedToArray(_useState3, 2),
      distance = _useState4[0],
      setDistance = _useState4[1];

  var _useState5 = useState(0),
      _useState6 = slicedToArray(_useState5, 2),
      size = _useState6[0],
      setSize = _useState6[1];

  var _useState7 = useState(false),
      _useState8 = slicedToArray(_useState7, 2),
      swipe = _useState8[0],
      setSwipe = _useState8[1];

  var _useState9 = useState(value),
      _useState10 = slicedToArray(_useState9, 2),
      val = _useState10[0],
      setValue = _useState10[1];

  var getTicks = function getTicks() {
    var stepArray = [];
    var minStep = min;
    var tickCount = max / ticks;

    if (tickCount * handleSize > size) {
      ticks = ticks * Math.ceil(tickCount * handleSize / size);
    }

    for (var i = 0; minStep <= max; i++) {
      stepArray.push(minStep);
      minStep = minStep + ticks;
    }

    return stepArray;
  };

  useEffect(function () {
    var progress = invlerp$1(min, max, value);
    var newPosition = lerp$1(0, size, progress);
    setValue(value || min);
    setPosition(newPosition);
    setDistance(0);
  }, [value, size]);

  var _useSpring = useSpring({
    to: {
      slidePosition: position + distance
    },
    immediate: swipe,
    config: {
      duration: 300
    }
  }),
      slidePosition = _useSpring.slidePosition;

  return React__default.createElement(Slider, _extends({
    showValue: showValue,
    showTicks: showTicks,
    vertical: vertical,
    sliderHeight: sliderHeight,
    handleSize: handleSize
  }, rest), React__default.createElement(Track$2, {
    type: trackColor,
    trackHeight: trackHeight,
    vertical: vertical,
    onLayout: function onLayout(_ref9) {
      var nativeEvent = _ref9.nativeEvent;
      setSize(vertical ? nativeEvent.layout.height : nativeEvent.layout.width);
    }
  }, React__default.createElement(Progress$1, {
    type: progressColor,
    style: {
      width: vertical ? "100%" : slidePosition,
      height: vertical ? slidePosition : "100%"
    }
  }), React__default.createElement(Pan$1, {
    as: HandleBox,
    onSwipe: function onSwipe(direction, gestureState) {
      var dx = gestureState.dx,
          dy = gestureState.dy;
      var dist = vertical ? dy : dx;
      var newPosition = position + dist;
      var newProgress = invlerp$1(0, size, newPosition);
      var newValue = Math.round(lerp$1(min, max, newProgress));

      if (newPosition > size) {
        dist = size - position;
        newValue = max;
      } else if (newPosition < 0) {
        dist = -position;
        newValue = min;
      }

      setValue(newValue);
      setDistance(dist);
      setSwipe(true);
      if (_onSwipe) _onSwipe(newValue);
    },
    onSwipeEnd: function onSwipeEnd(direction, gestureState) {
      var newPosition = position + distance;
      var newProgress = invlerp$1(0, size, newPosition);
      var newValue = Math.round(lerp$1(min, max, newProgress));

      if (newValue / steps % 1 != 0) {
        newValue = Math.round(newValue / steps) * steps;
        newProgress = invlerp$1(min, max, newValue);
        newPosition = lerp$1(0, size, newProgress);
      }

      setPosition(newPosition);
      setValue(newValue);
      setDistance(0);
      setSwipe(false);
      if (onChange) onChange(newValue);
    },
    vertical: vertical,
    trackHeight: trackHeight,
    handleSize: handleSize,
    style: {
      transform: vertical ? [{
        translateY: slidePosition
      }] : [{
        translateX: slidePosition
      }]
    }
  }, React__default.createElement(Handle, _extends({
    vertical: vertical,
    trackHeight: trackHeight,
    handleSize: handleSize,
    handleColor: handleColor,
    shadow: 5
  }, handleProps))), showValue ? React__default.createElement(Value, {
    type: "primary",
    vertical: vertical,
    style: {
      transform: vertical ? [{
        translateY: slidePosition
      }] : [{
        translateX: slidePosition
      }]
    },
    pointerEvents: "none"
  }, React__default.createElement(Text, {
    style: {
      color: "#FFF",
      fontSize: 10
    }
  }, val, valueSuffix ? valueSuffix : "")) : null, showTicks ? React__default.createElement(Ticks, {
    vertical: vertical,
    trackHeight: trackHeight,
    handleSize: handleSize,
    size: size,
    pointerEvents: "none"
  }, getTicks().map(function (step, index) {
    return React__default.createElement(Tick, {
      key: "step-" + index,
      vertical: vertical,
      handleSize: handleSize
    }, React__default.createElement(View, null, React__default.createElement(Text, {
      style: {
        fontSize: 9
      },
      numberOfLines: 1
    }, step)));
  })) : null));
};

var Comp$b = function Comp$$1(_ref) {
  var value = _ref.value,
      onChange = _ref.onChange,
      style = _ref.style,
      defaultColors = _ref.defaultColors,
      setFocus = _ref.setFocus,
      _ref$overlayProps = _ref.overlayProps,
      overlayProps = _ref$overlayProps === undefined ? {} : _ref$overlayProps,
      _ref$inputProps = _ref.inputProps,
      inputProps = _ref$inputProps === undefined ? {} : _ref$inputProps,
      rest = objectWithoutProperties(_ref, ["value", "onChange", "style", "defaultColors", "setFocus", "overlayProps", "inputProps"]);

  var _useState = useState(false),
      _useState2 = slicedToArray(_useState, 2),
      visible = _useState2[0],
      setVisible = _useState2[1];

  return React__default.createElement(Fragment, null, React__default.createElement(Box, _extends({
    w: "100%",
    relative: true
  }, rest), React__default.createElement(Comp$7, _extends({
    value: value,
    setFocus: setFocus,
    onChange: onChange
  }, inputProps)), React__default.createElement(Box, {
    type: value || "#FFF",
    as: TouchableOpacity,
    style: {
      position: "absolute",
      right: 0,
      top: "10%",
      minWidth: 60,
      height: "80%",
      borderRadius: 20,
      paddingHorizontal: 8,
      borderWidth: 1,
      borderColor: "rgba(0,0,0,0.1)",
      alignItems: "flex-end",
      justifyContent: "center"
    },
    onPress: function onPress() {
      return setVisible(true);
    }
  }, React__default.createElement(Comp, {
    name: "arrowDown",
    color: isDark(value) ? "#FFF" : "#000",
    size: 15
  }))), React__default.createElement(ThemeComp, _extends({
    visible: visible,
    onClose: function onClose() {
      return setVisible(false);
    },
    p: 20,
    style: {
      maxWidth: 500,
      width: "90%"
    }
  }, overlayProps), React__default.createElement(Box, {
    width: "100%"
  }, React__default.createElement(Grid$1, {
    min: 88
  }, defaultColors.map(function (color, index) {
    return React__default.createElement(Box, {
      key: index,
      as: TouchableOpacity,
      style: {
        width: "100%",
        height: 44,
        borderRadius: 5,
        backgroundColor: color,
        borderWidth: 1,
        borderColor: "rgba(0,0,0,0.1)"
      },
      onPress: function onPress() {
        onChange(color);
        setVisible(false);
      }
    });
  })), React__default.createElement(Button$1, {
    onPress: function onPress() {
      return setVisible(false);
    }
  }, "Fertig"))));
};

Comp$b.propTypes = {
  value: PropTypes__default.string,
  style: PropTypes__default.object,
  borderSize: PropTypes__default.number,
  onChange: PropTypes__default.func
};
Comp$b.defaultProps = {
  value: "#FFF",
  defaultColors: ["#f44336", "#e91e63", "#9c27b0", "#673ab7", "#3f51b5", "#2196f3", "#03a9f4", "#00bcd4", "#009688", "#4caf50", "#8bc34a", "#cddc39", "#ffeb3b", "#ffc107", "#ff9800", "#ff5722", "#795548", "#607d8b"]
};

var Comp$c = function Comp$$1(props) {
  var style = props.style,
      onChange = props.onChange,
      value = props.value,
      _props$step = props.step,
      step = _props$step === undefined ? 1 : _props$step,
      rest = objectWithoutProperties(props, ["style", "onChange", "value", "step"]);
  return React__default.createElement(Box, {
    relative: true,
    w: "100%",
    style: style
  }, React__default.createElement(Flex, {
    as: TouchableOpacity,
    absolute: true,
    t: "0px",
    r: "0px",
    type: "background",
    row: true,
    h: "80%",
    px: 5,
    style: {
      borderRadius: 20,
      zIndex: 10
    }
  }, React__default.createElement(Flex, {
    as: TouchableOpacity,
    onPress: function onPress() {
      if (onChange) onChange(parseInt(value) - step);
    },
    w: 38,
    h: "100%",
    align: "center",
    content: "center",
    style: {
      borderRightWidth: 2,
      borderRightColor: "#FFF"
    }
  }, React__default.createElement(Comp, {
    size: 15,
    name: "minus"
  })), React__default.createElement(Flex, {
    as: TouchableOpacity,
    onPress: function onPress() {
      if (onChange) onChange(parseInt(value) + step);
    },
    w: 38,
    h: "100%",
    align: "center",
    content: "center"
  }, React__default.createElement(Comp, {
    size: 15,
    name: "plus"
  }))), React__default.createElement(Comp$7, _extends({
    keyboardType: "numeric",
    value: value,
    onChange: onChange
  }, rest)));
};

var Checkbox = styled.TouchableOpacity(function (_ref) {
  var circleSize = _ref.circleSize,
      borderSize = _ref.borderSize;
  return {
    width: circleSize,
    height: circleSize,
    borderWidth: borderSize,
    borderColor: "primary",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: circleSize / 2
  };
});
var Circle$1 = styled.View(function (_ref2) {
  var circleSize = _ref2.circleSize,
      borderSize = _ref2.borderSize;
  return {
    width: circleSize - borderSize * 4,
    height: circleSize - borderSize * 4,
    backgroundColor: "primary",
    borderRadius: circleSize / 2
  };
});
var AnimatedCircle = animated(Circle$1);

var Comp$d = function Comp(_ref3) {
  var _ref3$type = _ref3.type,
      type = _ref3$type === undefined ? "primary" : _ref3$type,
      value = _ref3.value,
      onChange = _ref3.onChange,
      _ref3$circleSize = _ref3.circleSize,
      circleSize = _ref3$circleSize === undefined ? 30 : _ref3$circleSize,
      style = _ref3.style,
      _ref3$borderSize = _ref3.borderSize,
      borderSize = _ref3$borderSize === undefined ? 2 : _ref3$borderSize,
      rest = objectWithoutProperties(_ref3, ["type", "value", "onChange", "circleSize", "style", "borderSize"]);

  var _useState = useState(value || false),
      _useState2 = slicedToArray(_useState, 2),
      active = _useState2[0],
      setActive = _useState2[1];

  var _useSpring = useSpring({
    to: {
      opacity: active ? 1 : 0,
      scale: active ? 1 : 0
    }
  }),
      scale = _useSpring.scale,
      opacity = _useSpring.opacity;

  useEffect(function () {
    setActive(value);
  }, [value]);
  return React__default.createElement(Checkbox, _extends({
    type: type,
    style: style,
    activeOpacity: 0.8,
    circleSize: circleSize,
    borderSize: borderSize,
    onPress: function onPress() {
      var newValue = !active;
      setActive(newValue);
      setTimeout(function () {
        if (onChange) {
          onChange(newValue);
        }
      }, 299);
    }
  }, rest), React__default.createElement(AnimatedCircle, {
    circleSize: circleSize,
    borderSize: borderSize,
    style: {
      opacity: opacity,
      transform: [{
        scale: scale
      }]
    }
  }));
};

Comp$d.propTypes = {
  value: PropTypes__default.bool,
  style: PropTypes__default.object,
  circleSize: PropTypes__default.number,
  borderSize: PropTypes__default.number,
  onChange: PropTypes__default.func
};
var Wrap$1 = styled.View({
  width: "100%",
  position: "relative"
});
var Select = styled.TouchableOpacity(function (_ref) {
  var last = _ref.last;
  return {
    width: "100%",
    position: "relative",
    flexDirection: "row",
    alignItems: "center",
    height: 50,
    borderBottomWidth: last ? 0 : 1,
    borderBottomColor: "background"
  };
});
var Label$3 = styled.Text({
  fontSize: "p",
  marginLeft: 15
});

var Comp$e = function Comp(_ref2) {
  var onChange = _ref2.onChange,
      value = _ref2.value,
      options = _ref2.options,
      rest = objectWithoutProperties(_ref2, ["onChange", "value", "options"]);
  var selectValue = value || [];
  return React__default.createElement(Wrap$1, rest, options.map(function (option, index) {
    var value = option.value ? option.value : option;
    return React__default.createElement(Select, {
      onPress: function onPress() {
        var newValue = selectValue;
        var found = newValue.filter(function (id) {
          return id === value;
        });

        if (found.length > 0) {
          newValue = newValue.filter(function (id) {
            return id !== value;
          });
        } else {
          newValue.push(value);
        }

        console.log({
          newValue: newValue
        });
        onChange(newValue);
      },
      key: "multiselect-" + index,
      activeOpacity: 0.8,
      last: index === options.length - 1
    }, React__default.createElement(Comp$d, {
      value: selectValue.filter(function (id) {
        return id === value;
      }).length > 0
    }), React__default.createElement(Label$3, null, option.label ? option.label : option));
  }));
};

var TagInput = styled.View({
  width: "100%",
  position: "relative",
  flexDirection: "row",
  flexWrap: "wrap",
  paddingVertical: 5
});
var Pill = styled.TouchableOpacity({
  paddingVertical: 10,
  paddingHorizontal: 18,
  backgroundColor: "primary",
  flexDirection: "row",
  alignItems: "center",
  borderRadius: 25,
  marginRight: 5,
  marginBottom: 5
});
var PillLabel = styled.Text({
  fontSize: "label",
  color: "#FFF",
  marginRight: 5
});

var Comp$f = function Comp$$1(_ref) {
  var _ref$value = _ref.value,
      value = _ref$value === undefined ? [] : _ref$value,
      onChange = _ref.onChange,
      _ref$textInputProps = _ref.textInputProps,
      textInputProps = _ref$textInputProps === undefined ? {} : _ref$textInputProps,
      _ref$placeholder = _ref.placeholder,
      placeholder = _ref$placeholder === undefined ? "Add Tag..." : _ref$placeholder,
      _ref$submitOnString = _ref.submitOnString,
      submitOnString = _ref$submitOnString === undefined ? [" ", ","] : _ref$submitOnString,
      setFocus = _ref.setFocus,
      rest = objectWithoutProperties(_ref, ["value", "onChange", "textInputProps", "placeholder", "submitOnString", "setFocus"]);

  var _useState = useState(""),
      _useState2 = slicedToArray(_useState, 2),
      text = _useState2[0],
      setText = _useState2[1];

  var submit = function submit() {
    if (text.length > 0) {
      var newArray = value;
      newArray.push(text);
      onChange(newArray);
      setText("");
    }
  };

  var revert = function revert(index) {
    if (index === undefined) setText(value[value.length - 1]);
    var newArray = value;

    if (index !== undefined) {
      newArray.splice(index, 1);
    } else {
      newArray.splice(-1, 1);
    }

    onChange(newArray);
  };

  return React__default.createElement(TagInput, rest, value.map(function (string$$1, index) {
    return React__default.createElement(Pill, {
      key: "pill-" + index,
      activeOpacity: 0.8,
      onPress: function onPress() {
        return revert(index);
      }
    }, React__default.createElement(PillLabel, null, string$$1), React__default.createElement(Comp, {
      name: "x",
      color: "#FFF",
      size: 15,
      lineWidth: 1
    }));
  }), React__default.createElement(Comp$7, _extends({
    value: text,
    onChange: function onChange(value) {
      console.log({
        value: value
      });

      if (value.length > 1 && submitOnString.indexOf(value.substr(value.length - 1)) > -1) {
        submit();
      } else {
        setText(value);
      }
    },
    placeholder: placeholder,
    onSubmitEditing: function onSubmitEditing() {
      return submit();
    }
  }, textInputProps, {
    style: {
      width: "auto",
      flex: 1
    },
    setFocus: setFocus
  })));
};

Comp$f.propTypes = {
  value: PropTypes__default.array,
  style: PropTypes__default.object,
  onChange: PropTypes__default.func
};
var types$1 = {
  text: Comp$7,
  textarea: Comp$7,
  select: Comp$8,
  "switch": Comp$6,
  date: Comp$9,
  datetime: Comp$9,
  time: Comp$9,
  range: Comp$a,
  color: Comp$b,
  number: Comp$c,
  checkbox: Comp$d,
  multiselect: Comp$e,
  tags: Comp$f
};
var Label$4 = styled.Text(function (_ref) {
  var color$$1 = _ref.color,
      size = _ref.size;
  return {
    color: color$$1,
    fontSize: size || "label"
  };
});
var Desc = styled.Text({});
var InputWrapper = styled(Box)(function (_ref2) {
  var theme = _ref2.theme;
  return {
    flexDirection: "column",
    justifyContent: "space-between",
    alignItems: "flex-start",
    backgroundColor: "surface",
    width: "100%",
    height: "auto",
    minHeight: 55,
    padding: 15,
    borderRadius: theme.globals.roundness,
    paddingBottom: 4
  };
});
var BorderWrap = styled.View(function (_ref3) {
  var size = _ref3.size,
      borderBlurColor = _ref3.borderBlurColor;
  return {
    position: "absolute",
    bottom: 0,
    left: 0,
    height: 2,
    width: size,
    backgroundColor: borderBlurColor,
    zIndex: 100,
    overflow: "hidden"
  };
});
var Border = animated(styled.View(function (_ref4) {
  var borderFocusColor = _ref4.borderFocusColor;
  return {
    height: "100%",
    width: "100%",
    backgroundColor: borderFocusColor
  };
}));
var typesProps = {
  "switch": {
    wrapperProps: {
      style: {
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "space-between",
        paddingBottom: 15
      }
    },
    labelProps: {
      size: "p"
    }
  },
  checkbox: {
    wrapperProps: {
      style: {
        flexDirection: "row-reverse",
        alignItems: "center",
        justifyContent: "flex-end",
        paddingBottom: 15
      }
    },
    labelProps: {
      size: "p",
      style: {
        marginLeft: 10
      }
    }
  },
  date: {
    wrapperProps: {
      readOnly: true
    }
  }
};

var Comp$g = function Comp(_ref5) {
  var children = _ref5.children,
      label = _ref5.label,
      desc = _ref5.desc,
      error = _ref5.error,
      style = _ref5.style,
      direction = _ref5.direction,
      type = _ref5.type,
      onChange = _ref5.onChange,
      value = _ref5.value,
      _ref5$labelColor = _ref5.labelColor,
      labelColor = _ref5$labelColor === undefined ? "text" : _ref5$labelColor,
      _ref5$borderProps = _ref5.borderProps,
      borderProps = _ref5$borderProps === undefined ? {} : _ref5$borderProps,
      _ref5$borderBlurColor = _ref5.borderBlurColor,
      borderBlurColor = _ref5$borderBlurColor === undefined ? "transparent" : _ref5$borderBlurColor,
      _ref5$borderFocusColo = _ref5.borderFocusColor,
      borderFocusColor = _ref5$borderFocusColo === undefined ? "primary" : _ref5$borderFocusColo,
      _ref5$required = _ref5.required,
      required = _ref5$required === undefined ? false : _ref5$required,
      theme = _ref5.theme,
      rest = objectWithoutProperties(_ref5, ["children", "label", "desc", "error", "style", "direction", "type", "onChange", "value", "labelColor", "borderProps", "borderBlurColor", "borderFocusColor", "required", "theme"]);

  var _useState = useState(false),
      _useState2 = slicedToArray(_useState, 2),
      focused = _useState2[0],
      setFocus = _useState2[1];

  var _useState3 = useState(Dimensions.get("window").width),
      _useState4 = slicedToArray(_useState3, 2),
      width = _useState4[0],
      setWidth = _useState4[1];

  var InputComp = types$1[type] || undefined;
  var TypeProps = typesProps[type] || {};
  var transitions = useTransition(focused, null, {
    from: {
      left: -width
    },
    enter: {
      left: 0
    },
    leave: {
      left: width
    }
  });
  return React__default.createElement(InputWrapper, _extends({
    as: ["switch", "checkbox"].indexOf(type) > -1 ? TouchableOpacity : undefined,
    onPress: function onPress() {
      if (onChange) {
        onChange(!value);
      }
    },
    onLayout: function onLayout(event) {
      var width = event.nativeEvent.layout.width;
      setWidth(width);
    },
    activeOpacity: 0.8,
    style: _extends({}, style, TypeProps.wrapperProps ? TypeProps.wrapperProps.style : {})
  }, rest), React__default.createElement(Flex, null, label ? React__default.createElement(Label$4, _extends({
    color: error ? "error" : focused ? "primary" : labelColor
  }, TypeProps.labelProps), label, required ? "*" : null) : null, desc ? React__default.createElement(Desc, {
    style: {
      color: color(theme.colors.text).alpha(0.5),
      fontSize: 10
    }
  }, desc) : null), InputComp ? React__default.createElement(InputComp, _extends({
    onChange: onChange,
    value: value,
    setFocus: setFocus,
    type: type,
    label: label,
    required: required
  }, TypeProps, rest)) : null, children ? React__default.Children.only(React__default.cloneElement(children, _extends({
    setFocus: setFocus,
    onChange: onChange,
    value: value,
    type: type,
    label: label,
    required: required
  }, children.props, rest))) : null, React__default.createElement(BorderWrap, {
    size: width,
    borderBlurColor: borderBlurColor
  }, transitions.map(function (_ref6) {
    var item = _ref6.item,
        key = _ref6.key,
        props = _ref6.props;
    return item ? React__default.createElement(Border, _extends({
      key: key,
      borderFocusColor: borderFocusColor
    }, borderProps, {
      style: _extends({
        transform: [{
          translateX: props.left
        }]
      }, borderProps.style)
    })) : null;
  })));
};

var ThemeComp$1 = withThemeProps(Comp$g, "Input");
ThemeComp$1.propTypes = {
  type: PropTypes__default.oneOf(["text", "textarea", "range", "date", "time", "datetime", "checkbox", "number", "select", "multiselect", "switch", "tags"])
};
ThemeComp$1["Text"] = Comp$7;
ThemeComp$1["Slider"] = Comp$a;
ThemeComp$1["Tags"] = Comp$f;
ThemeComp$1["Switch"] = Comp$6;
ThemeComp$1["Select"] = Comp$8;
ThemeComp$1["Number"] = Comp$c;
ThemeComp$1["Checkbox"] = Comp$d;
ThemeComp$1["DatePicker"] = Comp$9;
ThemeComp$1["Color"] = Comp$b;
ThemeComp$1["MultiSelect"] = Comp$e;
var FormWrap = styled(Box)({
  width: "100%"
});

var getDefaultValue = function getDefaultValue(_ref) {
  var props = _ref.child.props;
  var value = undefined;

  if (props.type === "text") {
    value = "";
  }

  if (props.type === "number" || props.type === "range") {
    value = 0;
  }

  if (props.type === "switch" || props.type === "checkbox") {
    value = false;
  }

  if (props.defaultValue) value = props.defaultValue;
  return value;
};

var getDefaultState = function getDefaultState(children, state) {
  Children.map(children, function (child, i) {
    if (child.key) {
      state[child.key] = getDefaultValue({
        child: child
      });
    }

    if (child.props.children) getDefaultState(child.props.children, state);
  });
  return state;
};

var renderChildren = function renderChildren(children, doc, setDoc) {
  return Children.map(children, function (child, index) {
    return React__default.cloneElement(child, {
      key: child.key || "child-" + index,
      value: doc[child.key],
      onChange: function onChange(value) {
        if (child.key) {
          console.log({
            value: value,
            key: child.key
          });
          setDoc(_extends({}, doc, defineProperty({}, child.key, value)));
        }
      },
      children: child.props.children ? renderChildren(child.props.children, doc, setDoc) : undefined
    });
  });
};

function Form(_ref2) {
  var children = _ref2.children,
      schema = _ref2.schema,
      onSubmit = _ref2.onSubmit,
      _ref2$button = _ref2.button,
      button = _ref2$button === undefined ? true : _ref2$button,
      _ref2$buttonLabel = _ref2.buttonLabel,
      buttonLabel = _ref2$buttonLabel === undefined ? "Submit" : _ref2$buttonLabel,
      _ref2$buttonProps = _ref2.buttonProps,
      buttonProps = _ref2$buttonProps === undefined ? {} : _ref2$buttonProps,
      rest = objectWithoutProperties(_ref2, ["children", "schema", "onSubmit", "button", "buttonLabel", "buttonProps"]);

  var _useState = useState(function () {
    return getDefaultState(children, {});
  }),
      _useState2 = slicedToArray(_useState, 2),
      doc = _useState2[0],
      setDoc = _useState2[1];

  return React__default.createElement(FormWrap, rest, renderChildren(children, doc, setDoc), button ? React__default.createElement(Button$1, _extends({
    onPress: function onPress() {
      return onSubmit ? onSubmit(doc) : null;
    }
  }, buttonProps), buttonLabel) : null);
}

export { isDark, styled, useTheme, color, ThemeProvider$1 as ThemeProvider, Flex, Box, Image$1 as Image, Text$2 as Text, Comp$2 as ActionSheet, Animate$1 as Animate, Button$1 as Button, ButtonGroup, Avatar, Progress, Grid$1 as Grid, Comp as Icon, index as Page, Comp$4 as Tabs, Comp$3 as Swiper, Comp$5 as Chart, ThemeComp as Overlay, Headline, Dropdown, ThemeComp$1 as Input, Form, Hoverable, Button as Ripple, Alert };